import React, { useState, useEffect, useRef, useCallback } from "react";
import Menubar from "../Menubar/Menubar";
import { Outlet } from "react-router-dom";
import "../Dashboard/Dashboard.css";
import { Tooltip } from "antd";
import {
  MdKeyboardDoubleArrowLeft,
  MdKeyboardDoubleArrowRight,
} from "react-icons/md";
import { IoLogoFacebook, IoLogoWhatsapp } from "react-icons/io";
import { RiInstagramFill, RiWhatsappFill } from "react-icons/ri";
import { TbDeviceAnalytics, TbRefresh } from "react-icons/tb";
import { AiFillInstagram } from "react-icons/ai";
import { FaFacebookSquare, FaPhone } from "react-icons/fa";
import { FaCalendarAlt } from "react-icons/fa";
import { IoMail } from "react-icons/io5";
import { IoIosTime } from "react-icons/io";
import { RxOpenInNewWindow } from "react-icons/rx";
import { MdFileDownloadDone } from "react-icons/md";
import { MdDelete } from "react-icons/md";
import { IoNotificationsOutline } from "react-icons/io5";

const API = `${process.env.REACT_APP_BACKEND_URL || "https://dash.zorbastays.com"}/web-backend`;

const STATUSES = [
  "New Enquiry",
  "Call Not Picked",
  "Contacted",
  "Qualified",
  "Plan & Quote Sent",
  "In Pipeline",
  "Negotiating",
  "Awaiting Payment",
  "Lost & Closed",
];
const STATUS_COLORS = {
  "New Enquiry": "#6366f1",
  "Call Not Picked": "#f59e0b",
  Contacted: "#3b82f6",
  Qualified: "#8b5cf6",
  "Plan & Quote Sent": "#06b6d4",
  "In Pipeline": "#10b981",
  Negotiating: "#f97316",
  "Awaiting Payment": "#ec4899",
  Booked: "#22c55e",
  "Lost & Closed": "#ef4444",
};
const PIPELINE_STAGES = [
  {
    name: "Incoming",
    color: "bg-emerald-100 text-emerald-600",
    status: "Incoming Leads",
  },
  {
    name: "Processed",
    color: "bg-yellow-100 text-yellow-600",
    status: "All Processed Leads",
  },
  {
    name: "New Enquiry",
    color: "bg-purple-100 text-purple-500",
    status: "New Enquiry",
  },
  {
    name: "Call Not Picked",
    color: "bg-sky-100 text-sky-600",
    status: "Call Not Picked",
  },
  {
    name: "Contacted",
    color: "bg-pink-100 text-pink-600",
    status: "Contacted",
  },
  {
    name: "Qualified",
    color: "bg-teal-100 text-teal-700",
    status: "Qualified",
  },
  {
    name: "Plan/Quote Sent",
    color: "bg-red-100 text-red-500",
    status: "Plan & Quote Sent",
  },
  {
    name: "In Pipeline",
    color: "bg-blue-100 text-blue-600",
    status: "In Pipeline",
  },
  {
    name: "Negotiating",
    color: "bg-lime-100 text-lime-700",
    status: "Negotiating",
  },
  {
    name: "Awaiting Payment",
    color: "bg-green-100 text-green-700",
    status: "Awaiting Payment",
  },
  {
    name: "Lost & Closed",
    color: "bg-slate-200 text-slate-700",
    status: "Lost & Closed",
  },
];
const WEBSITE_STATUSES = [
  "New Lead",
  "Contacted",
  "Qualified",
  "Plan & Quote Sent",
  "In Pipeline",
  "Negotiating",
  "Awaiting Payment",
  "Lost & Closed",
];
const WEBSITE_STATUS_COLORS = {
  "New Lead": "#6366f1",
  Contacted: "#3b82f6",
  Qualified: "#8b5cf6",
  "Plan & Quote Sent": "#06b6d4",
  "In Pipeline": "#10b981",
  Negotiating: "#f97316",
  "Awaiting Payment": "#ec4899",
  "Lost & Closed": "#ef4444",
};
const WEBSITE_PIPELINE_STAGES = [
  { name: "All", color: "bg-orange-100 text-orange-600", status: "All Leads" },
  {
    name: "Incoming",
    color: "bg-emerald-100 text-emerald-600",
    status: "Incoming Leads",
  },
  {
    name: "Processed",
    color: "bg-yellow-100 text-yellow-600",
    status: "All Processed Leads",
  },
  {
    name: "New Lead",
    color: "bg-purple-100 text-purple-500",
    status: "New Lead",
  },
  {
    name: "Contacted",
    color: "bg-pink-100 text-pink-600",
    status: "Contacted",
  },
  {
    name: "Qualified",
    color: "bg-teal-100 text-teal-700",
    status: "Qualified",
  },
  {
    name: "Plan/Quote Sent",
    color: "bg-red-100 text-red-500",
    status: "Plan & Quote Sent",
  },
  {
    name: "In Pipeline",
    color: "bg-blue-100 text-blue-600",
    status: "In Pipeline",
  },
  {
    name: "Negotiating",
    color: "bg-lime-100 text-lime-700",
    status: "Negotiating",
  },
  {
    name: "Awaiting Payment",
    color: "bg-green-100 text-green-700",
    status: "Awaiting Payment",
  },
  {
    name: "Lost & Closed",
    color: "bg-slate-200 text-slate-700",
    status: "Lost & Closed",
  },
];
const CHANNELS = {
  "Instagram DM": {
    color: "#e1306c",
    bg: "#fce4ec",
    icon: <AiFillInstagram />,
  },
  "Facebook Lead": {
    color: "#1877f2",
    bg: "#e3f2fd",
    icon: <FaFacebookSquare />,
  },
  WhatsApp: { color: "#25d366", bg: "#e8f5e9", icon: <RiWhatsappFill /> },
};
const TAG_COLORS = { Hot: "#ef4444", Warm: "#f97316", Cold: "#64748b" };
const TEAM = ["Unassigned", "Parth", "Altaf", "Riya", "Dev", "Sneha"];

function timeAgo(dateStr) {
  if (!dateStr) return "—";
  const diff = (Date.now() - new Date(dateStr)) / 1000;
  if (diff < 60) return "Just now";
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  return `${Math.floor(diff / 86400)}d ago`;
}
function channelToSource(channel) {
  return (
    {
      "Facebook Lead": "Facebook",
      "Instagram DM": "Instagram",
      WhatsApp: "WhatsApp",
    }[channel] ||
    channel ||
    "Lead"
  );
}

// ─── Toast ────────────────────────────────────────────────────────────────────
function Toast({ msg, onDone }) {
  useEffect(() => {
    const t = setTimeout(onDone, 3000);
    return () => clearTimeout(t);
  }, [onDone]);
  return (
    <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-[999] bg-gray-800 text-white text-sm font-medium px-5 py-3 rounded-xl shadow-2xl animate-bounce-once">
      {msg}
    </div>
  );
}

// ─── Confirmation Modal ────────────────────────────────────────────────────────
function ConfirmProcessModal({ onConfirm, onCancel }) {
  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl shadow-xl p-6 max-w-sm w-full mx-4">
        <h3 className="text-base font-bold text-gray-800 mb-2">
          Process Lead?
        </h3>
        <p className="text-sm text-gray-500 mb-5">
          This will save the lead to the database. Do you want to continue?
        </p>
        <div className="flex gap-3 justify-end">
          <button
            onClick={onCancel}
            className="px-4 py-1.5 rounded-md text-sm font-semibold text-gray-600 bg-gray-100 hover:bg-gray-200 transition-all"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="px-4 py-1.5 rounded-md text-sm font-semibold text-white bg-[#797d72] hover:bg-[#5a5e55] transition-all"
          >
            Yes, Process
          </button>
        </div>
      </div>
    </div>
  );
}
function DeleteLeadModal({ leadName, onConfirm, onCancel, deleting }) {
  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl shadow-xl p-6 max-w-sm w-full mx-4">
        <h3 className="text-base font-bold text-gray-800 mb-2">Delete Lead?</h3>
        <p className="text-sm text-gray-500 mb-1">
          Are you sure you want to delete{" "}
          <span className="font-semibold text-gray-700">{leadName}</span>?
        </p>
        <p className="text-xs text-red-500 mb-5">
          This action cannot be undone.
        </p>
        <div className="flex gap-3 justify-end">
          <button
            onClick={onCancel}
            disabled={deleting}
            className="px-4 py-1.5 rounded-md text-sm font-semibold text-gray-600 bg-gray-100 hover:bg-gray-200 transition-all"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            disabled={deleting}
            className="px-4 py-1.5 rounded-md text-sm font-semibold text-white bg-red-500 hover:bg-red-600 transition-all"
          >
            {deleting ? "Deleting…" : "Yes, Delete"}
          </button>
        </div>
      </div>
    </div>
  );
}
// ─── Process Meta Lead Button ──────────────────────────────────────────────────
function ProcessMetaLeadButton({ lead, onProcessed }) {
  const [processing, setProcessing] = useState(false);
  const [done, setDone] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const handleProcess = async () => {
    setProcessing(true);
    try {
      const meta_lead_id = lead.id.startsWith("meta_")
        ? lead.id.replace("meta_", "")
        : lead.id;
      const res = await fetch(`${API}/leads/process-meta`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          meta_lead_id,
          name: lead.name,
          phone: lead.phone || "",
          email: lead.email || "",
          channel: lead.channel || "Facebook Lead",
          enquiry: lead.enquiry || "",
          form_id: lead.form_id || "",
          page_id: lead.page_id || "",
          field_data: lead.field_data || [],
          raw_payload: lead,
        }),
      });
      if (!res.ok) throw new Error("Failed " + res.status);
      const { lead: savedLead, already_existed } = await res.json();
      setDone(true);
      onProcessed(savedLead, already_existed);
    } catch (e) {
      alert("Error processing lead: " + e.message);
    } finally {
      setProcessing(false);
    }
  };

  if (done)
    return (
      <span className="text-xs text-green-500 font-bold">✓ Saved to DB</span>
    );

  return (
    <>
      {showConfirm && (
        <ConfirmProcessModal
          onConfirm={() => {
            setShowConfirm(false);
            handleProcess();
          }}
          onCancel={() => setShowConfirm(false)}
        />
      )}
      <button
        onClick={() => setShowConfirm(true)}
        disabled={processing}
        className={`px-3 py-1.5 rounded-md text-white text-xs font-bold whitespace-nowrap transition-all ${
          processing
            ? "bg-gray-400 cursor-not-allowed"
            : "bg-[#aeb3a4] hover:bg-[#797d72] cursor-pointer"
        }`}
      >
        {processing ? "Saving…" : "Process Lead"}
      </button>
    </>
  );
}

// ─── Process Website Lead Button ──────────────────────────────────────────────
function ProcessWebsiteLeadButton({ lead, onProcessed }) {
  const [processing, setProcessing] = useState(false);
  const [done, setDone] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const handleProcess = async () => {
    setProcessing(true);
    try {
      const res = await fetch(`${API}/website-leads/process`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ leadId: lead.leadId }),
      });
      if (!res.ok) throw new Error("Failed " + res.status);
      const { lead: savedLead, already_existed } = await res.json();
      setDone(true);
      onProcessed(savedLead, already_existed);
    } catch (e) {
      alert("Error processing lead: " + e.message);
    } finally {
      setProcessing(false);
    }
  };

  if (done)
    return (
      <span className="text-xs text-green-500 font-bold">✓ Saved to DB</span>
    );

  return (
    <>
      {showConfirm && (
        <ConfirmProcessModal
          onConfirm={() => {
            setShowConfirm(false);
            handleProcess();
          }}
          onCancel={() => setShowConfirm(false)}
        />
      )}
      <button
        onClick={() => setShowConfirm(true)}
        disabled={processing}
        className={`px-3 py-1.5 rounded-md text-white text-xs font-bold whitespace-nowrap transition-all ${
          processing
            ? "bg-gray-400 cursor-not-allowed"
            : "bg-[#aeb3a4] hover:bg-[#797d72] cursor-pointer"
        }`}
      >
        {processing ? "Saving…" : "Process Lead"}
      </button>
    </>
  );
}

// ─── Follow Up Modal ──────────────────────────────────────────────────────────
function FollowUpModal({ lead, onClose }) {
  const [type, setType] = useState("whatsapp");
  const [msg, setMsg] = useState("");
  const [sent, setSent] = useState(false);
  const send = () => {
    setSent(true);
    setTimeout(onClose, 1600);
  };
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-white rounded-2xl p-7 w-[420px] shadow-2xl">
        {sent ? (
          <div className="text-center py-6">
            <div className="text-5xl"></div>
            <div className="text-base font-bold mt-3">Follow-up Sent!</div>
          </div>
        ) : (
          <>
            <div className="font-bold text-base mb-1">Send Follow-Up</div>
            <div className="text-xs text-gray-400 mb-4">
              To: <b>{lead.name || lead.customerName}</b>
              {lead.phone ? ` · ${lead.phone}` : ""}
            </div>
            <div className="flex gap-2 mb-4">
              {["whatsapp", "email"].map((t) => (
                <button
                  key={t}
                  onClick={() => setType(t)}
                  className={`flex-1 py-2 rounded-lg font-semibold text-sm cursor-pointer border-2 transition-all ${type === t ? "border-indigo-500 bg-indigo-50 text-indigo-600" : "border-gray-200 bg-white text-gray-500"}`}
                >
                  {t === "whatsapp" ? " WhatsApp" : " Email"}
                </button>
              ))}
            </div>
            <textarea
              value={msg}
              onChange={(e) => setMsg(e.target.value)}
              rows={4}
              placeholder={`Write your ${type} message…`}
              className="w-full p-3 rounded-lg border border-gray-200 text-sm resize-y outline-none focus:border-indigo-400 font-[inherit]"
            />
            <div className="flex gap-3 mt-4">
              <button
                onClick={onClose}
                className="flex-1 py-2.5 rounded-lg border border-gray-200 bg-white text-gray-500 font-semibold cursor-pointer"
              >
                Cancel
              </button>
              <button
                onClick={send}
                disabled={!msg}
                className={`flex-1 py-2.5 rounded-lg text-white font-bold cursor-pointer ${msg ? "bg-[#25d366] hover:bg-green-600" : "bg-gray-300 cursor-not-allowed"}`}
              >
                Send
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

// ─── Create Lead Modal ────────────────────────────────────────────────────────
function CreateLeadModal({ onClose, onCreated }) {
  const [form, setForm] = useState({
    name: "",
    phone: "",
    email: "",
    channel: "Instagram DM",
    enquiry: "",
    tag: "Warm",
    assignee: "Unassigned",
  });
  const [saving, setSaving] = useState(false);
  const [err, setErr] = useState("");
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));
  const handleSubmit = async () => {
    if (!form.name.trim()) {
      setErr("Name is required");
      return;
    }
    setSaving(true);
    setErr("");
    try {
      const res = await fetch(`${API}/leads`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });
      if (!res.ok) throw new Error("Server error " + res.status);
      onCreated(await res.json());
      onClose();
    } catch (e) {
      setErr(e.message);
    } finally {
      setSaving(false);
    }
  };
  const inp =
    "w-full p-2.5 rounded-lg border border-gray-200 text-sm outline-none focus:border-indigo-400 mb-2.5 font-[inherit] box-border";
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-white rounded-2xl p-7 w-[460px] shadow-2xl max-h-[90vh] overflow-y-auto">
        <div className="font-bold text-base mb-4">➕ Add New Lead</div>
        <input
          className={inp}
          placeholder="Full Name *"
          value={form.name}
          onChange={(e) => set("name", e.target.value)}
        />
        <input
          className={inp}
          placeholder="Phone Number"
          value={form.phone}
          onChange={(e) => set("phone", e.target.value)}
        />
        <input
          className={inp}
          placeholder="Email"
          type="email"
          value={form.email}
          onChange={(e) => set("email", e.target.value)}
        />
        <select
          className={inp}
          value={form.channel}
          onChange={(e) => set("channel", e.target.value)}
        >
          {Object.keys(CHANNELS).map((c) => (
            <option key={c}>{c}</option>
          ))}
        </select>
        <textarea
          className={`${inp} resize-y`}
          placeholder="Enquiry / Message"
          value={form.enquiry}
          rows={3}
          onChange={(e) => set("enquiry", e.target.value)}
        />
        <div className="flex gap-2.5 mb-2.5">
          <select
            className="flex-1 p-2.5 rounded-lg border border-gray-200 text-sm outline-none focus:border-indigo-400 font-[inherit]"
            value={form.tag}
            onChange={(e) => set("tag", e.target.value)}
          >
            {["Hot", "Warm", "Cold"].map((t) => (
              <option key={t}>{t}</option>
            ))}
          </select>
          <select
            className="flex-1 p-2.5 rounded-lg border border-gray-200 text-sm outline-none focus:border-indigo-400 font-[inherit]"
            value={form.assignee}
            onChange={(e) => set("assignee", e.target.value)}
          >
            {TEAM.map((t) => (
              <option key={t}>{t}</option>
            ))}
          </select>
        </div>
        {err && <div className="text-red-500 text-xs mb-2">⚠ {err}</div>}
        <div className="flex gap-2.5 mt-1.5">
          <button
            onClick={onClose}
            className="flex-1 py-2.5 rounded-lg border border-gray-200 bg-white text-gray-500 font-semibold cursor-pointer"
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            disabled={saving}
            className={`flex-1 py-2.5 rounded-lg text-white font-bold cursor-pointer ${saving ? "bg-gray-400 cursor-not-allowed" : "bg-indigo-500 hover:bg-indigo-600"}`}
          >
            {saving ? "Saving…" : "Create Lead"}
          </button>
        </div>
      </div>
    </div>
  );
}

// ─── Main Component ───────────────────────────────────────────────────────────
const InquireLeads = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);
  const [isSidebarOpen, setIsSidebarOpen] = useState(() => {
    const s = localStorage.getItem("menubarOpen");
    return s !== null ? JSON.parse(s) : window.innerWidth >= 1024;
  });
  const [storeTab, setStoreTab] = useState("meta");
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [processedMetaIds, setProcessedMetaIds] = useState(new Set());
  const [activeStatus, setActiveStatus] = useState("Incoming Leads");
  const [websiteLeads, setWebsiteLeads] = useState([]);
  const [websiteLoading, setWebsiteLoading] = useState(false);
  const [websiteError, setWebsiteError] = useState(null);
  const [processedWebsiteIds, setProcessedWebsiteIds] = useState(new Set());
  const [processedWebsiteLeads, setProcessedWebsiteLeads] = useState([]);
  const [processedWebsiteLoading, setProcessedWebsiteLoading] = useState(false);
  const [websiteActiveStatus, setWebsiteActiveStatus] = useState("All Leads");
  const [activeChannel, setActiveChannel] = useState("All");
  const [activeTag, ] = useState("All");
  const [searchInput, setSearchInput] = useState("");
  const [search, setSearch] = useState("");
  const [expandedLead, setExpandedLead] = useState(null);
  const [followUpLead, setFollowUpLead] = useState(null);
  const [showCreate, setShowCreate] = useState(false);
  const [updatingId, setUpdatingId] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [showConvertModal, setShowConvertModal] = useState(false);
  const [converting, setConverting] = useState(false);
  const [convertResult, setConvertResult] = useState(null);
  const [showBulkProcessModal, setShowBulkProcessModal] = useState(false);
  const [bulkProcessing, setBulkProcessing] = useState(false);
  const [bulkProcessResult, setBulkProcessResult] = useState(null);
  const [deleteTarget, setDeleteTarget] = useState(null); // { id, name, type: "meta"|"website" }
  const [deleting, setDeleting] = useState(false);
  const currentUser = JSON.parse(localStorage.getItem("user") || "{}");
  const userId = currentUser.id;

  const [notifCount, setNotifCount] = useState(0);
  const [notifBreakdown, setNotifBreakdown] = useState({ meta: 0, website: 0 });
  const [showNotifDropdown, setShowNotifDropdown] = useState(false);
  // Toast state
  const [toastMsg, setToastMsg] = useState("");
  const rowsPerPage = 20;
  const [currentPage, setCurrentPage] = useState(1);
  const [showPopup_filter, setShowPopup_filter] = useState(false);
  const filterRef = useRef(null);
  // Add this state near the other filter states
  const [websiteFilter, setWebsiteFilter] = useState("All"); // "All" | "Processed" | "Unprocessed"
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  useEffect(() => {
    const t = setTimeout(() => setSearch(searchInput), 400);
    return () => clearTimeout(t);
  }, [searchInput]);
  useEffect(() => {
    setCurrentPage(1);
    setSelectedRows([]);
    setWebsiteFilter("All");
  }, [
    search,
    activeStatus,
    activeChannel,
    activeTag,
    websiteActiveStatus,
    storeTab,
  ]);
  useEffect(() => {
    function handleClickOutside(e) {
      if (filterRef.current && !filterRef.current.contains(e.target))
        setShowPopup_filter(false);
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 1024;
      setIsMobile(mobile);
      if (mobile) setIsSidebarOpen(false);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const fetchLeads = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      // Just fetch all, filter client-side
      const res = await fetch(`${API}/leads?limit=200`);
      if (!res.ok) throw new Error(`API error ${res.status}`);
      const data = await res.json();
      const allLeads = data.leads || [];
      setProcessedMetaIds(
        new Set(
          allLeads
            .filter((l) => !String(l.id).startsWith("meta_") && l.meta_lead_id)
            .map((l) => l.meta_lead_id),
        ),
      );
      setLeads(allLeads);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  }, []); // no longer depends on filter states

  useEffect(() => {
    fetchLeads();
  }, [fetchLeads]);

  const fetchWebsiteLeads = useCallback(async () => {
    setWebsiteLoading(true);
    setWebsiteError(null);
    try {
      const res = await fetch(`${API}/website-leads`);
      if (!res.ok) throw new Error(`API error ${res.status}`);
      setWebsiteLeads((await res.json()).data || []);
    } catch (e) {
      setWebsiteError(e.message);
    } finally {
      setWebsiteLoading(false);
    }
  }, []);

  const fetchProcessedWebsiteLeads = useCallback(async () => {
    setProcessedWebsiteLoading(true);
    try {
      const url =
        websiteActiveStatus !== "Incoming Leads" &&
        websiteActiveStatus !== "All Processed Leads" &&
        websiteActiveStatus !== "All Leads"
          ? `${API}/processed-website-leads?status=${encodeURIComponent(websiteActiveStatus)}`
          : `${API}/processed-website-leads`;
      const res = await fetch(url);
      if (!res.ok) throw new Error(`API error ${res.status}`);
      const rows = (await res.json()).data || [];
      setProcessedWebsiteLeads(rows);
      setProcessedWebsiteIds(
        new Set(rows.map((r) => String(r.original_lead_id))),
      );
    } catch (e) {
      console.error("fetchProcessedWebsiteLeads:", e.message);
    } finally {
      setProcessedWebsiteLoading(false);
    }
  }, [websiteActiveStatus]);

  useEffect(() => {
    if (storeTab === "website") {
      fetchWebsiteLeads();
      fetchProcessedWebsiteLeads();
    }
  }, [storeTab, fetchWebsiteLeads, fetchProcessedWebsiteLeads]);

  // ── Notifications ───────────────────────────────────────────────────────────────────
  const [, setCurrentCounts] = useState({ meta: 0, website: 0 });

  const fetchNotifications = useCallback(async () => {
    if (!userId) return;
    try {
      const res = await fetch(`${API}/lead-notifications?userId=${userId}`);
      const data = await res.json();
      setNotifCount(data.total || 0);
      setNotifBreakdown({ meta: data.meta || 0, website: data.website || 0 });
      setCurrentCounts({
        meta: data.currentMeta || 0,
        website: data.currentWebsite || 0,
      });
    } catch (e) {
      console.error("Notification fetch failed:", e.message);
    }
  }, [userId]);

 
const markSeen = useCallback(async () => {
  if (!userId) return;
  try {
    await fetch(`${API}/lead-notifications/mark-seen`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ userId }),  // just userId, nothing else
    });
    setNotifCount(0);
    setNotifBreakdown({ meta: 0, website: 0 });
    setShowNotifDropdown(false);
  } catch (e) {
    console.error("markSeen failed:", e.message);
  }
}, [userId]);
  // Poll every 60 seconds
  useEffect(() => {
    fetchNotifications();
    const interval = setInterval(fetchNotifications, 60_000);
    return () => clearInterval(interval);
  }, [fetchNotifications]);

  const notifRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(e) {
      if (notifRef.current && !notifRef.current.contains(e.target))
        setShowNotifDropdown(false);
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // ── Helpers ───────────────────────────────────────────────────────────────────
  const matchesSearch = (lead, term) => {
    if (!term) return true;
    const t = term.toLowerCase();
    return (
      (lead.name || lead.customerName || lead.customer_name || "")
        .toLowerCase()
        .includes(t) ||
      (lead.phone || "").toLowerCase().includes(t) ||
      (lead.email || "").toLowerCase().includes(t)
    );
  };

  const matchesDateRange = (dateStr) => {
    if (!dateFrom && !dateTo) return true;
    if (!dateStr) return false;
    const d = new Date(dateStr);
    if (dateFrom && d < new Date(dateFrom)) return false;
    if (dateTo && d > new Date(dateTo + "T23:59:59")) return false;
    return true;
  };

  // ── visibleLeads (Meta) ───────────────────────────────────────────────────────
  const visibleLeads = (() => {
    let base;
    if (activeStatus === "All Leads") base = leads;
    else if (activeStatus === "Incoming Leads")
      base = leads.filter(
        (l) =>
          String(l.id).startsWith("meta_") &&
          !processedMetaIds.has(String(l.id).replace("meta_", "")),
      );
    else if (activeStatus === "All Processed Leads")
      base = leads.filter((l) => !String(l.id).startsWith("meta_"));
    else
      base = leads.filter(
        (l) => !String(l.id).startsWith("meta_") && l.status === activeStatus,
      );

    return base
      .filter((l) => matchesSearch(l, search))
      .filter((l) => activeChannel === "All" || l.channel === activeChannel)
      .filter((l) => matchesDateRange(l.created_at));
  })();

  // ── visibleWebsiteLeads ───────────────────────────────────────────────────────
  const visibleWebsiteLeads = (() => {
    let base;
    if (websiteActiveStatus === "All Leads") {
      const incoming = websiteLeads
        .filter(
          (l) => !processedWebsiteIds.has(String(l.leadId).replace("WL-", "")),
        )
        .map((l) => ({ ...l, _isIncoming: true }));
      base = [...incoming, ...processedWebsiteLeads];
    } else if (websiteActiveStatus === "Incoming Leads") {
      base = websiteLeads
        .filter(
          (l) => !processedWebsiteIds.has(String(l.leadId).replace("WL-", "")),
        )
        .map((l) => ({ ...l, _isIncoming: true }));
    } else if (websiteActiveStatus === "All Processed Leads") {
      base = processedWebsiteLeads;
    } else {
      base = processedWebsiteLeads.filter(
        (l) => l.status === websiteActiveStatus,
      );
    }

    // Apply websiteFilter (Processed / Unprocessed) — only meaningful in All Leads
    if (websiteActiveStatus === "All Leads") {
      if (websiteFilter === "Unprocessed")
        base = base.filter((l) => l._isIncoming);
      else if (websiteFilter === "Processed")
        base = base.filter((l) => !l._isIncoming);
    }

    return base.filter((l) => {
      const nameMatch = matchesSearch(l, search);
      const dateField = l._isIncoming ? l.createdat : l.created_at;
      return nameMatch && matchesDateRange(dateField);
    });
  })();

  const patchLead = async (id, field, value) => {
    setUpdatingId(id);
    setLeads((prev) =>
      prev.map((l) => (l.id === id ? { ...l, [field]: value } : l)),
    );
    try {
      const res = await fetch(`${API}/leads/${id}`, {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ [field]: value }),
      });
      if (!res.ok) throw new Error("patch failed");
    } catch {
      fetchLeads();
    } finally {
      setUpdatingId(null);
    }
  };

  const patchWebsiteLead = async (id, field, value) => {
    setUpdatingId(id);
    setProcessedWebsiteLeads((prev) =>
      prev.map((l) => (l.id === id ? { ...l, [field]: value } : l)),
    );
    try {
      const res = await fetch(`${API}/processed-website-leads/${id}`, {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ [field]: value }),
      });
      if (!res.ok) throw new Error("patch failed");
    } catch {
      fetchProcessedWebsiteLeads();
    } finally {
      setUpdatingId(null);
    }
  };
  const handleDeleteLead = async () => {
    if (!deleteTarget) return;
    setDeleting(true);
    try {
      const url =
        deleteTarget.type === "meta"
          ? `${API}/leads/${deleteTarget.id}`
          : `${API}/processed-website-leads/${deleteTarget.id}`;
      const res = await fetch(url, { method: "DELETE" });
      if (!res.ok) throw new Error("Delete failed " + res.status);

      if (deleteTarget.type === "meta") {
        setLeads((prev) => prev.filter((l) => l.id !== deleteTarget.id));
      } else {
        setProcessedWebsiteLeads((prev) =>
          prev.filter((l) => l.id !== deleteTarget.id),
        );
      }
      setToastMsg("Lead deleted successfully");
    } catch (e) {
      setToastMsg("Error: " + e.message);
    } finally {
      setDeleting(false);
      setDeleteTarget(null);
    }
  };

  const addRemark = (lead) => {
    const r = prompt("Remark:", lead.remark || "");
    if (r !== null) patchLead(lead.id, "remark", r);
  };
  const addWebsiteRemark = (lead) => {
    const r = prompt("Remark:", lead.remark || "");
    if (r !== null) patchWebsiteLead(lead.id, "remark", r);
  };
  const handleCreated = (lead) => setLeads((prev) => [lead, ...prev]);
  const handleMetaLeadProcessed = (savedLead) => {
    setProcessedMetaIds((prev) => {
      const n = new Set(prev);
      n.add(savedLead.meta_lead_id);
      return n;
    });
    setLeads((prev) =>
      prev.some((l) => l.id === savedLead.id) ? prev : [savedLead, ...prev],
    );
  };
  const handleWebsiteLeadProcessed = (savedLead) => {
    setProcessedWebsiteIds((prev) => {
      const n = new Set(prev);
      n.add(String(savedLead.original_lead_id));
      return n;
    });
    setProcessedWebsiteLeads((prev) =>
      prev.some((l) => l.id === savedLead.id) ? prev : [savedLead, ...prev],
    );
  };

  const handleConvertToBooking = async () => {
    const leadsToConvert = leads.filter((l) => selectedRows.includes(l.id));
    if (!leadsToConvert.length) return;
    setConverting(true);
    setConvertResult(null);
    const results = { bookingids: [], errors: [] };
    for (const lead of leadsToConvert) {
      try {
        const nameParts = (lead.name || "").trim().split(/\s+/);
        const payload = {
          firstname: nameParts[0] || "Unknown",
          lastname: nameParts.slice(1).join(" ") || "",
          email: lead.email || "",
          phone: lead.phone || "",
          tripexecutive:
            lead.assignee && lead.assignee !== "Unassigned"
              ? lead.assignee
              : "",
          bookingstatus: "Pending",
          paymentstatus: "Pending",
          source: channelToSource(lead.channel),
        };
        const res = await fetch(`${API}/createBooking`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });
        if (!res.ok) {
          const e = await res.json().catch(() => ({}));
          throw new Error(e.message || `HTTP ${res.status}`);
        }
        const data = await res.json();
        results.bookingids.push(data.bookingid || "—");
        const delRes = await fetch(`${API}/leads/${lead.id}`, {
          method: "DELETE",
        });
        if (!delRes.ok)
          console.warn(
            `Booking created but lead delete failed for id ${lead.id}`,
          );
      } catch (e) {
        results.errors.push({ name: lead.name, error: e.message });
      }
    }
    const failedNames = new Set(results.errors.map((e) => e.name));
    setLeads((prev) =>
      prev.filter(
        (l) =>
          !leadsToConvert
            .filter((lc) => !failedNames.has(lc.name))
            .map((lc) => lc.id)
            .includes(l.id),
      ),
    );
    setSelectedRows([]);
    setConverting(false);
    setConvertResult(results);
  };

  const handleWebsiteConvertToBooking = async () => {
    if (!selectedRows.length) return;
    setConverting(true);
    setConvertResult(null);
    try {
      const res = await fetch(`${API}/website-leads/convert-booking`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ids: selectedRows }),
      });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();
      const results = {
        bookingids: data.bookingids || [],
        errors: data.errors || [],
      };
      const failedIds = new Set((data.errors || []).map((e) => e.id));
      setProcessedWebsiteLeads((prev) =>
        prev.filter(
          (l) =>
            !selectedRows.filter((id) => !failedIds.has(id)).includes(l.id),
        ),
      );
      setSelectedRows([]);
      setConvertResult(results);
    } catch (e) {
      setConvertResult({
        bookingids: [],
        errors: [{ id: "all", error: e.message }],
      });
    } finally {
      setConverting(false);
    }
  };

  const handleBulkProcessWebsiteLeads = async () => {
    const toProcess = currentLeads.filter(
      (l) => l._isIncoming && selectedRows.includes(l.leadId),
    );
    if (!toProcess.length) return;
    setBulkProcessing(true);
    setBulkProcessResult(null);
    const results = { processed: [], errors: [] };
    for (const lead of toProcess) {
      try {
        const res = await fetch(`${API}/website-leads/process`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ leadId: lead.leadId }),
        });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const { lead: savedLead } = await res.json();
        results.processed.push(lead.customerName || lead.leadId);
        handleWebsiteLeadProcessed(savedLead);
      } catch (e) {
        results.errors.push({
          name: lead.customerName || lead.leadId,
          error: e.message,
        });
      }
    }
    setSelectedRows([]);
    setBulkProcessing(false);
    setBulkProcessResult(results);
  };

  // ── Smart checkbox handler with toast guard ────────────────────────────────
  // For website "All Leads" view: prevent mixing processed and unprocessed selections
  const handleRowCheckboxChange = (id, isUnprocessed = false) => {
    if (storeTab === "website" && websiteActiveStatus === "All Leads") {
      const hasProcessed = selectedRows.some(
        (sid) => !currentLeads.find((l) => l._isIncoming && l.leadId === sid),
      );
      const hasUnprocessed = selectedRows.some((sid) =>
        currentLeads.find((l) => l._isIncoming && l.leadId === sid),
      );

      if (isUnprocessed && hasProcessed) {
        setToastMsg("Cannot select processed and unprocessed leads at once");
        return;
      }
      if (!isUnprocessed && hasUnprocessed) {
        setToastMsg("Cannot select processed and unprocessed leads at once");
        return;
      }
    }
    setSelectedRows((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id],
    );
  };

  const handleSelectAll = () => {
    if (
      selectedRows.length === currentLeads.length &&
      currentLeads.length > 0
    ) {
      setSelectedRows([]);
      return;
    }
    // In All Leads website view, only select same type as first already-selected row (or all if none selected)
    if (
      storeTab === "website" &&
      websiteActiveStatus === "All Leads" &&
      selectedRows.length > 0
    ) {
      const hasProcessed = selectedRows.some(
        (sid) => !currentLeads.find((l) => l._isIncoming && l.leadId === sid),
      );
      const hasUnprocessed = selectedRows.some((sid) =>
        currentLeads.find((l) => l._isIncoming && l.leadId === sid),
      );
      if (hasUnprocessed && !hasProcessed) {
        setSelectedRows(
          currentLeads.filter((l) => l._isIncoming).map((l) => l.leadId),
        );
        return;
      }
      if (hasProcessed && !hasUnprocessed) {
        setSelectedRows(
          currentLeads.filter((l) => !l._isIncoming).map((l) => l.id),
        );
        return;
      }
    }
    setSelectedRows(currentLeads.map((l) => l.id || l.leadId));
  };

  // Counts for action bars
  const newMetaLeadsCount = leads.filter(
    (l) =>
      String(l.id).startsWith("meta_") &&
      !processedMetaIds.has(String(l.id).replace("meta_", "")),
  ).length;
  const facebookCount = leads.filter(
    (l) => l.channel === "Facebook Lead",
  ).length;
  const instagramCount = leads.filter(
    (l) => l.channel === "Instagram DM",
  ).length;
  const whatsappCount = leads.filter((l) => l.channel === "WhatsApp").length;

  const activeLeadList =
    storeTab === "meta" ? visibleLeads : visibleWebsiteLeads;
  const totalPages = Math.ceil(activeLeadList.length / rowsPerPage);
  const indexOfFirst = (currentPage - 1) * rowsPerPage;
  const indexOfLast = indexOfFirst + rowsPerPage;
  const currentLeads = activeLeadList.slice(indexOfFirst, indexOfLast);

  const generatePageNumbers = () => {
    const pages = [];
    if (totalPages <= 3) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      if (currentPage > 2) {
        pages.push(1);
        pages.push("...");
      }
      for (let i = currentPage - 1; i <= currentPage + 1; i++) {
        if (i > 0 && i <= totalPages) pages.push(i);
      }
      if (currentPage < totalPages - 1) {
        pages.push("...");
        pages.push(totalPages);
      }
    }
    return pages;
  };

  const isIncomingView = activeStatus === "Incoming Leads";
  const isAllLeadsView = activeStatus === "All Leads";
  const isWebsiteIncomingView = websiteActiveStatus === "Incoming Leads";

  const selectedUnprocessedWebsiteCount = currentLeads.filter(
    (l) =>
      selectedRows.includes(l.leadId) &&
      (l._isIncoming || isWebsiteIncomingView),
  ).length;
  const selectedProcessedWebsiteCount = selectedRows.filter(
    (id) => !currentLeads.find((l) => l._isIncoming && l.leadId === id),
  ).length;

  if (error && storeTab === "meta")
    return (
      <div className="flex">
        <Menubar
          isOpen={isSidebarOpen}
          setIsOpen={setIsSidebarOpen}
          isMobile={isMobile}
        />
        <div className="flex-1 p-6 flex justify-center items-center h-64">
          <div className="text-lg text-red-500">
            {error}
            <button
              onClick={fetchLeads}
              className="ml-3 underline text-indigo-500 text-sm"
            >
              Retry
            </button>
          </div>
        </div>
      </div>
    );

  // Pipeline stage tab helper
  const PipelineTab = ({ stage, isActive, onClick }) => (
    <button
      onClick={onClick}
      className={`relative flex-shrink-0 flex-1 min-w-[70px] h-9 px-1 leading-tight transition-all ${stage.color} ${isActive ? "ring-1 ring-black z-10" : ""}`}
      style={{
        clipPath:
          "polygon(0 0, calc(100% - 12px) 0, 100% 50%, calc(100% - 12px) 100%, 0 100%, 12px 50%)",
        marginRight: "-6px",
      }}
    >
      <span className="flex flex-col items-center justify-center gap-0.5 w-full">
        <span>{stage.name}</span>
        <span
          className="rounded-full transition-all duration-200"
          style={{
            width: isActive ? 5 : 0,
            height: isActive ? 5 : 0,
            background: "currentColor",
            opacity: isActive ? 1 : 0,
            display: "block",
          }}
        />
      </span>
    </button>
  );

  return (
    <div className="flex bg-[#F8F9FA]">
      <Menubar
        isOpen={isSidebarOpen}
        setIsOpen={setIsSidebarOpen}
        isMobile={isMobile}
      />

      <main
        className={`p-5 lg:p-6 transition-all duration-500 w-full ${isMobile ? "ml-0" : isSidebarOpen ? "ml-64" : "ml-16"}`}
      >
        <Outlet />

        {/* Header */}
        <div className="flex justify-between gap-5 items-start lg:items-center">
          <p className="font-semibold text-xl text-gray-700 ml-10 lg:ml-0">
            Inquire Leads
          </p>

          {/* Search Bar and Filter */}
          <div className="flex items-center gap-1 ">
            <div className="mr-2 p-2 overflow-hidden w-8 h-8 hover:w-[120px] sm:hover:w-[250px] hover:border hover:border-[#1D2826] hover:shadow-[2px_2px_20px_rgba(0,0,0,0.08)] rounded-full flex group items-center hover:duration-300 duration-300">
              <div className="flex items-center justify-center fill-[#1D2826]">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="18"
                  height="18"
                >
                  <path d="M18.9,16.776A10.539,10.539,0,1,0,16.776,18.9l5.1,5.1L24,21.88ZM10.5,18A7.5,7.5,0,1,1,18,10.5,7.507,7.507,0,0,1,10.5,18Z" />
                </svg>
              </div>
              <input
                type="text"
                placeholder="Search name, phone…"
                value={searchInput}
                onChange={(e) => setSearchInput(e.target.value)}
                className="border-none outline-none text-sm bg-transparent w-full font-normal px-2 focus:ring-0"
              />
            </div>
            <div className="flex items-center">
              <div className="relative inline-block" ref={filterRef}>
                <div
                  onClick={() => setShowPopup_filter((p) => !p)}
                  className={`flex flex-col items-center gap-4 cursor-pointer select-none group scale-[0.75] py-2.5 px-2 rounded-full border-2 transition-all duration-300 ${showPopup_filter ? "border-[#1D2826]" : "border-transparent hover:border-[#1D2826]"}`}
                >
                  {[
                    ["100%", "0%"],
                    ["0%", "100%"],
                    ["100%", "0%"],
                  ].map(([a, b], i) => (
                    <div
                      key={i}
                      className={`relative w-6 h-0.5 bg-[#1D2826] rounded-full ${i === 1 ? "-my-2.5" : ""}`}
                    >
                      <div
                        className="absolute top-1/2 -translate-y-1/2 w-2 h-2 rounded-full border-2 border-black bg-white transition-all duration-300"
                        style={{
                          left: showPopup_filter ? a : b,
                          transform: `translate(${showPopup_filter ? (i === 1 ? "0" : "-100%") : i === 1 ? "0" : "-0%"},-50%)`,
                        }}
                      />
                    </div>
                  ))}
                </div>
                {showPopup_filter && (
                  <div className="absolute top-full mt-1 right-0 bg-white border rounded-lg shadow-custom z-10 p-4 space-y-4 min-w-[220px]">
                    {/* META: Channel filter */}
                    {storeTab === "meta" && (
                      <div className="flex flex-col gap-2">
                        <p className="text-xs font-semibold text-gray-500 uppercase">
                          Channel
                        </p>
                        <div className="flex gap-1 flex-wrap">
                          {[
                            "All",
                            "Instagram DM",
                            "Facebook Lead",
                            "WhatsApp",
                          ].map((ch) => (
                            <button
                              key={ch}
                              onClick={() => setActiveChannel(ch)}
                              className={`py-1 px-2 rounded text-xs font-medium transition-colors ${activeChannel === ch ? "bg-[#1D2826] text-white" : "bg-gray-100 hover:bg-[#DAE0CE]"}`}
                            >
                              {ch}
                            </button>
                          ))}
                        </div>
                      </div>
                    )}

                    {/* WEBSITE: Processed/Unprocessed filter (only useful on All Leads view) */}
                    {storeTab === "website" && (
                      <div className="flex flex-col gap-2">
                        <p className="text-xs font-semibold text-gray-500 uppercase">
                          Lead Type
                        </p>
                        <div className="flex gap-1 flex-wrap">
                          {["All", "Processed", "Unprocessed"].map((f) => (
                            <button
                              key={f}
                              onClick={() => setWebsiteFilter(f)}
                              className={`py-1 px-2 rounded text-xs font-medium transition-colors ${websiteFilter === f ? "bg-[#1D2826] text-white" : "bg-gray-100 hover:bg-[#DAE0CE]"}`}
                            >
                              {f}
                            </button>
                          ))}
                        </div>
                      </div>
                    )}

                    {/* Date Range (both tabs) */}
                    <div className="flex flex-col gap-2">
                      <p className="text-xs font-semibold text-gray-500 uppercase">
                        Date Range
                      </p>
                      <div className="flex justify-between gap-2">
                        {[
                          { label: "Today", days: 0 },
                          { label: "Week", days: 7 },
                          { label: "Month", days: 30 },
                          { label: "Year", days: 365 },
                        ].map(({ label, days }) => (
                          <button
                            key={label}
                            onClick={() => {
                              const from = new Date();
                              from.setDate(from.getDate() - days);
                              setDateFrom(
                                days === 0
                                  ? new Date().toISOString().split("T")[0]
                                  : from.toISOString().split("T")[0],
                              );
                              setDateTo(new Date().toISOString().split("T")[0]);
                            }}
                            className="flex-1 py-1 px-2 bg-gray-100 active:bg-[#DAE0CE] hover:bg-[#DAE0CE] rounded text-xs font-medium"
                          >
                            {label}
                          </button>
                        ))}
                      </div>
                      <div className="flex items-center gap-2">
                        <input
                          type="date"
                          value={dateFrom}
                          onChange={(e) => setDateFrom(e.target.value)}
                          className="border text-sm rounded px-2 py-1 w-full focus:outline-none focus:ring-1 focus:ring-green-600 focus:border-black"
                        />
                        <span className="text-sm text-gray-500">-</span>
                        <input
                          type="date"
                          value={dateTo}
                          onChange={(e) => setDateTo(e.target.value)}
                          className="border text-sm rounded px-2 py-1 w-full focus:outline-none focus:ring-1 focus:ring-green-600 focus:border-black"
                        />
                      </div>
                      {(dateFrom || dateTo) && (
                        <button
                          onClick={() => {
                            setDateFrom("");
                            setDateTo("");
                          }}
                          className="text-xs text-gray-400 hover:text-gray-700 underline text-left"
                        >
                          Clear dates
                        </button>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
            {/* Notification Bell */}
            <div className="relative" ref={notifRef}>
              <button
                onClick={() => setShowNotifDropdown((p) => !p)}
                title="New leads"
                className="p-2 rounded-lg text-xl cursor-pointer border-none relative"
              >
                <IoNotificationsOutline />
                {notifCount > 0 && (
                  <span className="absolute -top-0.5 -right-0.5 bg-red-500 text-white text-[9px] font-bold rounded-full min-w-[16px] h-4 flex items-center justify-center px-1 leading-none">
                    {notifCount > 99 ? "99+" : notifCount}
                  </span>
                )}
              </button>

              {showNotifDropdown && (
                <div className="absolute right-0 top-full mt-1 bg-white border border-gray-200 rounded-xl shadow-xl p-4 text-xs z-30 w-52">
                  <p className="font-semibold text-gray-700 mb-2 text-sm">
                    {notifCount > 0
                      ? `${notifCount} new lead${notifCount > 1 ? "s" : ""}`
                      : "All caught up!"}
                  </p>
                  {notifCount > 0 && (
                    <>
                      <div className="flex justify-between text-gray-500 py-1 border-b border-gray-100">
                        <span>Meta leads</span>
                        <span className="font-bold text-gray-800">
                          {notifBreakdown.meta}
                        </span>
                      </div>
                      <div className="flex justify-between text-gray-500 py-1 mb-3">
                        <span>Website leads</span>
                        <span className="font-bold text-gray-800">
                          {notifBreakdown.website}
                        </span>
                      </div>
                      <button
                        onClick={markSeen}
                        className="w-full py-1.5 bg-[#1D2826] text-white rounded-lg font-semibold text-xs cursor-pointer"
                      >
                        Mark all seen
                      </button>
                    </>
                  )}
                </div>
              )}
            </div>
            <button
              onClick={
                storeTab === "meta"
                  ? fetchLeads
                  : () => {
                      fetchWebsiteLeads();
                      fetchProcessedWebsiteLeads();
                    }
              }
              title="Refresh"
              className="p-2 rounded-lg text-xl cursor-pointer border-none"
            >
              <TbRefresh />
            </button>
            {storeTab === "meta" && (
              <button
                onClick={() => setShowCreate(true)}
                className="ml-1 px-4 py-2 bg-[#1D2826] rounded-lg text-white text-sm font-semibold hover:scale-95 transition-all duration-200"
              >
                + New Lead
              </button>
            )}
          </div>
        </div>

        {/* Meta Stat Boxes */}
        {storeTab === "meta" && (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 items-center gap-5 text-gray-700 font-semibold mt-5">
            {[
              [
                "FaceBook Leads",
                facebookCount,
                <IoLogoFacebook className="bg-[#3C4C4E] text-3xl text-white p-1.5 rounded-md" />,
              ],
              [
                "Instagram Leads",
                instagramCount,
                <RiInstagramFill className="bg-[#3C4C4E] text-3xl text-white p-1.5 rounded-md" />,
              ],
              [
                "WhatsApp Leads",
                whatsappCount,
                <IoLogoWhatsapp className="bg-[#3C4C4E] text-3xl text-white p-1.5 rounded-md" />,
              ],
              [
                "Unprocessed (Meta)",
                newMetaLeadsCount,
                <TbDeviceAnalytics className="bg-[#3C4C4E] text-3xl text-white p-1.5 rounded-md" />,
              ],
            ].map(([label, count, icon]) => (
              <div
                key={label}
                className="flex items-center justify-between gap-5 bg-[#DAE0CE] py-2 px-4 rounded-lg"
              >
                <div>
                  <p>{label}</p>
                  <p className="mt-2 text-lg text-black">{count}</p>
                </div>
                {icon}
              </div>
            ))}
          </div>
        )}

        {/* Website Stat Boxes */}
        {storeTab === "website" && (
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 text-gray-700 font-semibold mt-5">
            <div className="flex items-center justify-between gap-5 bg-[#DAE0CE] py-2 px-4 rounded-lg">
              <div>
                <p>Incoming</p>
                <p className="mt-2 text-lg text-black">
                  {
                    websiteLeads.filter(
                      (l) =>
                        !processedWebsiteIds.has(
                          String(l.leadId).replace("WL-", ""),
                        ),
                    ).length
                  }
                </p>
              </div>
              <RxOpenInNewWindow className="bg-[#3C4C4E] text-3xl text-white p-1.5 rounded-md" />
            </div>
            <div className="flex items-center justify-between gap-5 bg-[#DAE0CE] py-2 px-4 rounded-lg">
              <div>
                <p>Processed</p>
                <p className="mt-2 text-lg text-black">
                  {processedWebsiteLeads.length}
                </p>
              </div>
              <MdFileDownloadDone className="bg-[#3C4C4E] text-3xl text-white p-1.5 rounded-md" />
            </div>
            <div className="flex items-center justify-between gap-5 bg-[#DAE0CE] py-2 px-4 rounded-lg">
              <div>
                <p>Total Leads (Website)</p>
                <p className="mt-2 text-lg text-black">
                  {websiteLeads.filter(
                    (l) =>
                      !processedWebsiteIds.has(
                        String(l.leadId).replace("WL-", ""),
                      ),
                  ).length + processedWebsiteLeads.length}
                </p>
              </div>
              <TbDeviceAnalytics className="bg-[#3C4C4E] text-3xl text-white p-1.5 rounded-md" />
            </div>
          </div>
        )}

        {/* Tab Switcher */}
        <div className="inline-flex border border-gray-300 rounded-lg overflow-hidden text-sm font-medium shadow-sm mt-5">
          <button
            onClick={() => setStoreTab("meta")}
            className={`px-4 py-2 transition-colors duration-200 focus:outline-none ${storeTab === "meta" ? "bg-[#1D2826] text-white" : "bg-white text-gray-500 hover:bg-green-50"}`}
          >
            Meta Leads
          </button>
          <button
            onClick={() => setStoreTab("website")}
            className={`px-4 py-2 transition-colors duration-200 focus:outline-none ${storeTab === "website" ? "bg-[#1D2826] text-white" : "bg-white text-gray-500 hover:bg-green-50"}`}
          >
            Website Leads
          </button>
        </div>

        {/* Meta Pipeline Tabs */}
        {storeTab === "meta" && (
          <div className="mt-6">
            <div className="flex w-full items-center text-[11px] font-semibold overflow-x-auto">
              {PIPELINE_STAGES.map((stage) => (
                <PipelineTab
                  key={stage.name}
                  stage={stage}
                  isActive={activeStatus === stage.status}
                  onClick={() => setActiveStatus(stage.status)}
                />
              ))}
            </div>
          </div>
        )}

        {/* Website Pipeline Tabs */}
        {storeTab === "website" && (
          <div className="mt-6">
            <div className="flex w-full items-center text-[11px] font-semibold overflow-x-auto">
              {WEBSITE_PIPELINE_STAGES.map((stage) => (
                <PipelineTab
                  key={stage.name}
                  stage={stage}
                  isActive={websiteActiveStatus === stage.status}
                  onClick={() => setWebsiteActiveStatus(stage.status)}
                />
              ))}
            </div>
          </div>
        )}

        {/* Action bars */}
        {selectedRows.length > 0 && (
          <div className="mt-4 flex items-center justify-between gap-2 px-4 py-2.5">
            {/* Left: count + clear */}
            <div className="flex items-center gap-3">
              <span className="text-sm text-gray-600 font-medium">
                {selectedRows.length} selected
              </span>
              <button
                onClick={() => setSelectedRows([])}
                className="text-xs text-gray-400 hover:text-gray-700 underline cursor-pointer"
              >
                Clear
              </button>
            </div>
            {/* Right: action buttons */}
            <div className="flex items-center gap-2">
              {/* Convert to Booking */}
              {((storeTab === "meta" && !isIncomingView) ||
                (storeTab === "website" &&
                  !isWebsiteIncomingView &&
                  selectedProcessedWebsiteCount > 0)) && (
                <button
                  onClick={() => setShowConvertModal(true)}
                  className="px-4 py-1.5 bg-[#1D2826] text-white text-xs font-semibold rounded-lg hover:scale-95 transition-all duration-200 cursor-pointer"
                >
                  Convert to Booking
                </button>
              )}
              {/* Process Selected Leads (website unprocessed) */}
              {storeTab === "website" &&
                selectedUnprocessedWebsiteCount > 0 && (
                  <button
                    onClick={() => setShowBulkProcessModal(true)}
                    className="px-4 py-1.5 bg-yellow-200 text-yellow-700 text-xs font-semibold rounded-lg hover:scale-95 transition-all duration-200 cursor-pointer"
                  >
                    Process Selected Leads
                  </button>
                )}
            </div>
          </div>
        )}

        {/* META TABLE */}
        {storeTab === "meta" && (
          <div className="shadow-md rounded-lg mt-3">
            <div className="overflow-x-auto">
              <table className="w-full text-sm text-left text-gray-500">
                <thead className="text-xs text-gray-400 uppercase bg-green-50 border-b">
                  <tr>
                    <th className="p-4">
                      <input
                        type="checkbox"
                        onChange={handleSelectAll}
                        checked={
                          selectedRows.length === currentLeads.length &&
                          currentLeads.length > 0
                        }
                      />
                    </th>
                    <th className="p-4">Lead Details</th>
                    <th className="p-4">Enquiry</th>
                    {isIncomingView ? (
                      <>
                        <th className="p-4">Meta Fields</th>
                        <th className="p-4">Action</th>
                      </>
                    ) : (
                      <>
                        <th className="p-4">Status</th>
                        <th className="p-4">Assigned To</th>
                        <th className="p-4">Remark</th>
                        <th className="p-4">Date</th>
                        <th className="p-4">Actions</th>
                      </>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td
                        colSpan={isIncomingView ? 5 : 9}
                        className="text-center py-14 text-gray-400"
                      >
                        Loading leads…
                      </td>
                    </tr>
                  ) : currentLeads.length === 0 ? (
                    <tr>
                      <td
                        colSpan={isIncomingView ? 5 : 9}
                        className="text-center py-14 text-gray-400"
                      >
                        {isIncomingView
                          ? "No unprocessed Meta leads. They'll appear here automatically via Meta webhooks."
                          : "No leads found for this filter."}
                      </td>
                    </tr>
                  ) : (
                    currentLeads.map((lead, idx) => {
                      const ch = CHANNELS[lead.channel] || {
                        color: "#888",
                        bg: "#f1f5f9",
                        icon: "",
                      };
                      const isExpanded = expandedLead === lead.id;
                      const dimmed = updatingId === lead.id;
                      const isMetaLead = String(lead.id).startsWith("meta_");
                      const showProcessButton = isAllLeadsView && isMetaLead;
                      return (
                        <React.Fragment key={lead.id}>
                          <tr
                            className={`border-b border-gray-200 hover:bg-gray-100 text-gray-800 transition-opacity ${idx % 2 === 0 ? "bg-white" : "bg-gray-50"}`}
                            style={{ opacity: dimmed ? 0.55 : 1 }}
                          >
                            <td className="px-4 py-3">
                              {/* Incoming tab: show checkbox for meta leads so bulk process is possible in future */}
                              <input
                                type="checkbox"
                                onChange={() =>
                                  handleRowCheckboxChange(
                                    lead.id,
                                    isMetaLead && isIncomingView,
                                  )
                                }
                                checked={selectedRows.includes(lead.id)}
                              />
                            </td>
                            <td className="px-4 py-3 min-w-[180px]">
                              <div className="font-bold text-gray-800 mb-1">
                                {lead.name || "—"}
                              </div>
                              <div className="flex flex-wrap items-center gap-1 mb-1">
                                <span
                                  className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] font-bold"
                                  style={{ background: ch.bg, color: ch.color }}
                                >
                                  <span className="text-xs">{ch.icon}</span>
                                  <span>{lead.channel}</span>
                                </span>
                                {lead.tag && (
                                  <span
                                    className="px-1.5 py-0.5 rounded-full text-[10px] font-bold"
                                    style={{
                                      background:
                                        (TAG_COLORS[lead.tag] || "#999") + "18",
                                      color: TAG_COLORS[lead.tag] || "#999",
                                    }}
                                  >
                                    {lead.tag}
                                  </span>
                                )}
                                {isAllLeadsView && isMetaLead && (
                                  <span className="px-1.5 py-0.5 rounded-full text-[10px] font-bold bg-amber-100 text-amber-600">
                                    Unprocessed
                                  </span>
                                )}
                              </div>
                              {lead.phone && (
                                <div className="inline-flex items-center gap-1 text-xs text-gray-500">
                                  <FaPhone />
                                  <span>{lead.phone}</span>
                                </div>
                              )}
                              <br />
                              {lead.email && (
                                <div className="inline-flex items-center gap-1 text-xs text-gray-400">
                                  <IoMail />
                                  <span>{lead.email}</span>
                                </div>
                              )}
                              <br />
                              <div className="inline-flex items-center gap-1 text-xs text-gray-400 mt-1">
                                <IoIosTime />
                                <span>{timeAgo(lead.created_at)}</span>
                              </div>
                            </td>
                            <td className="px-4 py-3 max-w-[220px]">
                              <div className="text-xs text-gray-600 leading-relaxed whitespace-pre-wrap">
                                {lead.enquiry
                                  ? lead.enquiry.split("\n").map((line, i) => {
                                      const clean = line
                                        .replace(/^•\s*/, "")
                                        .trim();
                                      const parts = clean.split(":");
                                      return (
                                        <div key={i} className="mb-2">
                                          <div>➤ {parts[0]}:</div>
                                          {parts.slice(1).join(":").trim() && (
                                            <div className="ml-3 font-bold text-gray-800">
                                              ↳{" "}
                                              {parts.slice(1).join(":").trim()}
                                            </div>
                                          )}
                                        </div>
                                      );
                                    })
                                  : "—"}
                              </div>
                            </td>
                            {isIncomingView ? (
                              <>
                                <td className="px-4 py-3 max-w-[220px]">
                                  {(lead.field_data || []).length > 0 ? (
                                    <div className="flex flex-col gap-1">
                                      {lead.field_data.map((f, fi) => (
                                        <div
                                          key={fi}
                                          className="text-[11px] text-gray-600"
                                        >
                                          <span className="text-gray-400 uppercase text-[10px]">
                                            {f.name.replace(/_/g, " ")}:{" "}
                                          </span>
                                          <span className="font-semibold text-gray-700">
                                            {f.values?.[0] || "—"}
                                          </span>
                                        </div>
                                      ))}
                                    </div>
                                  ) : (
                                    <span className="text-xs text-gray-300">
                                      —
                                    </span>
                                  )}
                                </td>
                                <td className="px-4 py-3">
                                  <ProcessMetaLeadButton
                                    lead={lead}
                                    onProcessed={handleMetaLeadProcessed}
                                  />
                                </td>
                              </>
                            ) : (
                              <>
                                <td className="px-4 py-3">
                                  {showProcessButton ? (
                                    <ProcessMetaLeadButton
                                      lead={lead}
                                      onProcessed={handleMetaLeadProcessed}
                                    />
                                  ) : (
                                    <select
                                      value={lead.status || ""}
                                      onChange={(e) =>
                                        patchLead(
                                          lead.id,
                                          "status",
                                          e.target.value,
                                        )
                                      }
                                      className="p-1.5 rounded-md text-[11px] font-bold cursor-pointer outline-none border"
                                      style={{
                                        borderColor:
                                          STATUS_COLORS[lead.status] || "#ccc",
                                        background:
                                          (STATUS_COLORS[lead.status] ||
                                            "#ccc") + "18",
                                        color:
                                          STATUS_COLORS[lead.status] || "#555",
                                      }}
                                    >
                                      {STATUSES.map((s) => (
                                        <option key={s} value={s}>
                                          {s}
                                        </option>
                                      ))}
                                    </select>
                                  )}
                                </td>
                                <td className="px-4 py-3">
                                  {showProcessButton ? (
                                    <span className="text-xs text-gray-300">
                                      —
                                    </span>
                                  ) : (
                                    <select
                                      value={lead.assignee || "Unassigned"}
                                      onChange={(e) =>
                                        patchLead(
                                          lead.id,
                                          "assignee",
                                          e.target.value,
                                        )
                                      }
                                      className="p-1.5 rounded-md border border-gray-200 bg-white text-xs cursor-pointer outline-none"
                                    >
                                      {TEAM.map((t) => (
                                        <option key={t}>{t}</option>
                                      ))}
                                    </select>
                                  )}
                                </td>
                                <td className="px-4 py-3">
                                  {showProcessButton ? (
                                    <span className="text-xs text-gray-300">
                                      —
                                    </span>
                                  ) : lead.remark ? (
                                    <div
                                      onClick={() => addRemark(lead)}
                                      title="Click to edit"
                                      className="text-xs text-gray-600 bg-gray-50 rounded-md px-2 py-1 max-w-[160px] cursor-pointer leading-snug"
                                    >
                                      {lead.remark}
                                    </div>
                                  ) : (
                                    <button
                                      onClick={() => addRemark(lead)}
                                      className="text-[11px] text-indigo-500 bg-transparent border border-dashed border-indigo-400 rounded-md px-2 py-1 cursor-pointer"
                                    >
                                      + Add Remark
                                    </button>
                                  )}
                                </td>
                                <td className="px-4 py-3">
                                  {showProcessButton ? (
                                    <span className="text-xs text-gray-300">
                                      —
                                    </span>
                                  ) : (
                                    <Tooltip
                                      title={
                                        lead.created_at
                                          ? new Date(
                                              lead.created_at,
                                            ).toLocaleString()
                                          : "—"
                                      }
                                      placement="left"
                                    >
                                      <span className="text-xs">
                                        {lead.created_at
                                          ? new Date(
                                              lead.created_at,
                                            ).toLocaleDateString()
                                          : "—"}
                                      </span>
                                    </Tooltip>
                                  )}
                                </td>
                                {/* <td className="px-4 py-3">
                                  {!showProcessButton && (
                                    <div className="flex flex-col gap-1.5">
                                      <button
                                        onClick={() => setFollowUpLead(lead)}
                                        className="bg-[#a19993] text-white border-none rounded-md px-2.5 py-1.5 text-[11px] font-semibold cursor-pointer"
                                      >
                                        Follow Up
                                      </button>
                                      <button
                                        onClick={() =>
                                          setExpandedLead(
                                            isExpanded ? null : lead.id,
                                          )
                                        }
                                        className="bg-gray-100 text-gray-600 border-none rounded-md px-2.5 py-1.5 text-[11px] cursor-pointer"
                                      >
                                        {isExpanded ? "▲ Less" : "▼ Details"}
                                      </button>
                                    </div>
                                  )}
                                </td> */}
                                <td className="px-4 py-3">
                                  {!showProcessButton && (
                                    <div className="flex flex-col gap-1.5">
                                      <button
                                        onClick={() => setFollowUpLead(lead)}
                                        className="bg-[#a19993] text-white border-none rounded-md px-2.5 py-1.5 text-[11px] font-semibold cursor-pointer"
                                      >
                                        Follow Up
                                      </button>
                                      <button
                                        onClick={() =>
                                          setExpandedLead(
                                            isExpanded ? null : lead.id,
                                          )
                                        }
                                        className="bg-gray-100 text-gray-600 border-none rounded-md px-2.5 py-1.5 text-[11px] cursor-pointer"
                                      >
                                        {isExpanded ? "▲ Less" : "▼ Details"}
                                      </button>
                                      {lead.status === "Lost & Closed" && (
                                        <button
                                          onClick={() =>
                                            setDeleteTarget({
                                              id: lead.id,
                                              name: lead.name,
                                              type: "meta",
                                            })
                                          }
                                          title="Delete lead"
                                          className="bg-red-50 text-red-500 border border-red-200 rounded-md px-2.5 py-1.5 text-[11px] cursor-pointer hover:bg-red-100 transition-all flex items-center gap-1"
                                        >
                                          <MdDelete className="text-sm" />{" "}
                                          Delete
                                        </button>
                                      )}
                                    </div>
                                  )}
                                </td>
                              </>
                            )}
                          </tr>
                          {!isMetaLead && isExpanded && (
                            <tr className="bg-gray-50">
                              <td colSpan={9} className="px-6 py-4">
                                <div className="flex gap-7 flex-wrap">
                                  {[
                                    ["Lead ID", lead.id],
                                    ["Meta ID", lead.meta_lead_id || "—"],
                                    ["Email", lead.email || "—"],
                                    ["Phone", lead.phone || "—"],
                                    ["Channel", lead.channel],
                                    ["Assigned To", lead.assignee || "—"],
                                    ["Status", lead.status],
                                    ["Tag", lead.tag || "—"],
                                    ["Remark", lead.remark || "—"],
                                    [
                                      "Received",
                                      lead.created_at
                                        ? new Date(
                                            lead.created_at,
                                          ).toLocaleString()
                                        : "—",
                                    ],
                                  ].map(([label, val]) => (
                                    <div key={label} className="min-w-[90px]">
                                      <div className="text-[10px] text-gray-400 uppercase font-bold mb-0.5">
                                        {label}
                                      </div>
                                      <div
                                        className="text-sm"
                                        style={{
                                          color:
                                            label === "Status"
                                              ? STATUS_COLORS[val]
                                              : "#333",
                                          fontWeight:
                                            label === "Status" ? 700 : 400,
                                        }}
                                      >
                                        {String(val)}
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </td>
                            </tr>
                          )}
                        </React.Fragment>
                      );
                    })
                  )}
                </tbody>
              </table>
            </div>
            <nav className="flex items-center flex-col md:flex-row justify-between rounded-b-lg px-2 py-1 bg-[#f7f7f7]">
              <span className="text-xs font-normal text-gray-500 mb-4 md:mb-0 block w-full md:inline md:w-auto">
                Showing{" "}
                <span className="font-semibold text-gray-700">
                  {visibleLeads.length > 0 ? indexOfFirst + 1 : 0}–
                  {Math.min(indexOfLast, visibleLeads.length)}
                </span>{" "}
                of{" "}
                <span className="font-semibold text-gray-700">
                  {visibleLeads.length}
                </span>
              </span>
              <ul className="inline-flex -space-x-px rtl:space-x-reverse text-xs h-8">
                <li>
                  <button
                    onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
                    disabled={currentPage === 1}
                    className="flex items-center justify-center px-1 h-8 leading-tight text-gray-500 bg-[#f7f7f7] border-gray-300 rounded-s-lg hover:bg-gray-100"
                  >
                    <MdKeyboardDoubleArrowLeft />
                  </button>
                </li>
                {generatePageNumbers().map((page, i) =>
                  page === "..." ? (
                    <li
                      key={i}
                      className="px-1 h-8 flex items-center justify-center text-gray-500"
                    >
                      <span>...</span>
                    </li>
                  ) : (
                    <li key={i}>
                      <button
                        onClick={() => setCurrentPage(page)}
                        className={`flex items-center justify-center px-3 h-8 leading-tight text-gray-500 bg-[#f7f7f7] border-gray-300 hover:bg-gray-100 ${currentPage === page ? "text-green-500 underline underline-offset-2" : ""}`}
                      >
                        {page}
                      </button>
                    </li>
                  ),
                )}
                <li>
                  <button
                    onClick={() =>
                      setCurrentPage((p) => Math.min(p + 1, totalPages))
                    }
                    disabled={currentPage === totalPages}
                    className="flex items-center justify-center px-1 h-8 leading-tight text-gray-500 bg-[#f7f7f7] border-gray-300 rounded-e-lg hover:bg-gray-100"
                  >
                    <MdKeyboardDoubleArrowRight />
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        )}

        {/* WEBSITE TABLE */}
        {storeTab === "website" && (
          <div className="shadow-md rounded-lg mt-3">
            <div className="overflow-x-auto">
              <table className="w-full text-sm text-left text-gray-500">
                <thead className="text-xs text-gray-400 uppercase bg-green-50 border-b">
                  <tr>
                    <th className="p-4">
                      <input
                        type="checkbox"
                        onChange={handleSelectAll}
                        checked={
                          selectedRows.length === currentLeads.length &&
                          currentLeads.length > 0
                        }
                      />
                    </th>
                    <th className="p-4">Lead ID</th>
                    <th className="p-4">Customer</th>
                    <th className="p-4">Property / Destination</th>
                    <th className="p-4">Check-In → Check-Out</th>
                    <th className="p-4">Location</th>
                    {isWebsiteIncomingView ? (
                      <th className="p-4">Action</th>
                    ) : (
                      <>
                        <th className="p-4">Status</th>
                        <th className="p-4">Assigned To</th>
                        <th className="p-4">Remark</th>
                        <th className="p-4">Actions</th>
                      </>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {(
                    isWebsiteIncomingView
                      ? websiteLoading
                      : processedWebsiteLoading
                  ) ? (
                    <tr>
                      <td
                        colSpan={isWebsiteIncomingView ? 7 : 11}
                        className="text-center py-14 text-gray-400"
                      >
                        Loading website leads…
                      </td>
                    </tr>
                  ) : websiteError && isWebsiteIncomingView ? (
                    <tr>
                      <td
                        colSpan={7}
                        className="text-center py-14 text-red-400"
                      >
                        {websiteError}
                      </td>
                    </tr>
                  ) : currentLeads.length === 0 ? (
                    <tr>
                      <td
                        colSpan={isWebsiteIncomingView ? 7 : 11}
                        className="text-center py-14 text-gray-400"
                      >
                        {isWebsiteIncomingView
                          ? "No new website leads. All incoming leads have been processed."
                          : "No processed website leads found for this stage."}
                      </td>
                    </tr>
                  ) : isWebsiteIncomingView ? (
                    currentLeads.map((lead, idx) => (
                      <tr
                        key={lead.leadId}
                        className={`border-b border-gray-200 hover:bg-gray-100 text-gray-800 ${idx % 2 === 0 ? "bg-white" : "bg-gray-50"}`}
                      >
                        {/* Checkbox on incoming tab too */}
                        <td className="px-4 py-3">
                          <input
                            type="checkbox"
                            onChange={() =>
                              handleRowCheckboxChange(lead.leadId, true)
                            }
                            checked={selectedRows.includes(lead.leadId)}
                          />
                        </td>
                        <td className="px-4 py-3 text-xs font-mono text-indigo-600">
                          {lead.leadId}
                        </td>
                        <td className="px-4 py-3 min-w-[160px]">
                          <div className="font-bold text-gray-800 mb-1">
                            {lead.customerName || "—"}
                          </div>
                          {lead.phone && (
                            <div className="inline-flex items-center gap-1 text-xs text-gray-500">
                              <FaPhone />
                              {lead.phone}
                            </div>
                          )}
                          <br />
                          {lead.email && (
                            <div className="inline-flex items-center gap-1 text-xs text-gray-400">
                              <IoMail />
                              {lead.email}
                            </div>
                          )}
                        </td>
                        <td className="px-4 py-3">
                          <div className="font-semibold text-gray-700 text-xs">
                            {lead.property || "—"}
                          </div>
                          <div className="text-xs text-gray-400 mt-0.5">
                            {lead.destination || "—"}
                          </div>
                        </td>
                        <td className="px-4 py-3 text-xs text-gray-600 whitespace-nowrap">
                          <div className="inline-flex items-center gap-1">
                            <FaCalendarAlt className="text-gray-400" />
                            {lead.checkin
                              ? new Date(lead.checkin).toLocaleDateString()
                              : "N/A"}
                            {" → "}
                            {lead.checkout
                              ? new Date(lead.checkout).toLocaleDateString()
                              : "N/A"}
                          </div>
                        </td>
                        <td className="px-4 py-3 text-xs text-gray-500">
                          <div className="inline-flex items-center gap-1">
                            {[lead.city, lead.state, lead.country]
                              .filter(Boolean)
                              .join(", ") || "—"}
                          </div>
                        </td>
                        <td className="px-4 py-3">
                          <ProcessWebsiteLeadButton
                            lead={lead}
                            onProcessed={handleWebsiteLeadProcessed}
                          />
                        </td>
                      </tr>
                    ))
                  ) : (
                    currentLeads.map((lead, idx) => {
                      const dimmed = updatingId === lead.id;
                      const isRawIncoming = lead._isIncoming === true;
                      return (
                        <tr
                          key={lead.id || lead.leadId}
                          className={`border-b border-gray-200 hover:bg-gray-100 text-gray-800 transition-opacity ${idx % 2 === 0 ? "bg-white" : "bg-gray-50"}`}
                          style={{ opacity: dimmed ? 0.55 : 1 }}
                        >
                          <td className="px-4 py-3">
                            <input
                              type="checkbox"
                              onChange={() =>
                                handleRowCheckboxChange(
                                  isRawIncoming ? lead.leadId : lead.id,
                                  isRawIncoming,
                                )
                              }
                              checked={selectedRows.includes(
                                isRawIncoming ? lead.leadId : lead.id,
                              )}
                            />
                          </td>
                          <td className="px-4 py-3 text-xs font-mono text-indigo-600">
                            <div className="flex items-center gap-1.5">
                              {isRawIncoming
                                ? lead.leadId
                                : `WL-${lead.original_lead_id}`}
                              {isRawIncoming && (
                                <span className="text-[10px] bg-amber-100 text-amber-600 px-1.5 py-0.5 rounded-full font-bold whitespace-nowrap">
                                  Unprocessed
                                </span>
                              )}
                            </div>
                          </td>
                          <td className="px-4 py-3 min-w-[160px]">
                            <div className="font-bold text-gray-800 mb-1">
                              {isRawIncoming
                                ? lead.customerName || "—"
                                : lead.customer_name || "—"}
                            </div>
                            {lead.phone && (
                              <div className="inline-flex items-center gap-1 text-xs text-gray-500">
                                <FaPhone />
                                {lead.phone}
                              </div>
                            )}
                            <br />
                            {lead.email && (
                              <div className="inline-flex items-center gap-1 text-xs text-gray-400">
                                <IoMail />
                                {lead.email}
                              </div>
                            )}
                            {!isRawIncoming && lead.converted === 1 && (
                              <div className="mt-1">
                                <span className="text-[10px] bg-green-100 text-green-700 px-1.5 py-0.5 rounded-full font-bold">
                                  ✓ Converted
                                </span>
                              </div>
                            )}
                          </td>
                          <td className="px-4 py-3">
                            <div className="font-semibold text-gray-700 text-xs">
                              {lead.property || "—"}
                            </div>
                            <div className="text-xs text-gray-400 mt-0.5">
                              {lead.destination || "—"}
                            </div>
                          </td>
                          <td className="px-4 py-3 text-xs text-gray-600 whitespace-nowrap">
                            <div className="inline-flex items-center gap-1">
                              <FaCalendarAlt className="text-gray-400" />
                              {isRawIncoming
                                ? lead.checkin
                                  ? new Date(lead.checkin).toLocaleDateString()
                                  : "—"
                                : lead.check_in
                                  ? new Date(lead.check_in).toLocaleDateString()
                                  : "—"}
                              {" → "}
                              {isRawIncoming
                                ? lead.checkout
                                  ? new Date(lead.checkout).toLocaleDateString()
                                  : "—"
                                : lead.check_out
                                  ? new Date(
                                      lead.check_out,
                                    ).toLocaleDateString()
                                  : "—"}
                            </div>
                          </td>
                          <td className="px-4 py-3 text-xs text-gray-500">
                            <div className="inline-flex items-center gap-1">
                              {[lead.city, lead.state, lead.country]
                                .filter(Boolean)
                                .join(", ") || "—"}
                            </div>
                          </td>
                          <td className="px-4 py-3">
                            {isRawIncoming ? (
                              <ProcessWebsiteLeadButton
                                lead={lead}
                                onProcessed={handleWebsiteLeadProcessed}
                              />
                            ) : (
                              <select
                                value={lead.status || "New Lead"}
                                onChange={(e) =>
                                  patchWebsiteLead(
                                    lead.id,
                                    "status",
                                    e.target.value,
                                  )
                                }
                                className="p-1.5 rounded-md text-[11px] font-bold cursor-pointer outline-none border"
                                style={{
                                  borderColor:
                                    WEBSITE_STATUS_COLORS[lead.status] ||
                                    "#ccc",
                                  background:
                                    (WEBSITE_STATUS_COLORS[lead.status] ||
                                      "#ccc") + "18",
                                  color:
                                    WEBSITE_STATUS_COLORS[lead.status] ||
                                    "#555",
                                }}
                              >
                                {WEBSITE_STATUSES.map((s) => (
                                  <option key={s} value={s}>
                                    {s}
                                  </option>
                                ))}
                              </select>
                            )}
                          </td>
                          <td className="px-4 py-3">
                            {isRawIncoming ? (
                              <span className="text-xs text-gray-300">—</span>
                            ) : (
                              <select
                                value={lead.assignee || "Unassigned"}
                                onChange={(e) =>
                                  patchWebsiteLead(
                                    lead.id,
                                    "assignee",
                                    e.target.value,
                                  )
                                }
                                className="p-1.5 rounded-md border border-gray-200 bg-white text-xs cursor-pointer outline-none"
                              >
                                {TEAM.map((t) => (
                                  <option key={t}>{t}</option>
                                ))}
                              </select>
                            )}
                          </td>
                          <td className="px-4 py-3">
                            {isRawIncoming ? (
                              <span className="text-xs text-gray-300">—</span>
                            ) : lead.remark ? (
                              <div
                                onClick={() => addWebsiteRemark(lead)}
                                title="Click to edit"
                                className="text-xs text-gray-600 bg-gray-50 rounded-md px-2 py-1 max-w-[160px] cursor-pointer leading-snug"
                              >
                                {lead.remark}
                              </div>
                            ) : (
                              <button
                                onClick={() => addWebsiteRemark(lead)}
                                className="text-[11px] text-indigo-500 bg-transparent border border-dashed border-indigo-400 rounded-md px-2 py-1 cursor-pointer"
                              >
                                + Add Remark
                              </button>
                            )}
                          </td>
                          {/* <td className="px-4 py-3">
                            {isRawIncoming ? (
                              <span className="text-xs text-gray-300">—</span>
                            ) : (
                              <button
                                onClick={() =>
                                  setFollowUpLead({
                                    ...lead,
                                    name: lead.customer_name,
                                  })
                                }
                                className="bg-[#a19993] text-white border-none rounded-md px-2.5 py-1.5 text-[11px] font-semibold cursor-pointer w-20"
                              >
                                Follow Up
                              </button>
                            )}
                          </td> */}
                          <td className="px-4 py-3">
                            {isRawIncoming ? (
                              <span className="text-xs text-gray-300">—</span>
                            ) : (
                              <div className="flex flex-col gap-1.5">
                                <button
                                  onClick={() =>
                                    setFollowUpLead({
                                      ...lead,
                                      name: lead.customer_name,
                                    })
                                  }
                                  className="bg-[#a19993] text-white border-none rounded-md px-2.5 py-1.5 text-[11px] font-semibold cursor-pointer w-20"
                                >
                                  Follow Up
                                </button>
                                {lead.status === "Lost & Closed" && (
                                  <button
                                    onClick={() =>
                                      setDeleteTarget({
                                        id: lead.id,
                                        name: lead.customer_name,
                                        type: "website",
                                      })
                                    }
                                    title="Delete lead"
                                    className="bg-red-50 text-red-500 border border-red-200 rounded-md px-2.5 py-1.5 text-[11px] cursor-pointer hover:bg-red-100 transition-all flex items-center gap-1"
                                  >
                                    <MdDelete className="text-sm" /> Delete
                                  </button>
                                )}
                              </div>
                            )}
                          </td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
            </div>
            <nav className="flex items-center flex-col md:flex-row justify-between rounded-b-lg px-2 py-1 bg-[#f7f7f7]">
              <span className="text-xs font-normal text-gray-500 mb-4 md:mb-0 block w-full md:inline md:w-auto">
                Showing{" "}
                <span className="font-semibold text-gray-700">
                  {visibleWebsiteLeads.length > 0 ? indexOfFirst + 1 : 0}–
                  {Math.min(indexOfLast, visibleWebsiteLeads.length)}
                </span>{" "}
                of{" "}
                <span className="font-semibold text-gray-700">
                  {visibleWebsiteLeads.length}
                </span>
              </span>
              <ul className="inline-flex -space-x-px rtl:space-x-reverse text-xs h-8">
                <li>
                  <button
                    onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
                    disabled={currentPage === 1}
                    className="flex items-center justify-center px-1 h-8 leading-tight text-gray-500 bg-[#f7f7f7] border-gray-300 rounded-s-lg hover:bg-gray-100"
                  >
                    <MdKeyboardDoubleArrowLeft />
                  </button>
                </li>
                {generatePageNumbers().map((page, i) =>
                  page === "..." ? (
                    <li
                      key={i}
                      className="px-1 h-8 flex items-center justify-center text-gray-500"
                    >
                      <span>...</span>
                    </li>
                  ) : (
                    <li key={i}>
                      <button
                        onClick={() => setCurrentPage(page)}
                        className={`flex items-center justify-center px-3 h-8 leading-tight text-gray-500 bg-[#f7f7f7] border-gray-300 hover:bg-gray-100 ${currentPage === page ? "text-green-500 underline underline-offset-2" : ""}`}
                      >
                        {page}
                      </button>
                    </li>
                  ),
                )}
                <li>
                  <button
                    onClick={() =>
                      setCurrentPage((p) => Math.min(p + 1, totalPages))
                    }
                    disabled={currentPage === totalPages}
                    className="flex items-center justify-center px-1 h-8 leading-tight text-gray-500 bg-[#f7f7f7] border-gray-300 rounded-e-lg hover:bg-gray-100"
                  >
                    <MdKeyboardDoubleArrowRight />
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        )}
      </main>

      {/* Modals */}
      {followUpLead && (
        <FollowUpModal
          lead={followUpLead}
          onClose={() => setFollowUpLead(null)}
        />
      )}
      {showCreate && (
        <CreateLeadModal
          onClose={() => setShowCreate(false)}
          onCreated={handleCreated}
        />
      )}

      {/* Convert Confirm */}
      {showConvertModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <div className="bg-white rounded-2xl p-7 w-[420px] shadow-2xl">
            <div className="font-bold text-base mb-2 text-gray-800">
              Convert to Booking
            </div>
            <p className="text-sm text-gray-500 mb-4">
              Convert{" "}
              <b className="text-gray-800">
                {selectedRows.length} lead{selectedRows.length > 1 ? "s" : ""}
              </b>{" "}
              to booking{selectedRows.length > 1 ? "s" : ""}?
            </p>
            <p className="text-xs text-amber-600 mb-4">
              {storeTab === "website"
                ? "These website leads will be marked as converted and inserted into bookings."
                : "The leads will be removed from the leads table and inserted into bookings."}
            </p>
            <div className="bg-gray-50 rounded-lg px-3 py-2 mb-5 max-h-36 overflow-y-auto">
              {storeTab === "meta"
                ? leads
                    .filter((l) => selectedRows.includes(l.id))
                    .map((l) => (
                      <div
                        key={l.id}
                        className="flex items-center justify-between py-1 border-b border-gray-100 last:border-0"
                      >
                        <span className="text-xs font-semibold text-gray-700">
                          {l.name || "—"}
                        </span>
                        <span className="text-[11px] text-gray-400">
                          {channelToSource(l.channel)}
                        </span>
                      </div>
                    ))
                : processedWebsiteLeads
                    .filter((l) => selectedRows.includes(l.id))
                    .map((l) => (
                      <div
                        key={l.id}
                        className="flex items-center justify-between py-1 border-b border-gray-100 last:border-0"
                      >
                        <span className="text-xs font-semibold text-gray-700">
                          {l.customer_name || "—"}
                        </span>
                        <span className="text-[11px] text-gray-400">
                          {l.property || "Website"}
                        </span>
                      </div>
                    ))}
            </div>
            <div className="flex gap-3">
              <button
                onClick={() => setShowConvertModal(false)}
                disabled={converting}
                className="flex-1 py-2.5 rounded-lg border border-gray-200 bg-white text-gray-500 font-semibold text-sm cursor-pointer"
              >
                Cancel
              </button>
              <button
                onClick={async () => {
                  setShowConvertModal(false);
                  storeTab === "meta"
                    ? await handleConvertToBooking()
                    : await handleWebsiteConvertToBooking();
                }}
                disabled={converting}
                className="flex-1 py-2.5 rounded-lg bg-[#1D2826] text-white font-bold text-sm cursor-pointer hover:bg-[#2d3d3a] transition-colors"
              >
                {converting ? "Converting…" : "Yes, Convert"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Convert Result */}
      {convertResult && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <div className="bg-white rounded-2xl p-7 w-[420px] shadow-2xl">
            {convertResult.errors.length === 0 ? (
              <>
                <div className="text-center mb-4">
                  <div className="text-4xl mb-2"></div>
                  <div className="font-bold text-base text-gray-800">
                    {convertResult.bookingids.length} Booking
                    {convertResult.bookingids.length > 1 ? "s" : ""} Created
                  </div>
                  <p className="text-xs text-gray-400 mt-1">
                    Successfully converted to bookings
                  </p>
                </div>
                <div className="bg-green-50 rounded-lg px-3 py-2 mb-5">
                  {convertResult.bookingids.map((bid, i) => (
                    <div
                      key={i}
                      className="text-xs text-green-700 font-semibold py-0.5"
                    >
                      Booking ID: <span className="font-bold">{bid}</span>
                    </div>
                  ))}
                </div>
              </>
            ) : (
              <>
                <div className="text-center mb-4">
                  <div className="text-4xl mb-2">⚠️</div>
                  <div className="font-bold text-base text-gray-800">
                    Partial Conversion
                  </div>
                  <p className="text-xs text-gray-400 mt-1">
                    {convertResult.bookingids.length} succeeded ·{" "}
                    {convertResult.errors.length} failed
                  </p>
                </div>
                {convertResult.bookingids.length > 0 && (
                  <div className="bg-green-50 rounded-lg px-3 py-2 mb-3">
                    <p className="text-[10px] text-green-600 font-bold uppercase mb-1">
                      Created
                    </p>
                    {convertResult.bookingids.map((bid, i) => (
                      <div key={i} className="text-xs text-green-700">
                        Booking ID: <b>{bid}</b>
                      </div>
                    ))}
                  </div>
                )}
                <div className="bg-red-50 rounded-lg px-3 py-2 mb-5">
                  <p className="text-[10px] text-red-500 font-bold uppercase mb-1">
                    Failed
                  </p>
                  {convertResult.errors.map((e, i) => (
                    <div key={i} className="text-xs text-red-600">
                      <b>{e.name || e.id}</b>: {e.error}
                    </div>
                  ))}
                </div>
              </>
            )}
            <button
              onClick={() => setConvertResult(null)}
              className="w-full py-2.5 rounded-lg bg-[#1D2826] text-white font-bold text-sm cursor-pointer"
            >
              Done
            </button>
          </div>
        </div>
      )}

      {/* Bulk Process Confirm */}
      {showBulkProcessModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <div className="bg-white rounded-2xl p-7 w-[420px] shadow-2xl">
            <div className="font-bold text-base mb-2 text-gray-800">
              Process Leads
            </div>
            <p className="text-sm text-gray-500 mb-4">
              Do you want to process{" "}
              <b className="text-gray-800">
                {selectedUnprocessedWebsiteCount} lead
                {selectedUnprocessedWebsiteCount > 1 ? "s" : ""}
              </b>
              ?
            </p>
            <p className="text-xs text-green-600 mb-4">
              The selected leads will be saved to the processed leads table and
              become manageable in the pipeline.
            </p>
            <div className="bg-gray-50 rounded-lg px-3 py-2 mb-5 max-h-36 overflow-y-auto">
              {currentLeads
                .filter((l) => l._isIncoming && selectedRows.includes(l.leadId))
                .map((l) => (
                  <div
                    key={l.leadId}
                    className="flex items-center justify-between py-1 border-b border-gray-100 last:border-0"
                  >
                    <span className="text-xs font-semibold text-gray-700">
                      {l.customerName || "—"}
                    </span>
                    <span className="text-[11px] text-gray-400 font-mono">
                      {l.leadId}
                    </span>
                  </div>
                ))}
            </div>

            <div className="flex gap-3">
              <button
                onClick={() => setShowBulkProcessModal(false)}
                disabled={bulkProcessing}
                className="flex-1 py-2.5 rounded-lg border border-gray-200 bg-white text-gray-500 font-semibold text-sm cursor-pointer"
              >
                Cancel
              </button>
              <button
                onClick={async () => {
                  setShowBulkProcessModal(false);
                  await handleBulkProcessWebsiteLeads();
                }}
                disabled={bulkProcessing}
                className="flex-1 py-2.5 rounded-lg bg-green-600 text-white font-bold text-sm cursor-pointer hover:bg-green-700 transition-colors"
              >
                {bulkProcessing ? "Processing…" : "Yes, Process"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Bulk Process Result */}
      {bulkProcessResult && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <div className="bg-white rounded-2xl p-7 w-[420px] shadow-2xl">
            {bulkProcessResult.errors.length === 0 ? (
              <>
                <div className="text-center mb-4">
                  <div className="text-4xl mb-2"></div>
                  <div className="font-bold text-base text-gray-800">
                    {bulkProcessResult.processed.length} Lead
                    {bulkProcessResult.processed.length > 1 ? "s" : ""}{" "}
                    Processed
                  </div>
                  <p className="text-xs text-gray-400 mt-1">
                    Now visible in the pipeline tabs
                  </p>
                </div>
                <div className="bg-indigo-50 rounded-lg px-3 py-2 mb-5">
                  {bulkProcessResult.processed.map((name, i) => (
                    <div
                      key={i}
                      className="text-xs text-indigo-700 font-semibold py-0.5"
                    >
                      ✓ {name}
                    </div>
                  ))}
                </div>
              </>
            ) : (
              <>
                <div className="text-center mb-4">
                  <div className="text-4xl mb-2">⚠️</div>
                  <div className="font-bold text-base text-gray-800">
                    Partial Processing
                  </div>
                  <p className="text-xs text-gray-400 mt-1">
                    {bulkProcessResult.processed.length} succeeded ·{" "}
                    {bulkProcessResult.errors.length} failed
                  </p>
                </div>
                {bulkProcessResult.processed.length > 0 && (
                  <div className="bg-indigo-50 rounded-lg px-3 py-2 mb-3">
                    <p className="text-[10px] text-indigo-600 font-bold uppercase mb-1">
                      Processed
                    </p>
                    {bulkProcessResult.processed.map((name, i) => (
                      <div key={i} className="text-xs text-indigo-700">
                        ✓ {name}
                      </div>
                    ))}
                  </div>
                )}
                <div className="bg-red-50 rounded-lg px-3 py-2 mb-5">
                  <p className="text-[10px] text-red-500 font-bold uppercase mb-1">
                    Failed
                  </p>
                  {bulkProcessResult.errors.map((e, i) => (
                    <div key={i} className="text-xs text-red-600">
                      <b>{e.name}</b>: {e.error}
                    </div>
                  ))}
                </div>
              </>
            )}
            <button
              onClick={() => setBulkProcessResult(null)}
              className="w-full py-2.5 rounded-lg bg-[#1D2826] text-white font-bold text-sm cursor-pointer"
            >
              Done
            </button>
          </div>
        </div>
      )}

      {/* Toast */}
      {toastMsg && <Toast msg={toastMsg} onDone={() => setToastMsg("")} />}

      {deleteTarget && (
        <DeleteLeadModal
          leadName={deleteTarget.name || "this lead"}
          onConfirm={handleDeleteLead}
          onCancel={() => setDeleteTarget(null)}
          deleting={deleting}
        />
      )}
    </div>
  );
};

export default InquireLeads;

//10thjune
// import React, { useState, useEffect, useRef, useCallback } from "react";
// import Menubar from "../Menubar/Menubar";
// import { Outlet } from "react-router-dom";
// import "../Dashboard/Dashboard.css";
// import { Tooltip } from "antd";
// import {
//   MdKeyboardDoubleArrowLeft,
//   MdKeyboardDoubleArrowRight,
// } from "react-icons/md";
// import { IoLogoFacebook, IoLogoWhatsapp } from "react-icons/io";
// import { RiInstagramFill, RiWhatsappFill } from "react-icons/ri";
// import { TbDeviceAnalytics, TbRefresh } from "react-icons/tb";
// import { AiFillInstagram } from "react-icons/ai";
// import { FaFacebookSquare, FaPhone } from "react-icons/fa";
// import { FaCalendarAlt } from "react-icons/fa";
// import { IoMail } from "react-icons/io5";
// import { IoIosTime } from "react-icons/io";
// import { RxOpenInNewWindow } from "react-icons/rx";
// import { MdFileDownloadDone } from "react-icons/md";

// const API = `${process.env.REACT_APP_BACKEND_URL || "https://dash.zorbastays.com"}/web-backend`;

// const STATUSES = [
//   "New Enquiry",
//   "Call Not Picked",
//   "Contacted",
//   "Qualified",
//   "Plan & Quote Sent",
//   "In Pipeline",
//   "Negotiating",
//   "Awaiting Payment",
//   "Lost & Closed",
// ];
// const STATUS_COLORS = {
//   "New Enquiry": "#6366f1",
//   "Call Not Picked": "#f59e0b",
//   Contacted: "#3b82f6",
//   Qualified: "#8b5cf6",
//   "Plan & Quote Sent": "#06b6d4",
//   "In Pipeline": "#10b981",
//   Negotiating: "#f97316",
//   "Awaiting Payment": "#ec4899",
//   Booked: "#22c55e",
//   "Lost & Closed": "#ef4444",
// };
// const PIPELINE_STAGES = [
//   {
//     name: "Incoming",
//     color: "bg-emerald-100 text-emerald-600",
//     status: "Incoming Leads",
//   },
//   {
//     name: "Processed",
//     color: "bg-yellow-100 text-yellow-600",
//     status: "All Processed Leads",
//   },
//   {
//     name: "New Enquiry",
//     color: "bg-purple-100 text-purple-500",
//     status: "New Enquiry",
//   },
//   {
//     name: "Call Not Picked",
//     color: "bg-sky-100 text-sky-600",
//     status: "Call Not Picked",
//   },
//   {
//     name: "Contacted",
//     color: "bg-pink-100 text-pink-600",
//     status: "Contacted",
//   },
//   {
//     name: "Qualified",
//     color: "bg-teal-100 text-teal-700",
//     status: "Qualified",
//   },
//   {
//     name: "Plan/Quote Sent",
//     color: "bg-red-100 text-red-500",
//     status: "Plan & Quote Sent",
//   },
//   {
//     name: "In Pipeline",
//     color: "bg-blue-100 text-blue-600",
//     status: "In Pipeline",
//   },
//   {
//     name: "Negotiating",
//     color: "bg-lime-100 text-lime-700",
//     status: "Negotiating",
//   },
//   {
//     name: "Awaiting Payment",
//     color: "bg-green-100 text-green-700",
//     status: "Awaiting Payment",
//   },
//   {
//     name: "Lost & Closed",
//     color: "bg-slate-200 text-slate-700",
//     status: "Lost & Closed",
//   },
// ];
// const WEBSITE_STATUSES = [
//   "New Lead",
//   "Contacted",
//   "Qualified",
//   "Plan & Quote Sent",
//   "In Pipeline",
//   "Negotiating",
//   "Awaiting Payment",
//   "Lost & Closed",
// ];
// const WEBSITE_STATUS_COLORS = {
//   "New Lead": "#6366f1",
//   Contacted: "#3b82f6",
//   Qualified: "#8b5cf6",
//   "Plan & Quote Sent": "#06b6d4",
//   "In Pipeline": "#10b981",
//   Negotiating: "#f97316",
//   "Awaiting Payment": "#ec4899",
//   "Lost & Closed": "#ef4444",
// };
// const WEBSITE_PIPELINE_STAGES = [
//   { name: "All", color: "bg-orange-100 text-orange-600", status: "All Leads" },
//   {
//     name: "Incoming",
//     color: "bg-emerald-100 text-emerald-600",
//     status: "Incoming Leads",
//   },
//   {
//     name: "Processed",
//     color: "bg-yellow-100 text-yellow-600",
//     status: "All Processed Leads",
//   },
//   {
//     name: "New Lead",
//     color: "bg-purple-100 text-purple-500",
//     status: "New Lead",
//   },
//   {
//     name: "Contacted",
//     color: "bg-pink-100 text-pink-600",
//     status: "Contacted",
//   },
//   {
//     name: "Qualified",
//     color: "bg-teal-100 text-teal-700",
//     status: "Qualified",
//   },
//   {
//     name: "Plan/Quote Sent",
//     color: "bg-red-100 text-red-500",
//     status: "Plan & Quote Sent",
//   },
//   {
//     name: "In Pipeline",
//     color: "bg-blue-100 text-blue-600",
//     status: "In Pipeline",
//   },
//   {
//     name: "Negotiating",
//     color: "bg-lime-100 text-lime-700",
//     status: "Negotiating",
//   },
//   {
//     name: "Awaiting Payment",
//     color: "bg-green-100 text-green-700",
//     status: "Awaiting Payment",
//   },
//   {
//     name: "Lost & Closed",
//     color: "bg-slate-200 text-slate-700",
//     status: "Lost & Closed",
//   },
// ];
// const CHANNELS = {
//   "Instagram DM": {
//     color: "#e1306c",
//     bg: "#fce4ec",
//     icon: <AiFillInstagram />,
//   },
//   "Facebook Lead": {
//     color: "#1877f2",
//     bg: "#e3f2fd",
//     icon: <FaFacebookSquare />,
//   },
//   WhatsApp: { color: "#25d366", bg: "#e8f5e9", icon: <RiWhatsappFill /> },
// };
// const TAG_COLORS = { Hot: "#ef4444", Warm: "#f97316", Cold: "#64748b" };
// const TEAM = ["Unassigned", "Parth", "Altaf", "Riya", "Dev", "Sneha"];

// function timeAgo(dateStr) {
//   if (!dateStr) return "—";
//   const diff = (Date.now() - new Date(dateStr)) / 1000;
//   if (diff < 60) return "Just now";
//   if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
//   if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
//   return `${Math.floor(diff / 86400)}d ago`;
// }
// function channelToSource(channel) {
//   return (
//     {
//       "Facebook Lead": "Facebook",
//       "Instagram DM": "Instagram",
//       WhatsApp: "WhatsApp",
//     }[channel] ||
//     channel ||
//     "Lead"
//   );
// }

// // ─── Toast ────────────────────────────────────────────────────────────────────
// function Toast({ msg, onDone }) {
//   useEffect(() => {
//     const t = setTimeout(onDone, 3000);
//     return () => clearTimeout(t);
//   }, [onDone]);
//   return (
//     <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-[999] bg-gray-800 text-white text-sm font-medium px-5 py-3 rounded-xl shadow-2xl animate-bounce-once">
//       {msg}
//     </div>
//   );
// }

// // ─── Confirmation Modal ────────────────────────────────────────────────────────
// function ConfirmProcessModal({ onConfirm, onCancel }) {
//   return (
//     <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
//       <div className="bg-white rounded-xl shadow-xl p-6 max-w-sm w-full mx-4">
//         <h3 className="text-base font-bold text-gray-800 mb-2">
//           Process Lead?
//         </h3>
//         <p className="text-sm text-gray-500 mb-5">
//           This will save the lead to the database. Do you want to continue?
//         </p>
//         <div className="flex gap-3 justify-end">
//           <button
//             onClick={onCancel}
//             className="px-4 py-1.5 rounded-md text-sm font-semibold text-gray-600 bg-gray-100 hover:bg-gray-200 transition-all"
//           >
//             Cancel
//           </button>
//           <button
//             onClick={onConfirm}
//             className="px-4 py-1.5 rounded-md text-sm font-semibold text-white bg-[#797d72] hover:bg-[#5a5e55] transition-all"
//           >
//             Yes, Process
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }

// // ─── Process Meta Lead Button ──────────────────────────────────────────────────
// function ProcessMetaLeadButton({ lead, onProcessed }) {
//   const [processing, setProcessing] = useState(false);
//   const [done, setDone] = useState(false);
//   const [showConfirm, setShowConfirm] = useState(false);

//   const handleProcess = async () => {
//     setProcessing(true);
//     try {
//       const meta_lead_id = lead.id.startsWith("meta_")
//         ? lead.id.replace("meta_", "")
//         : lead.id;
//       const res = await fetch(`${API}/leads/process-meta`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           meta_lead_id,
//           name: lead.name,
//           phone: lead.phone || "",
//           email: lead.email || "",
//           channel: lead.channel || "Facebook Lead",
//           enquiry: lead.enquiry || "",
//           form_id: lead.form_id || "",
//           page_id: lead.page_id || "",
//           field_data: lead.field_data || [],
//           raw_payload: lead,
//         }),
//       });
//       if (!res.ok) throw new Error("Failed " + res.status);
//       const { lead: savedLead, already_existed } = await res.json();
//       setDone(true);
//       onProcessed(savedLead, already_existed);
//     } catch (e) {
//       alert("Error processing lead: " + e.message);
//     } finally {
//       setProcessing(false);
//     }
//   };

//   if (done)
//     return (
//       <span className="text-xs text-green-500 font-bold">✓ Saved to DB</span>
//     );

//   return (
//     <>
//       {showConfirm && (
//         <ConfirmProcessModal
//           onConfirm={() => {
//             setShowConfirm(false);
//             handleProcess();
//           }}
//           onCancel={() => setShowConfirm(false)}
//         />
//       )}
//       <button
//         onClick={() => setShowConfirm(true)}
//         disabled={processing}
//         className={`px-3 py-1.5 rounded-md text-white text-xs font-bold whitespace-nowrap transition-all ${
//           processing
//             ? "bg-gray-400 cursor-not-allowed"
//             : "bg-[#aeb3a4] hover:bg-[#797d72] cursor-pointer"
//         }`}
//       >
//         {processing ? "Saving…" : "Process Lead"}
//       </button>
//     </>
//   );
// }

// // ─── Process Website Lead Button ──────────────────────────────────────────────
// function ProcessWebsiteLeadButton({ lead, onProcessed }) {
//   const [processing, setProcessing] = useState(false);
//   const [done, setDone] = useState(false);
//   const [showConfirm, setShowConfirm] = useState(false);

//   const handleProcess = async () => {
//     setProcessing(true);
//     try {
//       const res = await fetch(`${API}/website-leads/process`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ leadId: lead.leadId }),
//       });
//       if (!res.ok) throw new Error("Failed " + res.status);
//       const { lead: savedLead, already_existed } = await res.json();
//       setDone(true);
//       onProcessed(savedLead, already_existed);
//     } catch (e) {
//       alert("Error processing lead: " + e.message);
//     } finally {
//       setProcessing(false);
//     }
//   };

//   if (done)
//     return (
//       <span className="text-xs text-green-500 font-bold">✓ Saved to DB</span>
//     );

//   return (
//     <>
//       {showConfirm && (
//         <ConfirmProcessModal
//           onConfirm={() => {
//             setShowConfirm(false);
//             handleProcess();
//           }}
//           onCancel={() => setShowConfirm(false)}
//         />
//       )}
//       <button
//         onClick={() => setShowConfirm(true)}
//         disabled={processing}
//         className={`px-3 py-1.5 rounded-md text-white text-xs font-bold whitespace-nowrap transition-all ${
//           processing
//             ? "bg-gray-400 cursor-not-allowed"
//             : "bg-[#aeb3a4] hover:bg-[#797d72] cursor-pointer"
//         }`}
//       >
//         {processing ? "Saving…" : "Process Lead"}
//       </button>
//     </>
//   );
// }

// // ─── Follow Up Modal ──────────────────────────────────────────────────────────
// function FollowUpModal({ lead, onClose }) {
//   const [type, setType] = useState("whatsapp");
//   const [msg, setMsg] = useState("");
//   const [sent, setSent] = useState(false);
//   const send = () => {
//     setSent(true);
//     setTimeout(onClose, 1600);
//   };
//   return (
//     <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
//       <div className="bg-white rounded-2xl p-7 w-[420px] shadow-2xl">
//         {sent ? (
//           <div className="text-center py-6">
//             <div className="text-5xl">✅</div>
//             <div className="text-base font-bold mt-3">Follow-up Sent!</div>
//           </div>
//         ) : (
//           <>
//             <div className="font-bold text-base mb-1">Send Follow-Up</div>
//             <div className="text-xs text-gray-400 mb-4">
//               To: <b>{lead.name || lead.customerName}</b>
//               {lead.phone ? ` · ${lead.phone}` : ""}
//             </div>
//             <div className="flex gap-2 mb-4">
//               {["whatsapp", "email"].map((t) => (
//                 <button
//                   key={t}
//                   onClick={() => setType(t)}
//                   className={`flex-1 py-2 rounded-lg font-semibold text-sm cursor-pointer border-2 transition-all ${type === t ? "border-indigo-500 bg-indigo-50 text-indigo-600" : "border-gray-200 bg-white text-gray-500"}`}
//                 >
//                   {t === "whatsapp" ? " WhatsApp" : " Email"}
//                 </button>
//               ))}
//             </div>
//             <textarea
//               value={msg}
//               onChange={(e) => setMsg(e.target.value)}
//               rows={4}
//               placeholder={`Write your ${type} message…`}
//               className="w-full p-3 rounded-lg border border-gray-200 text-sm resize-y outline-none focus:border-indigo-400 font-[inherit]"
//             />
//             <div className="flex gap-3 mt-4">
//               <button
//                 onClick={onClose}
//                 className="flex-1 py-2.5 rounded-lg border border-gray-200 bg-white text-gray-500 font-semibold cursor-pointer"
//               >
//                 Cancel
//               </button>
//               <button
//                 onClick={send}
//                 disabled={!msg}
//                 className={`flex-1 py-2.5 rounded-lg text-white font-bold cursor-pointer ${msg ? "bg-[#25d366] hover:bg-green-600" : "bg-gray-300 cursor-not-allowed"}`}
//               >
//                 Send
//               </button>
//             </div>
//           </>
//         )}
//       </div>
//     </div>
//   );
// }

// // ─── Create Lead Modal ────────────────────────────────────────────────────────
// function CreateLeadModal({ onClose, onCreated }) {
//   const [form, setForm] = useState({
//     name: "",
//     phone: "",
//     email: "",
//     channel: "Instagram DM",
//     enquiry: "",
//     tag: "Warm",
//     assignee: "Unassigned",
//   });
//   const [saving, setSaving] = useState(false);
//   const [err, setErr] = useState("");
//   const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));
//   const handleSubmit = async () => {
//     if (!form.name.trim()) {
//       setErr("Name is required");
//       return;
//     }
//     setSaving(true);
//     setErr("");
//     try {
//       const res = await fetch(`${API}/leads`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(form),
//       });
//       if (!res.ok) throw new Error("Server error " + res.status);
//       onCreated(await res.json());
//       onClose();
//     } catch (e) {
//       setErr(e.message);
//     } finally {
//       setSaving(false);
//     }
//   };
//   const inp =
//     "w-full p-2.5 rounded-lg border border-gray-200 text-sm outline-none focus:border-indigo-400 mb-2.5 font-[inherit] box-border";
//   return (
//     <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
//       <div className="bg-white rounded-2xl p-7 w-[460px] shadow-2xl max-h-[90vh] overflow-y-auto">
//         <div className="font-bold text-base mb-4">➕ Add New Lead</div>
//         <input
//           className={inp}
//           placeholder="Full Name *"
//           value={form.name}
//           onChange={(e) => set("name", e.target.value)}
//         />
//         <input
//           className={inp}
//           placeholder="Phone Number"
//           value={form.phone}
//           onChange={(e) => set("phone", e.target.value)}
//         />
//         <input
//           className={inp}
//           placeholder="Email"
//           type="email"
//           value={form.email}
//           onChange={(e) => set("email", e.target.value)}
//         />
//         <select
//           className={inp}
//           value={form.channel}
//           onChange={(e) => set("channel", e.target.value)}
//         >
//           {Object.keys(CHANNELS).map((c) => (
//             <option key={c}>{c}</option>
//           ))}
//         </select>
//         <textarea
//           className={`${inp} resize-y`}
//           placeholder="Enquiry / Message"
//           value={form.enquiry}
//           rows={3}
//           onChange={(e) => set("enquiry", e.target.value)}
//         />
//         <div className="flex gap-2.5 mb-2.5">
//           <select
//             className="flex-1 p-2.5 rounded-lg border border-gray-200 text-sm outline-none focus:border-indigo-400 font-[inherit]"
//             value={form.tag}
//             onChange={(e) => set("tag", e.target.value)}
//           >
//             {["Hot", "Warm", "Cold"].map((t) => (
//               <option key={t}>{t}</option>
//             ))}
//           </select>
//           <select
//             className="flex-1 p-2.5 rounded-lg border border-gray-200 text-sm outline-none focus:border-indigo-400 font-[inherit]"
//             value={form.assignee}
//             onChange={(e) => set("assignee", e.target.value)}
//           >
//             {TEAM.map((t) => (
//               <option key={t}>{t}</option>
//             ))}
//           </select>
//         </div>
//         {err && <div className="text-red-500 text-xs mb-2">⚠ {err}</div>}
//         <div className="flex gap-2.5 mt-1.5">
//           <button
//             onClick={onClose}
//             className="flex-1 py-2.5 rounded-lg border border-gray-200 bg-white text-gray-500 font-semibold cursor-pointer"
//           >
//             Cancel
//           </button>
//           <button
//             onClick={handleSubmit}
//             disabled={saving}
//             className={`flex-1 py-2.5 rounded-lg text-white font-bold cursor-pointer ${saving ? "bg-gray-400 cursor-not-allowed" : "bg-indigo-500 hover:bg-indigo-600"}`}
//           >
//             {saving ? "Saving…" : "Create Lead"}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }

// // ─── Main Component ───────────────────────────────────────────────────────────
// const InquireLeads = () => {
//   const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);
//   const [isSidebarOpen, setIsSidebarOpen] = useState(() => {
//     const s = localStorage.getItem("menubarOpen");
//     return s !== null ? JSON.parse(s) : window.innerWidth >= 1024;
//   });
//   const [storeTab, setStoreTab] = useState("meta");
//   const [leads, setLeads] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [processedMetaIds, setProcessedMetaIds] = useState(new Set());
//   const [activeStatus, setActiveStatus] = useState("Incoming Leads");
//   const [websiteLeads, setWebsiteLeads] = useState([]);
//   const [websiteLoading, setWebsiteLoading] = useState(false);
//   const [websiteError, setWebsiteError] = useState(null);
//   const [processedWebsiteIds, setProcessedWebsiteIds] = useState(new Set());
//   const [processedWebsiteLeads, setProcessedWebsiteLeads] = useState([]);
//   const [processedWebsiteLoading, setProcessedWebsiteLoading] = useState(false);
//   const [websiteActiveStatus, setWebsiteActiveStatus] = useState("All Leads");
//   const [activeChannel, setActiveChannel] = useState("All");
//   const [activeTag, setActiveTag] = useState("All");
//   const [searchInput, setSearchInput] = useState("");
//   const [search, setSearch] = useState("");
//   const [expandedLead, setExpandedLead] = useState(null);
//   const [followUpLead, setFollowUpLead] = useState(null);
//   const [showCreate, setShowCreate] = useState(false);
//   const [updatingId, setUpdatingId] = useState(null);
//   const [selectedRows, setSelectedRows] = useState([]);
//   const [showConvertModal, setShowConvertModal] = useState(false);
//   const [converting, setConverting] = useState(false);
//   const [convertResult, setConvertResult] = useState(null);
//   const [showBulkProcessModal, setShowBulkProcessModal] = useState(false);
//   const [bulkProcessing, setBulkProcessing] = useState(false);
//   const [bulkProcessResult, setBulkProcessResult] = useState(null);
//   // Toast state
//   const [toastMsg, setToastMsg] = useState("");
//   const rowsPerPage = 20;
//   const [currentPage, setCurrentPage] = useState(1);
//   const [showPopup_filter, setShowPopup_filter] = useState(false);
//   const filterRef = useRef(null);

//   useEffect(() => {
//     const t = setTimeout(() => setSearch(searchInput), 400);
//     return () => clearTimeout(t);
//   }, [searchInput]);
//   useEffect(() => {
//     setCurrentPage(1);
//     setSelectedRows([]);
//   }, [
//     search,
//     activeStatus,
//     activeChannel,
//     activeTag,
//     websiteActiveStatus,
//     storeTab,
//   ]);
//   useEffect(() => {
//     function handleClickOutside(e) {
//       if (filterRef.current && !filterRef.current.contains(e.target))
//         setShowPopup_filter(false);
//     }
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);
//   useEffect(() => {
//     const handleResize = () => {
//       const mobile = window.innerWidth < 1024;
//       setIsMobile(mobile);
//       if (mobile) setIsSidebarOpen(false);
//     };
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   const fetchLeads = useCallback(async () => {
//     setLoading(true);
//     setError(null);
//     try {
//       const p = new URLSearchParams();
//       if (
//         activeStatus !== "All" &&
//         activeStatus !== "Incoming Leads" &&
//         activeStatus !== "All Leads"
//       )
//         p.set("status", activeStatus);
//       if (activeChannel !== "All") p.set("channel", activeChannel);
//       if (activeTag !== "All") p.set("tag", activeTag);
//       if (search) p.set("search", search);
//       p.set("limit", "200");
//       const res = await fetch(`${API}/leads?${p}`);
//       if (!res.ok) throw new Error(`API error ${res.status}`);
//       const data = await res.json();
//       const allLeads = data.leads || [];
//       setProcessedMetaIds(
//         new Set(
//           allLeads
//             .filter((l) => !String(l.id).startsWith("meta_") && l.meta_lead_id)
//             .map((l) => l.meta_lead_id),
//         ),
//       );
//       setLeads(allLeads);
//     } catch (e) {
//       setError(e.message);
//     } finally {
//       setLoading(false);
//     }
//   }, [activeStatus, activeChannel, activeTag, search]);

//   useEffect(() => {
//     fetchLeads();
//   }, [fetchLeads]);

//   const fetchWebsiteLeads = useCallback(async () => {
//     setWebsiteLoading(true);
//     setWebsiteError(null);
//     try {
//       const res = await fetch(`${API}/website-leads`);
//       if (!res.ok) throw new Error(`API error ${res.status}`);
//       setWebsiteLeads((await res.json()).data || []);
//     } catch (e) {
//       setWebsiteError(e.message);
//     } finally {
//       setWebsiteLoading(false);
//     }
//   }, []);

//   const fetchProcessedWebsiteLeads = useCallback(async () => {
//     setProcessedWebsiteLoading(true);
//     try {
//       const url =
//         websiteActiveStatus !== "Incoming Leads" &&
//         websiteActiveStatus !== "All Processed Leads" &&
//         websiteActiveStatus !== "All Leads"
//           ? `${API}/processed-website-leads?status=${encodeURIComponent(websiteActiveStatus)}`
//           : `${API}/processed-website-leads`;
//       const res = await fetch(url);
//       if (!res.ok) throw new Error(`API error ${res.status}`);
//       const rows = (await res.json()).data || [];
//       setProcessedWebsiteLeads(rows);
//       setProcessedWebsiteIds(
//         new Set(rows.map((r) => String(r.original_lead_id))),
//       );
//     } catch (e) {
//       console.error("fetchProcessedWebsiteLeads:", e.message);
//     } finally {
//       setProcessedWebsiteLoading(false);
//     }
//   }, [websiteActiveStatus]);

//   useEffect(() => {
//     if (storeTab === "website") {
//       fetchWebsiteLeads();
//       fetchProcessedWebsiteLeads();
//     }
//   }, [storeTab, fetchWebsiteLeads, fetchProcessedWebsiteLeads]);

//   const visibleLeads = (() => {
//     if (activeStatus === "All Leads") return leads;
//     if (activeStatus === "Incoming Leads")
//       return leads.filter(
//         (l) =>
//           String(l.id).startsWith("meta_") &&
//           !processedMetaIds.has(String(l.id).replace("meta_", "")),
//       );
//     if (activeStatus === "All Processed Leads")
//       return leads.filter((l) => !String(l.id).startsWith("meta_"));
//     return leads.filter(
//       (l) => !String(l.id).startsWith("meta_") && l.status === activeStatus,
//     );
//   })();

//   const visibleWebsiteLeads = (() => {
//     if (websiteActiveStatus === "All Leads") {
//       const incoming = websiteLeads
//         .filter(
//           (l) => !processedWebsiteIds.has(String(l.leadId).replace("WL-", "")),
//         )
//         .map((l) => ({ ...l, _isIncoming: true }));
//       return [...incoming, ...processedWebsiteLeads];
//     }
//     if (websiteActiveStatus === "Incoming Leads")
//       return websiteLeads.filter(
//         (l) => !processedWebsiteIds.has(String(l.leadId).replace("WL-", "")),
//       );
//     if (websiteActiveStatus === "All Processed Leads")
//       return processedWebsiteLeads;
//     return processedWebsiteLeads.filter(
//       (l) => l.status === websiteActiveStatus,
//     );
//   })();

//   const patchLead = async (id, field, value) => {
//     setUpdatingId(id);
//     setLeads((prev) =>
//       prev.map((l) => (l.id === id ? { ...l, [field]: value } : l)),
//     );
//     try {
//       const res = await fetch(`${API}/leads/${id}`, {
//         method: "PATCH",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ [field]: value }),
//       });
//       if (!res.ok) throw new Error("patch failed");
//     } catch {
//       fetchLeads();
//     } finally {
//       setUpdatingId(null);
//     }
//   };

//   const patchWebsiteLead = async (id, field, value) => {
//     setUpdatingId(id);
//     setProcessedWebsiteLeads((prev) =>
//       prev.map((l) => (l.id === id ? { ...l, [field]: value } : l)),
//     );
//     try {
//       const res = await fetch(`${API}/processed-website-leads/${id}`, {
//         method: "PATCH",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ [field]: value }),
//       });
//       if (!res.ok) throw new Error("patch failed");
//     } catch {
//       fetchProcessedWebsiteLeads();
//     } finally {
//       setUpdatingId(null);
//     }
//   };

//   const addRemark = (lead) => {
//     const r = prompt("Remark:", lead.remark || "");
//     if (r !== null) patchLead(lead.id, "remark", r);
//   };
//   const addWebsiteRemark = (lead) => {
//     const r = prompt("Remark:", lead.remark || "");
//     if (r !== null) patchWebsiteLead(lead.id, "remark", r);
//   };
//   const handleCreated = (lead) => setLeads((prev) => [lead, ...prev]);
//   const handleMetaLeadProcessed = (savedLead) => {
//     setProcessedMetaIds((prev) => {
//       const n = new Set(prev);
//       n.add(savedLead.meta_lead_id);
//       return n;
//     });
//     setLeads((prev) =>
//       prev.some((l) => l.id === savedLead.id) ? prev : [savedLead, ...prev],
//     );
//   };
//   const handleWebsiteLeadProcessed = (savedLead) => {
//     setProcessedWebsiteIds((prev) => {
//       const n = new Set(prev);
//       n.add(String(savedLead.original_lead_id));
//       return n;
//     });
//     setProcessedWebsiteLeads((prev) =>
//       prev.some((l) => l.id === savedLead.id) ? prev : [savedLead, ...prev],
//     );
//   };

//   const handleConvertToBooking = async () => {
//     const leadsToConvert = leads.filter((l) => selectedRows.includes(l.id));
//     if (!leadsToConvert.length) return;
//     setConverting(true);
//     setConvertResult(null);
//     const results = { bookingids: [], errors: [] };
//     for (const lead of leadsToConvert) {
//       try {
//         const nameParts = (lead.name || "").trim().split(/\s+/);
//         const payload = {
//           firstname: nameParts[0] || "Unknown",
//           lastname: nameParts.slice(1).join(" ") || "",
//           email: lead.email || "",
//           phone: lead.phone || "",
//           tripexecutive:
//             lead.assignee && lead.assignee !== "Unassigned"
//               ? lead.assignee
//               : "",
//           bookingstatus: "Pending",
//           paymentstatus: "Pending",
//           source: channelToSource(lead.channel),
//         };
//         const res = await fetch(`${API}/createBooking`, {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify(payload),
//         });
//         if (!res.ok) {
//           const e = await res.json().catch(() => ({}));
//           throw new Error(e.message || `HTTP ${res.status}`);
//         }
//         const data = await res.json();
//         results.bookingids.push(data.bookingid || "—");
//         const delRes = await fetch(`${API}/leads/${lead.id}`, {
//           method: "DELETE",
//         });
//         if (!delRes.ok)
//           console.warn(
//             `Booking created but lead delete failed for id ${lead.id}`,
//           );
//       } catch (e) {
//         results.errors.push({ name: lead.name, error: e.message });
//       }
//     }
//     const failedNames = new Set(results.errors.map((e) => e.name));
//     setLeads((prev) =>
//       prev.filter(
//         (l) =>
//           !leadsToConvert
//             .filter((lc) => !failedNames.has(lc.name))
//             .map((lc) => lc.id)
//             .includes(l.id),
//       ),
//     );
//     setSelectedRows([]);
//     setConverting(false);
//     setConvertResult(results);
//   };

//   const handleWebsiteConvertToBooking = async () => {
//     if (!selectedRows.length) return;
//     setConverting(true);
//     setConvertResult(null);
//     try {
//       const res = await fetch(`${API}/website-leads/convert-booking`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ ids: selectedRows }),
//       });
//       if (!res.ok) throw new Error(`HTTP ${res.status}`);
//       const data = await res.json();
//       const results = {
//         bookingids: data.bookingids || [],
//         errors: data.errors || [],
//       };
//       const failedIds = new Set((data.errors || []).map((e) => e.id));
//       setProcessedWebsiteLeads((prev) =>
//         prev.filter(
//           (l) =>
//             !selectedRows.filter((id) => !failedIds.has(id)).includes(l.id),
//         ),
//       );
//       setSelectedRows([]);
//       setConvertResult(results);
//     } catch (e) {
//       setConvertResult({
//         bookingids: [],
//         errors: [{ id: "all", error: e.message }],
//       });
//     } finally {
//       setConverting(false);
//     }
//   };

//   const handleBulkProcessWebsiteLeads = async () => {
//     const toProcess = currentLeads.filter(
//       (l) => l._isIncoming && selectedRows.includes(l.leadId),
//     );
//     if (!toProcess.length) return;
//     setBulkProcessing(true);
//     setBulkProcessResult(null);
//     const results = { processed: [], errors: [] };
//     for (const lead of toProcess) {
//       try {
//         const res = await fetch(`${API}/website-leads/process`, {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify({ leadId: lead.leadId }),
//         });
//         if (!res.ok) throw new Error(`HTTP ${res.status}`);
//         const { lead: savedLead } = await res.json();
//         results.processed.push(lead.customerName || lead.leadId);
//         handleWebsiteLeadProcessed(savedLead);
//       } catch (e) {
//         results.errors.push({
//           name: lead.customerName || lead.leadId,
//           error: e.message,
//         });
//       }
//     }
//     setSelectedRows([]);
//     setBulkProcessing(false);
//     setBulkProcessResult(results);
//   };

//   // ── Smart checkbox handler with toast guard ────────────────────────────────
//   // For website "All Leads" view: prevent mixing processed and unprocessed selections
//   const handleRowCheckboxChange = (id, isUnprocessed = false) => {
//     if (storeTab === "website" && websiteActiveStatus === "All Leads") {
//       const hasProcessed = selectedRows.some(
//         (sid) => !currentLeads.find((l) => l._isIncoming && l.leadId === sid),
//       );
//       const hasUnprocessed = selectedRows.some((sid) =>
//         currentLeads.find((l) => l._isIncoming && l.leadId === sid),
//       );

//       if (isUnprocessed && hasProcessed) {
//         setToastMsg("Cannot select processed and unprocessed leads at once");
//         return;
//       }
//       if (!isUnprocessed && hasUnprocessed) {
//         setToastMsg("Cannot select processed and unprocessed leads at once");
//         return;
//       }
//     }
//     setSelectedRows((prev) =>
//       prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id],
//     );
//   };

//   const handleSelectAll = () => {
//     if (
//       selectedRows.length === currentLeads.length &&
//       currentLeads.length > 0
//     ) {
//       setSelectedRows([]);
//       return;
//     }
//     // In All Leads website view, only select same type as first already-selected row (or all if none selected)
//     if (
//       storeTab === "website" &&
//       websiteActiveStatus === "All Leads" &&
//       selectedRows.length > 0
//     ) {
//       const hasProcessed = selectedRows.some(
//         (sid) => !currentLeads.find((l) => l._isIncoming && l.leadId === sid),
//       );
//       const hasUnprocessed = selectedRows.some((sid) =>
//         currentLeads.find((l) => l._isIncoming && l.leadId === sid),
//       );
//       if (hasUnprocessed && !hasProcessed) {
//         setSelectedRows(
//           currentLeads.filter((l) => l._isIncoming).map((l) => l.leadId),
//         );
//         return;
//       }
//       if (hasProcessed && !hasUnprocessed) {
//         setSelectedRows(
//           currentLeads.filter((l) => !l._isIncoming).map((l) => l.id),
//         );
//         return;
//       }
//     }
//     setSelectedRows(currentLeads.map((l) => l.id || l.leadId));
//   };

//   // Counts for action bars
//   const newMetaLeadsCount = leads.filter(
//     (l) =>
//       String(l.id).startsWith("meta_") &&
//       !processedMetaIds.has(String(l.id).replace("meta_", "")),
//   ).length;
//   const facebookCount = leads.filter(
//     (l) => l.channel === "Facebook Lead",
//   ).length;
//   const instagramCount = leads.filter(
//     (l) => l.channel === "Instagram DM",
//   ).length;
//   const whatsappCount = leads.filter((l) => l.channel === "WhatsApp").length;

//   const activeLeadList =
//     storeTab === "meta" ? visibleLeads : visibleWebsiteLeads;
//   const totalPages = Math.ceil(activeLeadList.length / rowsPerPage);
//   const indexOfFirst = (currentPage - 1) * rowsPerPage;
//   const indexOfLast = indexOfFirst + rowsPerPage;
//   const currentLeads = activeLeadList.slice(indexOfFirst, indexOfLast);

//   const generatePageNumbers = () => {
//     const pages = [];
//     if (totalPages <= 3) {
//       for (let i = 1; i <= totalPages; i++) pages.push(i);
//     } else {
//       if (currentPage > 2) {
//         pages.push(1);
//         pages.push("...");
//       }
//       for (let i = currentPage - 1; i <= currentPage + 1; i++) {
//         if (i > 0 && i <= totalPages) pages.push(i);
//       }
//       if (currentPage < totalPages - 1) {
//         pages.push("...");
//         pages.push(totalPages);
//       }
//     }
//     return pages;
//   };

//   const isIncomingView = activeStatus === "Incoming Leads";
//   const isAllLeadsView = activeStatus === "All Leads";
//   const isWebsiteIncomingView = websiteActiveStatus === "Incoming Leads";

//   const selectedUnprocessedWebsiteCount = currentLeads.filter(
//     (l) =>
//       selectedRows.includes(l.leadId) &&
//       (l._isIncoming || isWebsiteIncomingView),
//   ).length;
//   const selectedProcessedWebsiteCount = selectedRows.filter(
//     (id) => !currentLeads.find((l) => l._isIncoming && l.leadId === id),
//   ).length;

//   if (error && storeTab === "meta")
//     return (
//       <div className="flex">
//         <Menubar
//           isOpen={isSidebarOpen}
//           setIsOpen={setIsSidebarOpen}
//           isMobile={isMobile}
//         />
//         <div className="flex-1 p-6 flex justify-center items-center h-64">
//           <div className="text-lg text-red-500">
//             {error}
//             <button
//               onClick={fetchLeads}
//               className="ml-3 underline text-indigo-500 text-sm"
//             >
//               Retry
//             </button>
//           </div>
//         </div>
//       </div>
//     );

//   // Pipeline stage tab helper
//   const PipelineTab = ({ stage, isActive, onClick }) => (
//     <button
//       onClick={onClick}
//       className={`relative flex-shrink-0 flex-1 min-w-[70px] h-9 px-1 leading-tight transition-all ${stage.color} ${isActive ? "ring-1 ring-black z-10" : ""}`}
//       style={{
//         clipPath:
//           "polygon(0 0, calc(100% - 12px) 0, 100% 50%, calc(100% - 12px) 100%, 0 100%, 12px 50%)",
//         marginRight: "-6px",
//       }}
//     >
//       <span className="flex flex-col items-center justify-center gap-0.5 w-full">
//         <span>{stage.name}</span>
//         <span
//           className="rounded-full transition-all duration-200"
//           style={{
//             width: isActive ? 5 : 0,
//             height: isActive ? 5 : 0,
//             background: "currentColor",
//             opacity: isActive ? 1 : 0,
//             display: "block",
//           }}
//         />
//       </span>
//     </button>
//   );

//   return (
//     <div className="flex bg-[#F8F9FA]">
//       <Menubar
//         isOpen={isSidebarOpen}
//         setIsOpen={setIsSidebarOpen}
//         isMobile={isMobile}
//       />

//       <main
//         className={`p-5 lg:p-6 transition-all duration-500 w-full ${isMobile ? "ml-0" : isSidebarOpen ? "ml-64" : "ml-16"}`}
//       >
//         <Outlet />

//         {/* Header */}
//         <div className="flex justify-between gap-5 items-start lg:items-center">
//           <p className="font-semibold text-xl text-gray-700 ml-10 lg:ml-0">
//             Inquire Leads
//           </p>

//           {/* Search Bar and Filter */}
//           <div className="flex items-center gap-1 ">
//             <div className="mr-2 p-2 overflow-hidden w-8 h-8 hover:w-[120px] sm:hover:w-[250px] hover:border hover:border-[#1D2826] hover:shadow-[2px_2px_20px_rgba(0,0,0,0.08)] rounded-full flex group items-center hover:duration-300 duration-300">
//               <div className="flex items-center justify-center fill-[#1D2826]">
//                 <svg
//                   xmlns="http://www.w3.org/2000/svg"
//                   viewBox="0 0 24 24"
//                   width="18"
//                   height="18"
//                 >
//                   <path d="M18.9,16.776A10.539,10.539,0,1,0,16.776,18.9l5.1,5.1L24,21.88ZM10.5,18A7.5,7.5,0,1,1,18,10.5,7.507,7.507,0,0,1,10.5,18Z" />
//                 </svg>
//               </div>
//               <input
//                 type="text"
//                 placeholder="Search name, phone…"
//                 value={searchInput}
//                 onChange={(e) => setSearchInput(e.target.value)}
//                 className="border-none outline-none text-sm bg-transparent w-full font-normal px-2 focus:ring-0"
//               />
//             </div>
//             <div className="flex items-center">
//               <div className="relative inline-block" ref={filterRef}>
//                 <div
//                   onClick={() => setShowPopup_filter((p) => !p)}
//                   className={`flex flex-col items-center gap-4 cursor-pointer select-none group scale-[0.75] py-2.5 px-2 rounded-full border-2 transition-all duration-300 ${showPopup_filter ? "border-[#1D2826]" : "border-transparent hover:border-[#1D2826]"}`}
//                 >
//                   {[
//                     ["100%", "0%"],
//                     ["0%", "100%"],
//                     ["100%", "0%"],
//                   ].map(([a, b], i) => (
//                     <div
//                       key={i}
//                       className={`relative w-6 h-0.5 bg-[#1D2826] rounded-full ${i === 1 ? "-my-2.5" : ""}`}
//                     >
//                       <div
//                         className="absolute top-1/2 -translate-y-1/2 w-2 h-2 rounded-full border-2 border-black bg-white transition-all duration-300"
//                         style={{
//                           left: showPopup_filter ? a : b,
//                           transform: `translate(${showPopup_filter ? (i === 1 ? "0" : "-100%") : i === 1 ? "0" : "-0%"},-50%)`,
//                         }}
//                       />
//                     </div>
//                   ))}
//                 </div>
//                 {showPopup_filter && (
//                   <div className="absolute top-full mt-1 right-0 bg-white border rounded-lg shadow-custom z-10 p-4 space-y-4">
//                     <div className="flex flex-col gap-2">
//                       <p className="text-xs font-semibold text-gray-500 uppercase">
//                         Channel
//                       </p>
//                       <div className="flex gap-1 flex-wrap">
//                         {[
//                           "All",
//                           "Instagram DM",
//                           "Facebook Lead",
//                           "WhatsApp",
//                         ].map((ch) => (
//                           <button
//                             key={ch}
//                             onClick={() => setActiveChannel(ch)}
//                             className={`py-1 px-2 rounded text-xs font-medium transition-colors ${activeChannel === ch ? "bg-[#1D2826] text-white" : "bg-gray-100 hover:bg-[#DAE0CE]"}`}
//                           >
//                             {ch}
//                           </button>
//                         ))}
//                       </div>
//                     </div>
//                     {/*  <div className="flex flex-col gap-2">
//                       <p className="text-xs font-semibold text-gray-500 uppercase">
//                         Tag
//                       </p>
//                       <div className="flex gap-1">
//                         {["All", "Hot", "Warm", "Cold"].map((t) => (
//                           <button
//                             key={t}
//                             onClick={() => setActiveTag(t)}
//                             className={`py-1 px-2 rounded text-xs font-medium transition-colors ${activeTag === t ? "bg-[#1D2826] text-white" : "bg-gray-100 hover:bg-[#DAE0CE]"}`}
//                           >
//                             {t}
//                           </button>
//                         ))}
//                       </div>
//                     </div>
// */}
//                     <div className="flex flex-col gap-2">
//                       <p className="text-xs font-semibold text-gray-500 uppercase">
//                         Date Range
//                       </p>
//                       <div className="flex justify-between gap-2">
//                         {["Today", "Week", "Month", "Year"].map((label) => (
//                           <button
//                             key={label}
//                             className="flex-1 py-1 px-2 bg-gray-100 active:bg-[#DAE0CE] hover:bg-[#DAE0CE] rounded text-sm font-medium"
//                           >
//                             {label}
//                           </button>
//                         ))}
//                       </div>
//                       <div className="flex items-center gap-2">
//                         <input
//                           type="date"
//                           className="border text-sm rounded px-2 py-1 w-full focus:outline-none focus:ring-1 focus:ring-green-600 focus:border-black"
//                         />
//                         <span className="text-sm text-gray-500">-</span>
//                         <input
//                           type="date"
//                           className="border text-sm rounded px-2 py-1 w-full focus:outline-none focus:ring-1 focus:ring-green-600 focus:border-black"
//                         />
//                       </div>
//                     </div>
//                   </div>
//                 )}
//               </div>
//             </div>
//             <button
//               onClick={
//                 storeTab === "meta"
//                   ? fetchLeads
//                   : () => {
//                       fetchWebsiteLeads();
//                       fetchProcessedWebsiteLeads();
//                     }
//               }
//               title="Refresh"
//               className="p-2 rounded-lg text-xl cursor-pointer border-none"
//             >
//               <TbRefresh />
//             </button>
//             {storeTab === "meta" && (
//               <button
//                 onClick={() => setShowCreate(true)}
//                 className="ml-1 px-4 py-2 bg-[#1D2826] rounded-lg text-white text-sm font-semibold hover:scale-95 transition-all duration-200"
//               >
//                 + New Lead
//               </button>
//             )}
//           </div>
//         </div>

//         {/* Meta Stat Boxes */}
//         {storeTab === "meta" && (
//           <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 items-center gap-5 text-gray-700 font-semibold mt-5">
//             {[
//               [
//                 "FaceBook Leads",
//                 facebookCount,
//                 <IoLogoFacebook className="bg-[#3C4C4E] text-3xl text-white p-1.5 rounded-md" />,
//               ],
//               [
//                 "Instagram Leads",
//                 instagramCount,
//                 <RiInstagramFill className="bg-[#3C4C4E] text-3xl text-white p-1.5 rounded-md" />,
//               ],
//               [
//                 "WhatsApp Leads",
//                 whatsappCount,
//                 <IoLogoWhatsapp className="bg-[#3C4C4E] text-3xl text-white p-1.5 rounded-md" />,
//               ],
//               [
//                 "Unprocessed (Meta)",
//                 newMetaLeadsCount,
//                 <TbDeviceAnalytics className="bg-[#3C4C4E] text-3xl text-white p-1.5 rounded-md" />,
//               ],
//             ].map(([label, count, icon]) => (
//               <div
//                 key={label}
//                 className="flex items-center justify-between gap-5 bg-[#DAE0CE] py-2 px-4 rounded-lg"
//               >
//                 <div>
//                   <p>{label}</p>
//                   <p className="mt-2 text-lg text-black">{count}</p>
//                 </div>
//                 {icon}
//               </div>
//             ))}
//           </div>
//         )}

//         {/* Website Stat Boxes */}
//         {storeTab === "website" && (
//           <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 text-gray-700 font-semibold mt-5">
//             <div className="flex items-center justify-between gap-5 bg-[#DAE0CE] py-2 px-4 rounded-lg">
//               <div>
//                 <p>Incoming</p>
//                 <p className="mt-2 text-lg text-black">
//                   {
//                     websiteLeads.filter(
//                       (l) =>
//                         !processedWebsiteIds.has(
//                           String(l.leadId).replace("WL-", ""),
//                         ),
//                     ).length
//                   }
//                 </p>
//               </div>
//               <RxOpenInNewWindow className="bg-[#3C4C4E] text-3xl text-white p-1.5 rounded-md" />
//             </div>
//             <div className="flex items-center justify-between gap-5 bg-[#DAE0CE] py-2 px-4 rounded-lg">
//               <div>
//                 <p>Processed</p>
//                 <p className="mt-2 text-lg text-black">
//                   {processedWebsiteLeads.length}
//                 </p>
//               </div>
//               <MdFileDownloadDone className="bg-[#3C4C4E] text-3xl text-white p-1.5 rounded-md" />
//             </div>
//             <div className="flex items-center justify-between gap-5 bg-[#DAE0CE] py-2 px-4 rounded-lg">
//               <div>
//                 <p>Total Leads (Website)</p>
//                 <p className="mt-2 text-lg text-black">
//                   {websiteLeads.filter(
//                     (l) =>
//                       !processedWebsiteIds.has(
//                         String(l.leadId).replace("WL-", ""),
//                       ),
//                   ).length + processedWebsiteLeads.length}
//                 </p>
//               </div>
//               <TbDeviceAnalytics className="bg-[#3C4C4E] text-3xl text-white p-1.5 rounded-md" />
//             </div>
//           </div>
//         )}

//         {/* Tab Switcher */}
//         <div className="inline-flex border border-gray-300 rounded-lg overflow-hidden text-sm font-medium shadow-sm mt-5">
//           <button
//             onClick={() => setStoreTab("meta")}
//             className={`px-4 py-2 transition-colors duration-200 focus:outline-none ${storeTab === "meta" ? "bg-[#1D2826] text-white" : "bg-white text-gray-500 hover:bg-green-50"}`}
//           >
//             Meta Leads
//           </button>
//           <button
//             onClick={() => setStoreTab("website")}
//             className={`px-4 py-2 transition-colors duration-200 focus:outline-none ${storeTab === "website" ? "bg-[#1D2826] text-white" : "bg-white text-gray-500 hover:bg-green-50"}`}
//           >
//             Website Leads
//           </button>
//         </div>

//         {/* Meta Pipeline Tabs */}
//         {storeTab === "meta" && (
//           <div className="mt-6">
//             <div className="flex w-full items-center text-[11px] font-semibold overflow-x-auto">
//               {PIPELINE_STAGES.map((stage) => (
//                 <PipelineTab
//                   key={stage.name}
//                   stage={stage}
//                   isActive={activeStatus === stage.status}
//                   onClick={() => setActiveStatus(stage.status)}
//                 />
//               ))}
//             </div>
//           </div>
//         )}

//         {/* Website Pipeline Tabs */}
//         {storeTab === "website" && (
//           <div className="mt-6">
//             <div className="flex w-full items-center text-[11px] font-semibold overflow-x-auto">
//               {WEBSITE_PIPELINE_STAGES.map((stage) => (
//                 <PipelineTab
//                   key={stage.name}
//                   stage={stage}
//                   isActive={websiteActiveStatus === stage.status}
//                   onClick={() => setWebsiteActiveStatus(stage.status)}
//                 />
//               ))}
//             </div>
//           </div>
//         )}

//         {/* Action bars */}
//         {selectedRows.length > 0 && (
//           <div className="mt-4 flex items-center justify-between gap-2 px-4 py-2.5">
//             {/* Left: count + clear */}
//             <div className="flex items-center gap-3">
//               <span className="text-sm text-gray-600 font-medium">
//                 {selectedRows.length} selected
//               </span>
//               <button
//                 onClick={() => setSelectedRows([])}
//                 className="text-xs text-gray-400 hover:text-gray-700 underline cursor-pointer"
//               >
//                 Clear
//               </button>
//             </div>
//             {/* Right: action buttons */}
//             <div className="flex items-center gap-2">
//               {/* Convert to Booking */}
//               {((storeTab === "meta" && !isIncomingView) ||
//                 (storeTab === "website" &&
//                   !isWebsiteIncomingView &&
//                   selectedProcessedWebsiteCount > 0)) && (
//                 <button
//                   onClick={() => setShowConvertModal(true)}
//                   className="px-4 py-1.5 bg-[#1D2826] text-white text-xs font-semibold rounded-lg hover:scale-95 transition-all duration-200 cursor-pointer"
//                 >
//                   Convert to Booking
//                 </button>
//               )}
//               {/* Process Selected Leads (website unprocessed) */}
//               {storeTab === "website" &&
//                 selectedUnprocessedWebsiteCount > 0 && (
//                   <button
//                     onClick={() => setShowBulkProcessModal(true)}
//                     className="px-4 py-1.5 bg-yellow-200 text-yellow-700 text-xs font-semibold rounded-lg hover:scale-95 transition-all duration-200 cursor-pointer"
//                   >
//                     Process Selected Leads
//                   </button>
//                 )}
//             </div>
//           </div>
//         )}

//         {/* META TABLE */}
//         {storeTab === "meta" && (
//           <div className="shadow-md rounded-lg mt-3">
//             <div className="overflow-x-auto">
//               <table className="w-full text-sm text-left text-gray-500">
//                 <thead className="text-xs text-gray-400 uppercase bg-green-50 border-b">
//                   <tr>
//                     <th className="p-4">
//                       <input
//                         type="checkbox"
//                         onChange={handleSelectAll}
//                         checked={
//                           selectedRows.length === currentLeads.length &&
//                           currentLeads.length > 0
//                         }
//                       />
//                     </th>
//                     <th className="p-4">Lead Details</th>
//                     <th className="p-4">Enquiry</th>
//                     {isIncomingView ? (
//                       <>
//                         <th className="p-4">Meta Fields</th>
//                         <th className="p-4">Action</th>
//                       </>
//                     ) : (
//                       <>
//                         <th className="p-4">Status</th>
//                         <th className="p-4">Assigned To</th>
//                         <th className="p-4">Remark</th>
//                         <th className="p-4">Date</th>
//                         <th className="p-4">Actions</th>
//                       </>
//                     )}
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {loading ? (
//                     <tr>
//                       <td
//                         colSpan={isIncomingView ? 5 : 9}
//                         className="text-center py-14 text-gray-400"
//                       >
//                         Loading leads…
//                       </td>
//                     </tr>
//                   ) : currentLeads.length === 0 ? (
//                     <tr>
//                       <td
//                         colSpan={isIncomingView ? 5 : 9}
//                         className="text-center py-14 text-gray-400"
//                       >
//                         {isIncomingView
//                           ? "No unprocessed Meta leads. They'll appear here automatically via Meta webhooks."
//                           : "No leads found for this filter."}
//                       </td>
//                     </tr>
//                   ) : (
//                     currentLeads.map((lead, idx) => {
//                       const ch = CHANNELS[lead.channel] || {
//                         color: "#888",
//                         bg: "#f1f5f9",
//                         icon: "",
//                       };
//                       const isExpanded = expandedLead === lead.id;
//                       const dimmed = updatingId === lead.id;
//                       const isMetaLead = String(lead.id).startsWith("meta_");
//                       const showProcessButton = isAllLeadsView && isMetaLead;
//                       return (
//                         <React.Fragment key={lead.id}>
//                           <tr
//                             className={`border-b border-gray-200 hover:bg-gray-100 text-gray-800 transition-opacity ${idx % 2 === 0 ? "bg-white" : "bg-gray-50"}`}
//                             style={{ opacity: dimmed ? 0.55 : 1 }}
//                           >
//                             <td className="px-4 py-3">
//                               {/* Incoming tab: show checkbox for meta leads so bulk process is possible in future */}
//                               <input
//                                 type="checkbox"
//                                 onChange={() =>
//                                   handleRowCheckboxChange(
//                                     lead.id,
//                                     isMetaLead && isIncomingView,
//                                   )
//                                 }
//                                 checked={selectedRows.includes(lead.id)}
//                               />
//                             </td>
//                             <td className="px-4 py-3 min-w-[180px]">
//                               <div className="font-bold text-gray-800 mb-1">
//                                 {lead.name || "—"}
//                               </div>
//                               <div className="flex flex-wrap items-center gap-1 mb-1">
//                                 <span
//                                   className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] font-bold"
//                                   style={{ background: ch.bg, color: ch.color }}
//                                 >
//                                   <span className="text-xs">{ch.icon}</span>
//                                   <span>{lead.channel}</span>
//                                 </span>
//                                 {lead.tag && (
//                                   <span
//                                     className="px-1.5 py-0.5 rounded-full text-[10px] font-bold"
//                                     style={{
//                                       background:
//                                         (TAG_COLORS[lead.tag] || "#999") + "18",
//                                       color: TAG_COLORS[lead.tag] || "#999",
//                                     }}
//                                   >
//                                     {lead.tag}
//                                   </span>
//                                 )}
//                                 {isAllLeadsView && isMetaLead && (
//                                   <span className="px-1.5 py-0.5 rounded-full text-[10px] font-bold bg-amber-100 text-amber-600">
//                                     Unprocessed
//                                   </span>
//                                 )}
//                               </div>
//                               {lead.phone && (
//                                 <div className="inline-flex items-center gap-1 text-xs text-gray-500">
//                                   <FaPhone />
//                                   <span>{lead.phone}</span>
//                                 </div>
//                               )}
//                               <br />
//                               {lead.email && (
//                                 <div className="inline-flex items-center gap-1 text-xs text-gray-400">
//                                   <IoMail />
//                                   <span>{lead.email}</span>
//                                 </div>
//                               )}
//                               <br />
//                               <div className="inline-flex items-center gap-1 text-xs text-gray-400 mt-1">
//                                 <IoIosTime />
//                                 <span>{timeAgo(lead.created_at)}</span>
//                               </div>
//                             </td>
//                             <td className="px-4 py-3 max-w-[220px]">
//                               <div className="text-xs text-gray-600 leading-relaxed whitespace-pre-wrap">
//                                 {lead.enquiry
//                                   ? lead.enquiry.split("\n").map((line, i) => {
//                                       const clean = line
//                                         .replace(/^•\s*/, "")
//                                         .trim();
//                                       const parts = clean.split(":");
//                                       return (
//                                         <div key={i} className="mb-2">
//                                           <div>➤ {parts[0]}:</div>
//                                           {parts.slice(1).join(":").trim() && (
//                                             <div className="ml-3 font-bold text-gray-800">
//                                               ↳{" "}
//                                               {parts.slice(1).join(":").trim()}
//                                             </div>
//                                           )}
//                                         </div>
//                                       );
//                                     })
//                                   : "—"}
//                               </div>
//                             </td>
//                             {isIncomingView ? (
//                               <>
//                                 <td className="px-4 py-3 max-w-[220px]">
//                                   {(lead.field_data || []).length > 0 ? (
//                                     <div className="flex flex-col gap-1">
//                                       {lead.field_data.map((f, fi) => (
//                                         <div
//                                           key={fi}
//                                           className="text-[11px] text-gray-600"
//                                         >
//                                           <span className="text-gray-400 uppercase text-[10px]">
//                                             {f.name.replace(/_/g, " ")}:{" "}
//                                           </span>
//                                           <span className="font-semibold text-gray-700">
//                                             {f.values?.[0] || "—"}
//                                           </span>
//                                         </div>
//                                       ))}
//                                     </div>
//                                   ) : (
//                                     <span className="text-xs text-gray-300">
//                                       —
//                                     </span>
//                                   )}
//                                 </td>
//                                 <td className="px-4 py-3">
//                                   <ProcessMetaLeadButton
//                                     lead={lead}
//                                     onProcessed={handleMetaLeadProcessed}
//                                   />
//                                 </td>
//                               </>
//                             ) : (
//                               <>
//                                 <td className="px-4 py-3">
//                                   {showProcessButton ? (
//                                     <ProcessMetaLeadButton
//                                       lead={lead}
//                                       onProcessed={handleMetaLeadProcessed}
//                                     />
//                                   ) : (
//                                     <select
//                                       value={lead.status || ""}
//                                       onChange={(e) =>
//                                         patchLead(
//                                           lead.id,
//                                           "status",
//                                           e.target.value,
//                                         )
//                                       }
//                                       className="p-1.5 rounded-md text-[11px] font-bold cursor-pointer outline-none border"
//                                       style={{
//                                         borderColor:
//                                           STATUS_COLORS[lead.status] || "#ccc",
//                                         background:
//                                           (STATUS_COLORS[lead.status] ||
//                                             "#ccc") + "18",
//                                         color:
//                                           STATUS_COLORS[lead.status] || "#555",
//                                       }}
//                                     >
//                                       {STATUSES.map((s) => (
//                                         <option key={s} value={s}>
//                                           {s}
//                                         </option>
//                                       ))}
//                                     </select>
//                                   )}
//                                 </td>
//                                 <td className="px-4 py-3">
//                                   {showProcessButton ? (
//                                     <span className="text-xs text-gray-300">
//                                       —
//                                     </span>
//                                   ) : (
//                                     <select
//                                       value={lead.assignee || "Unassigned"}
//                                       onChange={(e) =>
//                                         patchLead(
//                                           lead.id,
//                                           "assignee",
//                                           e.target.value,
//                                         )
//                                       }
//                                       className="p-1.5 rounded-md border border-gray-200 bg-white text-xs cursor-pointer outline-none"
//                                     >
//                                       {TEAM.map((t) => (
//                                         <option key={t}>{t}</option>
//                                       ))}
//                                     </select>
//                                   )}
//                                 </td>
//                                 <td className="px-4 py-3">
//                                   {showProcessButton ? (
//                                     <span className="text-xs text-gray-300">
//                                       —
//                                     </span>
//                                   ) : lead.remark ? (
//                                     <div
//                                       onClick={() => addRemark(lead)}
//                                       title="Click to edit"
//                                       className="text-xs text-gray-600 bg-gray-50 rounded-md px-2 py-1 max-w-[160px] cursor-pointer leading-snug"
//                                     >
//                                       {lead.remark}
//                                     </div>
//                                   ) : (
//                                     <button
//                                       onClick={() => addRemark(lead)}
//                                       className="text-[11px] text-indigo-500 bg-transparent border border-dashed border-indigo-400 rounded-md px-2 py-1 cursor-pointer"
//                                     >
//                                       + Add Remark
//                                     </button>
//                                   )}
//                                 </td>
//                                 <td className="px-4 py-3">
//                                   {showProcessButton ? (
//                                     <span className="text-xs text-gray-300">
//                                       —
//                                     </span>
//                                   ) : (
//                                     <Tooltip
//                                       title={
//                                         lead.created_at
//                                           ? new Date(
//                                               lead.created_at,
//                                             ).toLocaleString()
//                                           : "—"
//                                       }
//                                       placement="left"
//                                     >
//                                       <span className="text-xs">
//                                         {lead.created_at
//                                           ? new Date(
//                                               lead.created_at,
//                                             ).toLocaleDateString()
//                                           : "—"}
//                                       </span>
//                                     </Tooltip>
//                                   )}
//                                 </td>
//                                 <td className="px-4 py-3">
//                                   {!showProcessButton && (
//                                     <div className="flex flex-col gap-1.5">
//                                       <button
//                                         onClick={() => setFollowUpLead(lead)}
//                                         className="bg-[#a19993] text-white border-none rounded-md px-2.5 py-1.5 text-[11px] font-semibold cursor-pointer"
//                                       >
//                                         Follow Up
//                                       </button>
//                                       <button
//                                         onClick={() =>
//                                           setExpandedLead(
//                                             isExpanded ? null : lead.id,
//                                           )
//                                         }
//                                         className="bg-gray-100 text-gray-600 border-none rounded-md px-2.5 py-1.5 text-[11px] cursor-pointer"
//                                       >
//                                         {isExpanded ? "▲ Less" : "▼ Details"}
//                                       </button>
//                                     </div>
//                                   )}
//                                 </td>
//                               </>
//                             )}
//                           </tr>
//                           {!isMetaLead && isExpanded && (
//                             <tr className="bg-gray-50">
//                               <td colSpan={9} className="px-6 py-4">
//                                 <div className="flex gap-7 flex-wrap">
//                                   {[
//                                     ["Lead ID", lead.id],
//                                     ["Meta ID", lead.meta_lead_id || "—"],
//                                     ["Email", lead.email || "—"],
//                                     ["Phone", lead.phone || "—"],
//                                     ["Channel", lead.channel],
//                                     ["Assigned To", lead.assignee || "—"],
//                                     ["Status", lead.status],
//                                     ["Tag", lead.tag || "—"],
//                                     ["Remark", lead.remark || "—"],
//                                     [
//                                       "Received",
//                                       lead.created_at
//                                         ? new Date(
//                                             lead.created_at,
//                                           ).toLocaleString()
//                                         : "—",
//                                     ],
//                                   ].map(([label, val]) => (
//                                     <div key={label} className="min-w-[90px]">
//                                       <div className="text-[10px] text-gray-400 uppercase font-bold mb-0.5">
//                                         {label}
//                                       </div>
//                                       <div
//                                         className="text-sm"
//                                         style={{
//                                           color:
//                                             label === "Status"
//                                               ? STATUS_COLORS[val]
//                                               : "#333",
//                                           fontWeight:
//                                             label === "Status" ? 700 : 400,
//                                         }}
//                                       >
//                                         {String(val)}
//                                       </div>
//                                     </div>
//                                   ))}
//                                 </div>
//                               </td>
//                             </tr>
//                           )}
//                         </React.Fragment>
//                       );
//                     })
//                   )}
//                 </tbody>
//               </table>
//             </div>
//             <nav className="flex items-center flex-col md:flex-row justify-between rounded-b-lg px-2 py-1 bg-[#f7f7f7]">
//               <span className="text-xs font-normal text-gray-500 mb-4 md:mb-0 block w-full md:inline md:w-auto">
//                 Showing{" "}
//                 <span className="font-semibold text-gray-700">
//                   {visibleLeads.length > 0 ? indexOfFirst + 1 : 0}–
//                   {Math.min(indexOfLast, visibleLeads.length)}
//                 </span>{" "}
//                 of{" "}
//                 <span className="font-semibold text-gray-700">
//                   {visibleLeads.length}
//                 </span>
//               </span>
//               <ul className="inline-flex -space-x-px rtl:space-x-reverse text-xs h-8">
//                 <li>
//                   <button
//                     onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
//                     disabled={currentPage === 1}
//                     className="flex items-center justify-center px-1 h-8 leading-tight text-gray-500 bg-[#f7f7f7] border-gray-300 rounded-s-lg hover:bg-gray-100"
//                   >
//                     <MdKeyboardDoubleArrowLeft />
//                   </button>
//                 </li>
//                 {generatePageNumbers().map((page, i) =>
//                   page === "..." ? (
//                     <li
//                       key={i}
//                       className="px-1 h-8 flex items-center justify-center text-gray-500"
//                     >
//                       <span>...</span>
//                     </li>
//                   ) : (
//                     <li key={i}>
//                       <button
//                         onClick={() => setCurrentPage(page)}
//                         className={`flex items-center justify-center px-3 h-8 leading-tight text-gray-500 bg-[#f7f7f7] border-gray-300 hover:bg-gray-100 ${currentPage === page ? "text-green-500 underline underline-offset-2" : ""}`}
//                       >
//                         {page}
//                       </button>
//                     </li>
//                   ),
//                 )}
//                 <li>
//                   <button
//                     onClick={() =>
//                       setCurrentPage((p) => Math.min(p + 1, totalPages))
//                     }
//                     disabled={currentPage === totalPages}
//                     className="flex items-center justify-center px-1 h-8 leading-tight text-gray-500 bg-[#f7f7f7] border-gray-300 rounded-e-lg hover:bg-gray-100"
//                   >
//                     <MdKeyboardDoubleArrowRight />
//                   </button>
//                 </li>
//               </ul>
//             </nav>
//           </div>
//         )}

//         {/* WEBSITE TABLE */}
//         {storeTab === "website" && (
//           <div className="shadow-md rounded-lg mt-3">
//             <div className="overflow-x-auto">
//               <table className="w-full text-sm text-left text-gray-500">
//                 <thead className="text-xs text-gray-400 uppercase bg-green-50 border-b">
//                   <tr>
//                     <th className="p-4">
//                       <input
//                         type="checkbox"
//                         onChange={handleSelectAll}
//                         checked={
//                           selectedRows.length === currentLeads.length &&
//                           currentLeads.length > 0
//                         }
//                       />
//                     </th>
//                     <th className="p-4">Lead ID</th>
//                     <th className="p-4">Customer</th>
//                     <th className="p-4">Property / Destination</th>
//                     <th className="p-4">Check-In → Check-Out</th>
//                     <th className="p-4">Location</th>
//                     {isWebsiteIncomingView ? (
//                       <th className="p-4">Action</th>
//                     ) : (
//                       <>
//                         <th className="p-4">Status</th>
//                         <th className="p-4">Assigned To</th>
//                         <th className="p-4">Remark</th>
//                         <th className="p-4">Actions</th>
//                       </>
//                     )}
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {(
//                     isWebsiteIncomingView
//                       ? websiteLoading
//                       : processedWebsiteLoading
//                   ) ? (
//                     <tr>
//                       <td
//                         colSpan={isWebsiteIncomingView ? 7 : 11}
//                         className="text-center py-14 text-gray-400"
//                       >
//                         Loading website leads…
//                       </td>
//                     </tr>
//                   ) : websiteError && isWebsiteIncomingView ? (
//                     <tr>
//                       <td
//                         colSpan={7}
//                         className="text-center py-14 text-red-400"
//                       >
//                         {websiteError}
//                       </td>
//                     </tr>
//                   ) : currentLeads.length === 0 ? (
//                     <tr>
//                       <td
//                         colSpan={isWebsiteIncomingView ? 7 : 11}
//                         className="text-center py-14 text-gray-400"
//                       >
//                         {isWebsiteIncomingView
//                           ? "No new website leads. All incoming leads have been processed."
//                           : "No processed website leads found for this stage."}
//                       </td>
//                     </tr>
//                   ) : isWebsiteIncomingView ? (
//                     currentLeads.map((lead, idx) => (
//                       <tr
//                         key={lead.leadId}
//                         className={`border-b border-gray-200 hover:bg-gray-100 text-gray-800 ${idx % 2 === 0 ? "bg-white" : "bg-gray-50"}`}
//                       >
//                         {/* Checkbox on incoming tab too */}
//                         <td className="px-4 py-3">
//                           <input
//                             type="checkbox"
//                             onChange={() =>
//                               handleRowCheckboxChange(lead.leadId, true)
//                             }
//                             checked={selectedRows.includes(lead.leadId)}
//                           />
//                         </td>
//                         <td className="px-4 py-3 text-xs font-mono text-indigo-600">
//                           {lead.leadId}
//                         </td>
//                         <td className="px-4 py-3 min-w-[160px]">
//                           <div className="font-bold text-gray-800 mb-1">
//                             {lead.customerName || "—"}
//                           </div>
//                           {lead.phone && (
//                             <div className="inline-flex items-center gap-1 text-xs text-gray-500">
//                               <FaPhone />
//                               {lead.phone}
//                             </div>
//                           )}
//                           <br />
//                           {lead.email && (
//                             <div className="inline-flex items-center gap-1 text-xs text-gray-400">
//                               <IoMail />
//                               {lead.email}
//                             </div>
//                           )}
//                         </td>
//                         <td className="px-4 py-3">
//                           <div className="font-semibold text-gray-700 text-xs">
//                             {lead.property || "—"}
//                           </div>
//                           <div className="text-xs text-gray-400 mt-0.5">
//                             {lead.destination || "—"}
//                           </div>
//                         </td>
//                         <td className="px-4 py-3 text-xs text-gray-600 whitespace-nowrap">
//                           <div className="inline-flex items-center gap-1">
//                             <FaCalendarAlt className="text-gray-400" />
//                             {lead.checkin
//                               ? new Date(lead.checkin).toLocaleDateString()
//                               : "N/A"}
//                             {" → "}
//                             {lead.checkout
//                               ? new Date(lead.checkout).toLocaleDateString()
//                               : "N/A"}
//                           </div>
//                         </td>
//                         <td className="px-4 py-3 text-xs text-gray-500">
//                           <div className="inline-flex items-center gap-1">
//                             {[lead.city, lead.state, lead.country]
//                               .filter(Boolean)
//                               .join(", ") || "—"}
//                           </div>
//                         </td>
//                         <td className="px-4 py-3">
//                           <ProcessWebsiteLeadButton
//                             lead={lead}
//                             onProcessed={handleWebsiteLeadProcessed}
//                           />
//                         </td>
//                       </tr>
//                     ))
//                   ) : (
//                     currentLeads.map((lead, idx) => {
//                       const dimmed = updatingId === lead.id;
//                       const isRawIncoming = lead._isIncoming === true;
//                       return (
//                         <tr
//                           key={lead.id || lead.leadId}
//                           className={`border-b border-gray-200 hover:bg-gray-100 text-gray-800 transition-opacity ${idx % 2 === 0 ? "bg-white" : "bg-gray-50"}`}
//                           style={{ opacity: dimmed ? 0.55 : 1 }}
//                         >
//                           <td className="px-4 py-3">
//                             <input
//                               type="checkbox"
//                               onChange={() =>
//                                 handleRowCheckboxChange(
//                                   isRawIncoming ? lead.leadId : lead.id,
//                                   isRawIncoming,
//                                 )
//                               }
//                               checked={selectedRows.includes(
//                                 isRawIncoming ? lead.leadId : lead.id,
//                               )}
//                             />
//                           </td>
//                           <td className="px-4 py-3 text-xs font-mono text-indigo-600">
//                             <div className="flex items-center gap-1.5">
//                               {isRawIncoming
//                                 ? lead.leadId
//                                 : `WL-${lead.original_lead_id}`}
//                               {isRawIncoming && (
//                                 <span className="text-[10px] bg-amber-100 text-amber-600 px-1.5 py-0.5 rounded-full font-bold whitespace-nowrap">
//                                   Unprocessed
//                                 </span>
//                               )}
//                             </div>
//                           </td>
//                           <td className="px-4 py-3 min-w-[160px]">
//                             <div className="font-bold text-gray-800 mb-1">
//                               {isRawIncoming
//                                 ? lead.customerName || "—"
//                                 : lead.customer_name || "—"}
//                             </div>
//                             {lead.phone && (
//                               <div className="inline-flex items-center gap-1 text-xs text-gray-500">
//                                 <FaPhone />
//                                 {lead.phone}
//                               </div>
//                             )}
//                             <br />
//                             {lead.email && (
//                               <div className="inline-flex items-center gap-1 text-xs text-gray-400">
//                                 <IoMail />
//                                 {lead.email}
//                               </div>
//                             )}
//                             {!isRawIncoming && lead.converted === 1 && (
//                               <div className="mt-1">
//                                 <span className="text-[10px] bg-green-100 text-green-700 px-1.5 py-0.5 rounded-full font-bold">
//                                   ✓ Converted
//                                 </span>
//                               </div>
//                             )}
//                           </td>
//                           <td className="px-4 py-3">
//                             <div className="font-semibold text-gray-700 text-xs">
//                               {lead.property || "—"}
//                             </div>
//                             <div className="text-xs text-gray-400 mt-0.5">
//                               {lead.destination || "—"}
//                             </div>
//                           </td>
//                           <td className="px-4 py-3 text-xs text-gray-600 whitespace-nowrap">
//                             <div className="inline-flex items-center gap-1">
//                               <FaCalendarAlt className="text-gray-400" />
//                               {isRawIncoming
//                                 ? lead.checkin
//                                   ? new Date(lead.checkin).toLocaleDateString()
//                                   : "—"
//                                 : lead.check_in
//                                   ? new Date(lead.check_in).toLocaleDateString()
//                                   : "—"}
//                               {" → "}
//                               {isRawIncoming
//                                 ? lead.checkout
//                                   ? new Date(lead.checkout).toLocaleDateString()
//                                   : "—"
//                                 : lead.check_out
//                                   ? new Date(
//                                       lead.check_out,
//                                     ).toLocaleDateString()
//                                   : "—"}
//                             </div>
//                           </td>
//                           <td className="px-4 py-3 text-xs text-gray-500">
//                             <div className="inline-flex items-center gap-1">
//                               {[lead.city, lead.state, lead.country]
//                                 .filter(Boolean)
//                                 .join(", ") || "—"}
//                             </div>
//                           </td>
//                           <td className="px-4 py-3">
//                             {isRawIncoming ? (
//                               <ProcessWebsiteLeadButton
//                                 lead={lead}
//                                 onProcessed={handleWebsiteLeadProcessed}
//                               />
//                             ) : (
//                               <select
//                                 value={lead.status || "New Lead"}
//                                 onChange={(e) =>
//                                   patchWebsiteLead(
//                                     lead.id,
//                                     "status",
//                                     e.target.value,
//                                   )
//                                 }
//                                 className="p-1.5 rounded-md text-[11px] font-bold cursor-pointer outline-none border"
//                                 style={{
//                                   borderColor:
//                                     WEBSITE_STATUS_COLORS[lead.status] ||
//                                     "#ccc",
//                                   background:
//                                     (WEBSITE_STATUS_COLORS[lead.status] ||
//                                       "#ccc") + "18",
//                                   color:
//                                     WEBSITE_STATUS_COLORS[lead.status] ||
//                                     "#555",
//                                 }}
//                               >
//                                 {WEBSITE_STATUSES.map((s) => (
//                                   <option key={s} value={s}>
//                                     {s}
//                                   </option>
//                                 ))}
//                               </select>
//                             )}
//                           </td>
//                           <td className="px-4 py-3">
//                             {isRawIncoming ? (
//                               <span className="text-xs text-gray-300">—</span>
//                             ) : (
//                               <select
//                                 value={lead.assignee || "Unassigned"}
//                                 onChange={(e) =>
//                                   patchWebsiteLead(
//                                     lead.id,
//                                     "assignee",
//                                     e.target.value,
//                                   )
//                                 }
//                                 className="p-1.5 rounded-md border border-gray-200 bg-white text-xs cursor-pointer outline-none"
//                               >
//                                 {TEAM.map((t) => (
//                                   <option key={t}>{t}</option>
//                                 ))}
//                               </select>
//                             )}
//                           </td>
//                           <td className="px-4 py-3">
//                             {isRawIncoming ? (
//                               <span className="text-xs text-gray-300">—</span>
//                             ) : lead.remark ? (
//                               <div
//                                 onClick={() => addWebsiteRemark(lead)}
//                                 title="Click to edit"
//                                 className="text-xs text-gray-600 bg-gray-50 rounded-md px-2 py-1 max-w-[160px] cursor-pointer leading-snug"
//                               >
//                                 {lead.remark}
//                               </div>
//                             ) : (
//                               <button
//                                 onClick={() => addWebsiteRemark(lead)}
//                                 className="text-[11px] text-indigo-500 bg-transparent border border-dashed border-indigo-400 rounded-md px-2 py-1 cursor-pointer"
//                               >
//                                 + Add Remark
//                               </button>
//                             )}
//                           </td>
//                           <td className="px-4 py-3">
//                             {isRawIncoming ? (
//                               <span className="text-xs text-gray-300">—</span>
//                             ) : (
//                               <button
//                                 onClick={() =>
//                                   setFollowUpLead({
//                                     ...lead,
//                                     name: lead.customer_name,
//                                   })
//                                 }
//                                 className="bg-[#a19993] text-white border-none rounded-md px-2.5 py-1.5 text-[11px] font-semibold cursor-pointer w-20"
//                               >
//                                 Follow Up
//                               </button>
//                             )}
//                           </td>
//                         </tr>
//                       );
//                     })
//                   )}
//                 </tbody>
//               </table>
//             </div>
//             <nav className="flex items-center flex-col md:flex-row justify-between rounded-b-lg px-2 py-1 bg-[#f7f7f7]">
//               <span className="text-xs font-normal text-gray-500 mb-4 md:mb-0 block w-full md:inline md:w-auto">
//                 Showing{" "}
//                 <span className="font-semibold text-gray-700">
//                   {visibleWebsiteLeads.length > 0 ? indexOfFirst + 1 : 0}–
//                   {Math.min(indexOfLast, visibleWebsiteLeads.length)}
//                 </span>{" "}
//                 of{" "}
//                 <span className="font-semibold text-gray-700">
//                   {visibleWebsiteLeads.length}
//                 </span>
//               </span>
//               <ul className="inline-flex -space-x-px rtl:space-x-reverse text-xs h-8">
//                 <li>
//                   <button
//                     onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
//                     disabled={currentPage === 1}
//                     className="flex items-center justify-center px-1 h-8 leading-tight text-gray-500 bg-[#f7f7f7] border-gray-300 rounded-s-lg hover:bg-gray-100"
//                   >
//                     <MdKeyboardDoubleArrowLeft />
//                   </button>
//                 </li>
//                 {generatePageNumbers().map((page, i) =>
//                   page === "..." ? (
//                     <li
//                       key={i}
//                       className="px-1 h-8 flex items-center justify-center text-gray-500"
//                     >
//                       <span>...</span>
//                     </li>
//                   ) : (
//                     <li key={i}>
//                       <button
//                         onClick={() => setCurrentPage(page)}
//                         className={`flex items-center justify-center px-3 h-8 leading-tight text-gray-500 bg-[#f7f7f7] border-gray-300 hover:bg-gray-100 ${currentPage === page ? "text-green-500 underline underline-offset-2" : ""}`}
//                       >
//                         {page}
//                       </button>
//                     </li>
//                   ),
//                 )}
//                 <li>
//                   <button
//                     onClick={() =>
//                       setCurrentPage((p) => Math.min(p + 1, totalPages))
//                     }
//                     disabled={currentPage === totalPages}
//                     className="flex items-center justify-center px-1 h-8 leading-tight text-gray-500 bg-[#f7f7f7] border-gray-300 rounded-e-lg hover:bg-gray-100"
//                   >
//                     <MdKeyboardDoubleArrowRight />
//                   </button>
//                 </li>
//               </ul>
//             </nav>
//           </div>
//         )}
//       </main>

//       {/* Modals */}
//       {followUpLead && (
//         <FollowUpModal
//           lead={followUpLead}
//           onClose={() => setFollowUpLead(null)}
//         />
//       )}
//       {showCreate && (
//         <CreateLeadModal
//           onClose={() => setShowCreate(false)}
//           onCreated={handleCreated}
//         />
//       )}

//       {/* Convert Confirm */}
//       {showConvertModal && (
//         <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
//           <div className="bg-white rounded-2xl p-7 w-[420px] shadow-2xl">
//             <div className="font-bold text-base mb-2 text-gray-800">
//               Convert to Booking
//             </div>
//             <p className="text-sm text-gray-500 mb-4">
//               Convert{" "}
//               <b className="text-gray-800">
//                 {selectedRows.length} lead{selectedRows.length > 1 ? "s" : ""}
//               </b>{" "}
//               to booking{selectedRows.length > 1 ? "s" : ""}?
//             </p>
//             <p className="text-xs text-amber-600 mb-4">
//               {storeTab === "website"
//                 ? "These website leads will be marked as converted and inserted into bookings."
//                 : "The leads will be removed from the leads table and inserted into bookings."}
//             </p>
//             <div className="bg-gray-50 rounded-lg px-3 py-2 mb-5 max-h-36 overflow-y-auto">
//               {storeTab === "meta"
//                 ? leads
//                     .filter((l) => selectedRows.includes(l.id))
//                     .map((l) => (
//                       <div
//                         key={l.id}
//                         className="flex items-center justify-between py-1 border-b border-gray-100 last:border-0"
//                       >
//                         <span className="text-xs font-semibold text-gray-700">
//                           {l.name || "—"}
//                         </span>
//                         <span className="text-[11px] text-gray-400">
//                           {channelToSource(l.channel)}
//                         </span>
//                       </div>
//                     ))
//                 : processedWebsiteLeads
//                     .filter((l) => selectedRows.includes(l.id))
//                     .map((l) => (
//                       <div
//                         key={l.id}
//                         className="flex items-center justify-between py-1 border-b border-gray-100 last:border-0"
//                       >
//                         <span className="text-xs font-semibold text-gray-700">
//                           {l.customer_name || "—"}
//                         </span>
//                         <span className="text-[11px] text-gray-400">
//                           {l.property || "Website"}
//                         </span>
//                       </div>
//                     ))}
//             </div>
//             <div className="flex gap-3">
//               <button
//                 onClick={() => setShowConvertModal(false)}
//                 disabled={converting}
//                 className="flex-1 py-2.5 rounded-lg border border-gray-200 bg-white text-gray-500 font-semibold text-sm cursor-pointer"
//               >
//                 Cancel
//               </button>
//               <button
//                 onClick={async () => {
//                   setShowConvertModal(false);
//                   storeTab === "meta"
//                     ? await handleConvertToBooking()
//                     : await handleWebsiteConvertToBooking();
//                 }}
//                 disabled={converting}
//                 className="flex-1 py-2.5 rounded-lg bg-[#1D2826] text-white font-bold text-sm cursor-pointer hover:bg-[#2d3d3a] transition-colors"
//               >
//                 {converting ? "Converting…" : "Yes, Convert"}
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Convert Result */}
//       {convertResult && (
//         <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
//           <div className="bg-white rounded-2xl p-7 w-[420px] shadow-2xl">
//             {convertResult.errors.length === 0 ? (
//               <>
//                 <div className="text-center mb-4">
//                   <div className="text-4xl mb-2">✅</div>
//                   <div className="font-bold text-base text-gray-800">
//                     {convertResult.bookingids.length} Booking
//                     {convertResult.bookingids.length > 1 ? "s" : ""} Created
//                   </div>
//                   <p className="text-xs text-gray-400 mt-1">
//                     Successfully converted to bookings
//                   </p>
//                 </div>
//                 <div className="bg-green-50 rounded-lg px-3 py-2 mb-5">
//                   {convertResult.bookingids.map((bid, i) => (
//                     <div
//                       key={i}
//                       className="text-xs text-green-700 font-semibold py-0.5"
//                     >
//                       Booking ID: <span className="font-bold">{bid}</span>
//                     </div>
//                   ))}
//                 </div>
//               </>
//             ) : (
//               <>
//                 <div className="text-center mb-4">
//                   <div className="text-4xl mb-2">⚠️</div>
//                   <div className="font-bold text-base text-gray-800">
//                     Partial Conversion
//                   </div>
//                   <p className="text-xs text-gray-400 mt-1">
//                     {convertResult.bookingids.length} succeeded ·{" "}
//                     {convertResult.errors.length} failed
//                   </p>
//                 </div>
//                 {convertResult.bookingids.length > 0 && (
//                   <div className="bg-green-50 rounded-lg px-3 py-2 mb-3">
//                     <p className="text-[10px] text-green-600 font-bold uppercase mb-1">
//                       Created
//                     </p>
//                     {convertResult.bookingids.map((bid, i) => (
//                       <div key={i} className="text-xs text-green-700">
//                         Booking ID: <b>{bid}</b>
//                       </div>
//                     ))}
//                   </div>
//                 )}
//                 <div className="bg-red-50 rounded-lg px-3 py-2 mb-5">
//                   <p className="text-[10px] text-red-500 font-bold uppercase mb-1">
//                     Failed
//                   </p>
//                   {convertResult.errors.map((e, i) => (
//                     <div key={i} className="text-xs text-red-600">
//                       <b>{e.name || e.id}</b>: {e.error}
//                     </div>
//                   ))}
//                 </div>
//               </>
//             )}
//             <button
//               onClick={() => setConvertResult(null)}
//               className="w-full py-2.5 rounded-lg bg-[#1D2826] text-white font-bold text-sm cursor-pointer"
//             >
//               Done
//             </button>
//           </div>
//         </div>
//       )}

//       {/* Bulk Process Confirm */}
//       {showBulkProcessModal && (
//         <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
//           <div className="bg-white rounded-2xl p-7 w-[420px] shadow-2xl">
//             <div className="font-bold text-base mb-2 text-gray-800">
//               Process Leads
//             </div>
//             <p className="text-sm text-gray-500 mb-4">
//               Do you want to process{" "}
//               <b className="text-gray-800">
//                 {selectedUnprocessedWebsiteCount} lead
//                 {selectedUnprocessedWebsiteCount > 1 ? "s" : ""}
//               </b>
//               ?
//             </p>
//             <p className="text-xs text-green-600 mb-4">
//               The selected leads will be saved to the processed leads table and
//               become manageable in the pipeline.
//             </p>
//             <div className="bg-gray-50 rounded-lg px-3 py-2 mb-5 max-h-36 overflow-y-auto">
//               {currentLeads
//                 .filter((l) => l._isIncoming && selectedRows.includes(l.leadId))
//                 .map((l) => (
//                   <div
//                     key={l.leadId}
//                     className="flex items-center justify-between py-1 border-b border-gray-100 last:border-0"
//                   >
//                     <span className="text-xs font-semibold text-gray-700">
//                       {l.customerName || "—"}
//                     </span>
//                     <span className="text-[11px] text-gray-400 font-mono">
//                       {l.leadId}
//                     </span>
//                   </div>
//                 ))}
//             </div>
//             <div className="flex gap-3">
//               <button
//                 onClick={() => setShowBulkProcessModal(false)}
//                 disabled={bulkProcessing}
//                 className="flex-1 py-2.5 rounded-lg border border-gray-200 bg-white text-gray-500 font-semibold text-sm cursor-pointer"
//               >
//                 Cancel
//               </button>
//               <button
//                 onClick={async () => {
//                   setShowBulkProcessModal(false);
//                   await handleBulkProcessWebsiteLeads();
//                 }}
//                 disabled={bulkProcessing}
//                 className="flex-1 py-2.5 rounded-lg bg-green-600 text-white font-bold text-sm cursor-pointer hover:bg-green-700 transition-colors"
//               >
//                 {bulkProcessing ? "Processing…" : "Yes, Process"}
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Bulk Process Result */}
//       {bulkProcessResult && (
//         <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
//           <div className="bg-white rounded-2xl p-7 w-[420px] shadow-2xl">
//             {bulkProcessResult.errors.length === 0 ? (
//               <>
//                 <div className="text-center mb-4">
//                   <div className="text-4xl mb-2">✅</div>
//                   <div className="font-bold text-base text-gray-800">
//                     {bulkProcessResult.processed.length} Lead
//                     {bulkProcessResult.processed.length > 1 ? "s" : ""}{" "}
//                     Processed
//                   </div>
//                   <p className="text-xs text-gray-400 mt-1">
//                     Now visible in the pipeline tabs
//                   </p>
//                 </div>
//                 <div className="bg-indigo-50 rounded-lg px-3 py-2 mb-5">
//                   {bulkProcessResult.processed.map((name, i) => (
//                     <div
//                       key={i}
//                       className="text-xs text-indigo-700 font-semibold py-0.5"
//                     >
//                       ✓ {name}
//                     </div>
//                   ))}
//                 </div>
//               </>
//             ) : (
//               <>
//                 <div className="text-center mb-4">
//                   <div className="text-4xl mb-2">⚠️</div>
//                   <div className="font-bold text-base text-gray-800">
//                     Partial Processing
//                   </div>
//                   <p className="text-xs text-gray-400 mt-1">
//                     {bulkProcessResult.processed.length} succeeded ·{" "}
//                     {bulkProcessResult.errors.length} failed
//                   </p>
//                 </div>
//                 {bulkProcessResult.processed.length > 0 && (
//                   <div className="bg-indigo-50 rounded-lg px-3 py-2 mb-3">
//                     <p className="text-[10px] text-indigo-600 font-bold uppercase mb-1">
//                       Processed
//                     </p>
//                     {bulkProcessResult.processed.map((name, i) => (
//                       <div key={i} className="text-xs text-indigo-700">
//                         ✓ {name}
//                       </div>
//                     ))}
//                   </div>
//                 )}
//                 <div className="bg-red-50 rounded-lg px-3 py-2 mb-5">
//                   <p className="text-[10px] text-red-500 font-bold uppercase mb-1">
//                     Failed
//                   </p>
//                   {bulkProcessResult.errors.map((e, i) => (
//                     <div key={i} className="text-xs text-red-600">
//                       <b>{e.name}</b>: {e.error}
//                     </div>
//                   ))}
//                 </div>
//               </>
//             )}
//             <button
//               onClick={() => setBulkProcessResult(null)}
//               className="w-full py-2.5 rounded-lg bg-[#1D2826] text-white font-bold text-sm cursor-pointer"
//             >
//               Done
//             </button>
//           </div>
//         </div>
//       )}

//       {/* Toast */}
//       {toastMsg && <Toast msg={toastMsg} onDone={() => setToastMsg("")} />}
//     </div>
//   );
// };

// export default InquireLeads;

//9th june 2026
// import React, { useState, useEffect, useRef, useCallback } from "react";
// import Menubar from "../Menubar/Menubar";
// // import { useNavigate } from "react-router-dom";
// import { Outlet } from "react-router-dom";
// import "../Dashboard/Dashboard.css";
// import { Tooltip } from "antd";
// import { MdKeyboardDoubleArrowLeft } from "react-icons/md";
// import { MdKeyboardDoubleArrowRight } from "react-icons/md";
// import { IoLogoFacebook } from "react-icons/io";
// import { RiInstagramFill } from "react-icons/ri";
// import { IoLogoWhatsapp } from "react-icons/io";
// import { TbDeviceAnalytics } from "react-icons/tb";
// import { TbRefresh } from "react-icons/tb";
// import { RiWhatsappFill } from "react-icons/ri";
// import { AiFillInstagram } from "react-icons/ai";
// import { FaFacebookSquare } from "react-icons/fa";
// import { FaPhone } from "react-icons/fa6";
// import { IoMail } from "react-icons/io5";
// import { IoIosTime } from "react-icons/io";
// import { FaCalendarAlt } from "react-icons/fa";
// import { RxOpenInNewWindow } from "react-icons/rx";
// import { MdFileDownloadDone } from "react-icons/md";

// const API = `${process.env.REACT_APP_BACKEND_URL || "https://dash.zorbastays.com"}/web-backend`;

// const STATUSES = [
//   "New Enquiry",
//   "Call Not Picked",
//   "Contacted",
//   "Qualified",
//   "Plan & Quote Sent",
//   "In Pipeline",
//   "Negotiating",
//   "Awaiting Payment",
//   "Lost & Closed",
// ];
// const STATUS_COLORS = {
//   "New Enquiry": "#6366f1",
//   "Call Not Picked": "#f59e0b",
//   Contacted: "#3b82f6",
//   Qualified: "#8b5cf6",
//   "Plan & Quote Sent": "#06b6d4",
//   "In Pipeline": "#10b981",
//   Negotiating: "#f97316",
//   "Awaiting Payment": "#ec4899",
//   Booked: "#22c55e",
//   "Lost & Closed": "#ef4444",
// };
// const PIPELINE_STAGES = [
//   {
//     name: "Incoming",
//     color: "bg-emerald-100 text-emerald-600",
//     status: "Incoming Leads",
//   },
//   {
//     name: "Processed",
//     color: "bg-yellow-100 text-yellow-600",
//     status: "All Processed Leads",
//   },
//   {
//     name: "New Enquiry",
//     color: "bg-purple-100 text-purple-500",
//     status: "New Enquiry",
//   },
//   {
//     name: "Call Not Picked",
//     color: "bg-sky-100 text-sky-600",
//     status: "Call Not Picked",
//   },
//   {
//     name: "Contacted",
//     color: "bg-pink-100 text-pink-600",
//     status: "Contacted",
//   },
//   {
//     name: "Qualified",
//     color: "bg-teal-100 text-teal-700",
//     status: "Qualified",
//   },
//   {
//     name: "Plan/Quote Sent",
//     color: "bg-red-100 text-red-500",
//     status: "Plan & Quote Sent",
//   },
//   {
//     name: "In Pipeline",
//     color: "bg-blue-100 text-blue-600",
//     status: "In Pipeline",
//   },
//   {
//     name: "Negotiating",
//     color: "bg-lime-100 text-lime-700",
//     status: "Negotiating",
//   },
//   {
//     name: "Awaiting Payment",
//     color: "bg-green-100 text-green-700",
//     status: "Awaiting Payment",
//   },
//   {
//     name: "Lost & Closed",
//     color: "bg-slate-200 text-slate-700",
//     status: "Lost & Closed",
//   },
// ];
// const WEBSITE_STATUSES = [
//   "New Lead",
//   "Contacted",
//   "Qualified",
//   "Plan & Quote Sent",
//   "In Pipeline",
//   "Negotiating",
//   "Awaiting Payment",
//   "Lost & Closed",
// ];
// const WEBSITE_STATUS_COLORS = {
//   "New Lead": "#6366f1",
//   Contacted: "#3b82f6",
//   Qualified: "#8b5cf6",
//   "Plan & Quote Sent": "#06b6d4",
//   "In Pipeline": "#10b981",
//   Negotiating: "#f97316",
//   "Awaiting Payment": "#ec4899",
//   "Lost & Closed": "#ef4444",
// };
// const WEBSITE_PIPELINE_STAGES = [
//   { name: "All", color: "bg-orange-100 text-orange-600", status: "All Leads" },
//   {
//     name: "Incoming",
//     color: "bg-emerald-100 text-emerald-600",
//     status: "Incoming Leads",
//   },
//   {
//     name: "Processed",
//     color: "bg-yellow-100 text-yellow-600",
//     status: "All Processed Leads",
//   },
//   {
//     name: "New Lead",
//     color: "bg-purple-100 text-purple-500",
//     status: "New Lead",
//   },
//   {
//     name: "Contacted",
//     color: "bg-pink-100 text-pink-600",
//     status: "Contacted",
//   },
//   {
//     name: "Qualified",
//     color: "bg-teal-100 text-teal-700",
//     status: "Qualified",
//   },
//   {
//     name: "Plan/Quote Sent",
//     color: "bg-red-100 text-red-500",
//     status: "Plan & Quote Sent",
//   },
//   {
//     name: "In Pipeline",
//     color: "bg-blue-100 text-blue-600",
//     status: "In Pipeline",
//   },
//   {
//     name: "Negotiating",
//     color: "bg-lime-100 text-lime-700",
//     status: "Negotiating",
//   },
//   {
//     name: "Awaiting Payment",
//     color: "bg-green-100 text-green-700",
//     status: "Awaiting Payment",
//   },
//   {
//     name: "Lost & Closed",
//     color: "bg-slate-200 text-slate-700",
//     status: "Lost & Closed",
//   },
// ];
// const CHANNELS = {
//   "Instagram DM": {
//     color: "#e1306c",
//     bg: "#fce4ec",
//     icon: <AiFillInstagram />,
//   },
//   "Facebook Lead": {
//     color: "#1877f2",
//     bg: "#e3f2fd",
//     icon: <FaFacebookSquare />,
//   },
//   WhatsApp: { color: "#25d366", bg: "#e8f5e9", icon: <RiWhatsappFill /> },
// };
// const TAG_COLORS = { Hot: "#ef4444", Warm: "#f97316", Cold: "#64748b" };
// const TEAM = ["Unassigned", "Parth", "Altaf", "Riya", "Dev", "Sneha"];

// function timeAgo(dateStr) {
//   if (!dateStr) return "—";
//   const diff = (Date.now() - new Date(dateStr)) / 1000;
//   if (diff < 60) return "Just now";
//   if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
//   if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
//   return `${Math.floor(diff / 86400)}d ago`;
// }
// function channelToSource(channel) {
//   const map = {
//     "Facebook Lead": "Facebook",
//     "Instagram DM": "Instagram",
//     WhatsApp: "WhatsApp",
//   };
//   return map[channel] || channel || "Lead";
// }

// // ─── Process Meta Lead Button ─────────────────────────────────────────────────
// function ProcessMetaLeadButton({ lead, onProcessed }) {
//   const [processing, setProcessing] = useState(false);
//   const [done, setDone] = useState(false);
//   const handleProcess = async () => {
//     setProcessing(true);
//     try {
//       const meta_lead_id = lead.id.startsWith("meta_")
//         ? lead.id.replace("meta_", "")
//         : lead.id;
//       const res = await fetch(`${API}/leads/process-meta`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           meta_lead_id,
//           name: lead.name,
//           phone: lead.phone || "",
//           email: lead.email || "",
//           channel: lead.channel || "Facebook Lead",
//           enquiry: lead.enquiry || "",
//           form_id: lead.form_id || "",
//           page_id: lead.page_id || "",
//           field_data: lead.field_data || [],
//           raw_payload: lead,
//         }),
//       });
//       if (!res.ok) throw new Error("Failed " + res.status);
//       const { lead: savedLead, already_existed } = await res.json();
//       setDone(true);
//       onProcessed(savedLead, already_existed);
//     } catch (e) {
//       alert("Error processing lead: " + e.message);
//     } finally {
//       setProcessing(false);
//     }
//   };
//   if (done)
//     return (
//       <span className="text-xs text-green-500 font-bold">✓ Saved to DB</span>
//     );
//   return (
//     <button
//       onClick={handleProcess}
//       disabled={processing}
//       className={`px-3 py-1.5 rounded-md text-white text-xs font-bold whitespace-nowrap transition-all ${processing ? "bg-gray-400 cursor-not-allowed" : "bg-[#aeb3a4] hover:bg-[#797d72] cursor-pointer"}`}
//     >
//       {processing ? "Saving…" : "Process Lead"}
//     </button>
//   );
// }

// // ─── Process Website Lead Button ──────────────────────────────────────────────
// function ProcessWebsiteLeadButton({ lead, onProcessed }) {
//   const [processing, setProcessing] = useState(false);
//   const [done, setDone] = useState(false);
//   const handleProcess = async () => {
//     setProcessing(true);
//     try {
//       const res = await fetch(`${API}/website-leads/process`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ leadId: lead.leadId }),
//       });
//       if (!res.ok) throw new Error("Failed " + res.status);
//       const { lead: savedLead, already_existed } = await res.json();
//       setDone(true);
//       onProcessed(savedLead, already_existed);
//     } catch (e) {
//       alert("Error processing lead: " + e.message);
//     } finally {
//       setProcessing(false);
//     }
//   };
//   if (done)
//     return (
//       <span className="text-xs text-green-500 font-bold">✓ Saved to DB</span>
//     );
//   return (
//     <button
//       onClick={handleProcess}
//       disabled={processing}
//       className={`px-3 py-1.5 rounded-md text-white text-xs font-bold whitespace-nowrap transition-all ${processing ? "bg-gray-400 cursor-not-allowed" : "bg-[#aeb3a4] hover:bg-[#797d72] cursor-pointer"}`}
//     >
//       {processing ? "Saving…" : "Process Lead"}
//     </button>
//   );
// }

// // ─── Follow Up Modal ──────────────────────────────────────────────────────────
// function FollowUpModal({ lead, onClose }) {
//   const [type, setType] = useState("whatsapp");
//   const [msg, setMsg] = useState("");
//   const [sent, setSent] = useState(false);
//   const send = () => {
//     setSent(true);
//     setTimeout(onClose, 1600);
//   };
//   return (
//     <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
//       <div className="bg-white rounded-2xl p-7 w-[420px] shadow-2xl">
//         {sent ? (
//           <div className="text-center py-6">
//             <div className="text-5xl">✅</div>
//             <div className="text-base font-bold mt-3">Follow-up Sent!</div>
//           </div>
//         ) : (
//           <>
//             <div className="font-bold text-base mb-1">Send Follow-Up</div>
//             <div className="text-xs text-gray-400 mb-4">
//               To: <b>{lead.name || lead.customerName}</b>
//               {lead.phone ? ` · ${lead.phone}` : ""}
//             </div>
//             <div className="flex gap-2 mb-4">
//               {["whatsapp", "email"].map((t) => (
//                 <button
//                   key={t}
//                   onClick={() => setType(t)}
//                   className={`flex-1 py-2 rounded-lg font-semibold text-sm cursor-pointer border-2 transition-all ${type === t ? "border-indigo-500 bg-indigo-50 text-indigo-600" : "border-gray-200 bg-white text-gray-500"}`}
//                 >
//                   {t === "whatsapp" ? " WhatsApp" : " Email"}
//                 </button>
//               ))}
//             </div>
//             <textarea
//               value={msg}
//               onChange={(e) => setMsg(e.target.value)}
//               rows={4}
//               placeholder={`Write your ${type} message…`}
//               className="w-full p-3 rounded-lg border border-gray-200 text-sm resize-y outline-none focus:border-indigo-400 font-[inherit]"
//             />
//             <div className="flex gap-3 mt-4">
//               <button
//                 onClick={onClose}
//                 className="flex-1 py-2.5 rounded-lg border border-gray-200 bg-white text-gray-500 font-semibold cursor-pointer"
//               >
//                 Cancel
//               </button>
//               <button
//                 onClick={send}
//                 disabled={!msg}
//                 className={`flex-1 py-2.5 rounded-lg text-white font-bold cursor-pointer ${msg ? "bg-[#25d366] hover:bg-green-600" : "bg-gray-300 cursor-not-allowed"}`}
//               >
//                 Send
//               </button>
//             </div>
//           </>
//         )}
//       </div>
//     </div>
//   );
// }

// // ─── Create Lead Modal ────────────────────────────────────────────────────────
// function CreateLeadModal({ onClose, onCreated }) {
//   const [form, setForm] = useState({
//     name: "",
//     phone: "",
//     email: "",
//     channel: "Instagram DM",
//     enquiry: "",
//     tag: "Warm",
//     assignee: "Unassigned",
//   });
//   const [saving, setSaving] = useState(false);
//   const [err, setErr] = useState("");
//   const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));
//   const handleSubmit = async () => {
//     if (!form.name.trim()) {
//       setErr("Name is required");
//       return;
//     }
//     setSaving(true);
//     setErr("");
//     try {
//       const res = await fetch(`${API}/leads`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(form),
//       });
//       if (!res.ok) throw new Error("Server error " + res.status);
//       const lead = await res.json();
//       onCreated(lead);
//       onClose();
//     } catch (e) {
//       setErr(e.message);
//     } finally {
//       setSaving(false);
//     }
//   };
//   const inputCls =
//     "w-full p-2.5 rounded-lg border border-gray-200 text-sm outline-none focus:border-indigo-400 mb-2.5 font-[inherit] box-border";
//   return (
//     <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
//       <div className="bg-white rounded-2xl p-7 w-[460px] shadow-2xl max-h-[90vh] overflow-y-auto">
//         <div className="font-bold text-base mb-4">➕ Add New Lead</div>
//         <input
//           className={inputCls}
//           placeholder="Full Name *"
//           value={form.name}
//           onChange={(e) => set("name", e.target.value)}
//         />
//         <input
//           className={inputCls}
//           placeholder="Phone Number"
//           value={form.phone}
//           onChange={(e) => set("phone", e.target.value)}
//         />
//         <input
//           className={inputCls}
//           placeholder="Email"
//           type="email"
//           value={form.email}
//           onChange={(e) => set("email", e.target.value)}
//         />
//         <select
//           className={inputCls}
//           value={form.channel}
//           onChange={(e) => set("channel", e.target.value)}
//         >
//           {Object.keys(CHANNELS).map((c) => (
//             <option key={c}>{c}</option>
//           ))}
//         </select>
//         <textarea
//           className={`${inputCls} resize-y`}
//           placeholder="Enquiry / Message"
//           value={form.enquiry}
//           rows={3}
//           onChange={(e) => set("enquiry", e.target.value)}
//         />
//         <div className="flex gap-2.5 mb-2.5">
//           <select
//             className="flex-1 p-2.5 rounded-lg border border-gray-200 text-sm outline-none focus:border-indigo-400 font-[inherit]"
//             value={form.tag}
//             onChange={(e) => set("tag", e.target.value)}
//           >
//             {["Hot", "Warm", "Cold"].map((t) => (
//               <option key={t}>{t}</option>
//             ))}
//           </select>
//           <select
//             className="flex-1 p-2.5 rounded-lg border border-gray-200 text-sm outline-none focus:border-indigo-400 font-[inherit]"
//             value={form.assignee}
//             onChange={(e) => set("assignee", e.target.value)}
//           >
//             {TEAM.map((t) => (
//               <option key={t}>{t}</option>
//             ))}
//           </select>
//         </div>
//         {err && <div className="text-red-500 text-xs mb-2">⚠ {err}</div>}
//         <div className="flex gap-2.5 mt-1.5">
//           <button
//             onClick={onClose}
//             className="flex-1 py-2.5 rounded-lg border border-gray-200 bg-white text-gray-500 font-semibold cursor-pointer"
//           >
//             Cancel
//           </button>
//           <button
//             onClick={handleSubmit}
//             disabled={saving}
//             className={`flex-1 py-2.5 rounded-lg text-white font-bold cursor-pointer ${saving ? "bg-gray-400 cursor-not-allowed" : "bg-indigo-500 hover:bg-indigo-600"}`}
//           >
//             {saving ? "Saving…" : "Create Lead"}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }

// // ─── Main Component ───────────────────────────────────────────────────────────
// const InquireLeads = () => {
//   const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);
//   const [isSidebarOpen, setIsSidebarOpen] = useState(() => {
//     const s = localStorage.getItem("menubarOpen");
//     return s !== null ? JSON.parse(s) : window.innerWidth >= 1024;
//   });

//   const [storeTab, setStoreTab] = useState("meta");

//   const [leads, setLeads] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [processedMetaIds, setProcessedMetaIds] = useState(new Set());
//   const [activeStatus, setActiveStatus] = useState("Incoming Leads");

//   const [websiteLeads, setWebsiteLeads] = useState([]);
//   const [websiteLoading, setWebsiteLoading] = useState(false);
//   const [websiteError, setWebsiteError] = useState(null);
//   const [processedWebsiteIds, setProcessedWebsiteIds] = useState(new Set());
//   const [processedWebsiteLeads, setProcessedWebsiteLeads] = useState([]);
//   const [processedWebsiteLoading, setProcessedWebsiteLoading] = useState(false);
//   const [websiteActiveStatus, setWebsiteActiveStatus] = useState("All Leads");

//   const [activeChannel, setActiveChannel] = useState("All");
//   const [activeTag, setActiveTag] = useState("All");
//   const [searchInput, setSearchInput] = useState("");
//   const [search, setSearch] = useState("");
//   const [expandedLead, setExpandedLead] = useState(null);
//   const [followUpLead, setFollowUpLead] = useState(null);
//   const [showCreate, setShowCreate] = useState(false);
//   const [updatingId, setUpdatingId] = useState(null);
//   const [selectedRows, setSelectedRows] = useState([]);

//   // ── Convert to booking state ───────────────────────────────────────────────
//   const [showConvertModal, setShowConvertModal] = useState(false);
//   const [converting, setConverting] = useState(false);
//   const [convertResult, setConvertResult] = useState(null);

//   // ── Bulk process website leads state (NEW) ─────────────────────────────────
//   const [showBulkProcessModal, setShowBulkProcessModal] = useState(false);
//   const [bulkProcessing, setBulkProcessing] = useState(false);
//   const [bulkProcessResult, setBulkProcessResult] = useState(null);

//   const rowsPerPage = 20;
//   const [currentPage, setCurrentPage] = useState(1);
//   const [showPopup_filter, setShowPopup_filter] = useState(false);
//   const filterRef = useRef(null);

//   useEffect(() => {
//     const t = setTimeout(() => setSearch(searchInput), 400);
//     return () => clearTimeout(t);
//   }, [searchInput]);

//   useEffect(() => {
//     setCurrentPage(1);
//     setSelectedRows([]); // clear selection when switching tabs/stages
//   }, [
//     search,
//     activeStatus,
//     activeChannel,
//     activeTag,
//     websiteActiveStatus,
//     storeTab,
//   ]);

//   useEffect(() => {
//     function handleClickOutside(e) {
//       if (filterRef.current && !filterRef.current.contains(e.target))
//         setShowPopup_filter(false);
//     }
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   useEffect(() => {
//     const handleResize = () => {
//       const mobile = window.innerWidth < 1024;
//       setIsMobile(mobile);
//       if (mobile) setIsSidebarOpen(false);
//     };
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   const fetchLeads = useCallback(async () => {
//     setLoading(true);
//     setError(null);
//     try {
//       const p = new URLSearchParams();
//       if (
//         activeStatus !== "All" &&
//         activeStatus !== "Incoming Leads" &&
//         activeStatus !== "All Leads"
//       )
//         p.set("status", activeStatus);
//       if (activeChannel !== "All") p.set("channel", activeChannel);
//       if (activeTag !== "All") p.set("tag", activeTag);
//       if (search) p.set("search", search);
//       p.set("limit", "200");
//       const res = await fetch(`${API}/leads?${p}`);
//       if (!res.ok) throw new Error(`API error ${res.status}`);
//       const data = await res.json();
//       const allLeads = data.leads || [];
//       const dbMetaIds = new Set(
//         allLeads
//           .filter((l) => !String(l.id).startsWith("meta_") && l.meta_lead_id)
//           .map((l) => l.meta_lead_id),
//       );
//       setProcessedMetaIds(dbMetaIds);
//       setLeads(allLeads);
//     } catch (e) {
//       setError(e.message);
//     } finally {
//       setLoading(false);
//     }
//   }, [activeStatus, activeChannel, activeTag, search]);

//   useEffect(() => {
//     fetchLeads();
//   }, [fetchLeads]);

//   const fetchWebsiteLeads = useCallback(async () => {
//     setWebsiteLoading(true);
//     setWebsiteError(null);
//     try {
//       const res = await fetch(`${API}/website-leads`);
//       if (!res.ok) throw new Error(`API error ${res.status}`);
//       const data = await res.json();
//       setWebsiteLeads(data.data || []);
//     } catch (e) {
//       setWebsiteError(e.message);
//     } finally {
//       setWebsiteLoading(false);
//     }
//   }, []);

//   const fetchProcessedWebsiteLeads = useCallback(async () => {
//     setProcessedWebsiteLoading(true);
//     try {
//       const url =
//         websiteActiveStatus !== "Incoming Leads" &&
//         websiteActiveStatus !== "All Processed Leads" &&
//         websiteActiveStatus !== "All Leads"
//           ? `${API}/processed-website-leads?status=${encodeURIComponent(websiteActiveStatus)}`
//           : `${API}/processed-website-leads`;
//       const res = await fetch(url);
//       if (!res.ok) throw new Error(`API error ${res.status}`);
//       const data = await res.json();
//       const rows = data.data || [];
//       setProcessedWebsiteLeads(rows);
//       setProcessedWebsiteIds(
//         new Set(rows.map((r) => String(r.original_lead_id))),
//       );
//     } catch (e) {
//       console.error("fetchProcessedWebsiteLeads:", e.message);
//     } finally {
//       setProcessedWebsiteLoading(false);
//     }
//   }, [websiteActiveStatus]);

//   useEffect(() => {
//     if (storeTab === "website") {
//       fetchWebsiteLeads();
//       fetchProcessedWebsiteLeads();
//     }
//   }, [storeTab, fetchWebsiteLeads, fetchProcessedWebsiteLeads]);

//   const visibleLeads = (() => {
//     if (activeStatus === "All Leads") return leads;
//     if (activeStatus === "Incoming Leads")
//       return leads.filter(
//         (l) =>
//           String(l.id).startsWith("meta_") &&
//           !processedMetaIds.has(String(l.id).replace("meta_", "")),
//       );
//     if (activeStatus === "All Processed Leads")
//       return leads.filter((l) => !String(l.id).startsWith("meta_"));
//     return leads.filter(
//       (l) => !String(l.id).startsWith("meta_") && l.status === activeStatus,
//     );
//   })();

//   const visibleWebsiteLeads = (() => {
//     if (websiteActiveStatus === "All Leads") {
//       const incoming = websiteLeads
//         .filter(
//           (l) => !processedWebsiteIds.has(String(l.leadId).replace("WL-", "")),
//         )
//         .map((l) => ({ ...l, _isIncoming: true }));
//       return [...incoming, ...processedWebsiteLeads];
//     }
//     if (websiteActiveStatus === "Incoming Leads")
//       return websiteLeads.filter(
//         (l) => !processedWebsiteIds.has(String(l.leadId).replace("WL-", "")),
//       );
//     if (websiteActiveStatus === "All Processed Leads")
//       return processedWebsiteLeads;
//     return processedWebsiteLeads.filter(
//       (l) => l.status === websiteActiveStatus,
//     );
//   })();

//   const patchLead = async (id, field, value) => {
//     setUpdatingId(id);
//     setLeads((prev) =>
//       prev.map((l) => (l.id === id ? { ...l, [field]: value } : l)),
//     );
//     try {
//       const res = await fetch(`${API}/leads/${id}`, {
//         method: "PATCH",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ [field]: value }),
//       });
//       if (!res.ok) throw new Error("patch failed");
//     } catch {
//       fetchLeads();
//     } finally {
//       setUpdatingId(null);
//     }
//   };

//   const patchWebsiteLead = async (id, field, value) => {
//     setUpdatingId(id);
//     setProcessedWebsiteLeads((prev) =>
//       prev.map((l) => (l.id === id ? { ...l, [field]: value } : l)),
//     );
//     try {
//       const res = await fetch(`${API}/processed-website-leads/${id}`, {
//         method: "PATCH",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ [field]: value }),
//       });
//       if (!res.ok) throw new Error("patch failed");
//     } catch {
//       fetchProcessedWebsiteLeads();
//     } finally {
//       setUpdatingId(null);
//     }
//   };

//   const addRemark = (lead) => {
//     const r = prompt("Remark:", lead.remark || "");
//     if (r !== null) patchLead(lead.id, "remark", r);
//   };
//   const addWebsiteRemark = (lead) => {
//     const r = prompt("Remark:", lead.remark || "");
//     if (r !== null) patchWebsiteLead(lead.id, "remark", r);
//   };

//   const handleCreated = (lead) => setLeads((prev) => [lead, ...prev]);

//   const handleMetaLeadProcessed = (savedLead, alreadyExisted) => {
//     setProcessedMetaIds((prev) => {
//       const n = new Set(prev);
//       n.add(savedLead.meta_lead_id);
//       return n;
//     });
//     setLeads((prev) =>
//       prev.some((l) => l.id === savedLead.id) ? prev : [savedLead, ...prev],
//     );
//   };

//   const handleWebsiteLeadProcessed = (savedLead, alreadyExisted) => {
//     setProcessedWebsiteIds((prev) => {
//       const n = new Set(prev);
//       n.add(String(savedLead.original_lead_id));
//       return n;
//     });
//     setProcessedWebsiteLeads((prev) =>
//       prev.some((l) => l.id === savedLead.id) ? prev : [savedLead, ...prev],
//     );
//   };

//   // ── Convert Meta leads → bookings ─────────────────────────────────────────
//   const handleConvertToBooking = async () => {
//     const leadsToConvert = leads.filter((l) => selectedRows.includes(l.id));
//     if (!leadsToConvert.length) return;
//     setConverting(true);
//     setConvertResult(null);
//     const results = { bookingids: [], errors: [] };
//     for (const lead of leadsToConvert) {
//       try {
//         const nameParts = (lead.name || "").trim().split(/\s+/);
//         const payload = {
//           firstname: nameParts[0] || "Unknown",
//           lastname: nameParts.slice(1).join(" ") || "",
//           email: lead.email || "",
//           phone: lead.phone || "",
//           tripexecutive:
//             lead.assignee && lead.assignee !== "Unassigned"
//               ? lead.assignee
//               : "",
//           bookingstatus: "Pending",
//           paymentstatus: "Pending",
//           source: channelToSource(lead.channel),
//         };
//         const res = await fetch(`${API}/createBooking`, {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify(payload),
//         });
//         if (!res.ok) {
//           const e = await res.json().catch(() => ({}));
//           throw new Error(e.message || `HTTP ${res.status}`);
//         }
//         const data = await res.json();
//         results.bookingids.push(data.bookingid || "—");
//         const delRes = await fetch(`${API}/leads/${lead.id}`, {
//           method: "DELETE",
//         });
//         if (!delRes.ok)
//           console.warn(
//             `Booking created but lead delete failed for id ${lead.id}`,
//           );
//       } catch (e) {
//         results.errors.push({ name: lead.name, error: e.message });
//       }
//     }
//     const failedNames = new Set(results.errors.map((e) => e.name));
//     const convertedIds = leadsToConvert
//       .filter((l) => !failedNames.has(l.name))
//       .map((l) => l.id);
//     setLeads((prev) => prev.filter((l) => !convertedIds.includes(l.id)));
//     setSelectedRows([]);
//     setConverting(false);
//     setConvertResult(results);
//   };

//   // ── Convert Website leads → bookings ──────────────────────────────────────
//   const handleWebsiteConvertToBooking = async () => {
//     const idsToConvert = selectedRows;
//     if (!idsToConvert.length) return;
//     setConverting(true);
//     setConvertResult(null);
//     try {
//       const res = await fetch(`${API}/website-leads/convert-booking`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ ids: idsToConvert }),
//       });
//       if (!res.ok) throw new Error(`HTTP ${res.status}`);
//       const data = await res.json();
//       const results = {
//         bookingids: data.bookingids || [],
//         errors: data.errors || [],
//       };
//       const failedIds = new Set((data.errors || []).map((e) => e.id));
//       const convertedIds = idsToConvert.filter((id) => !failedIds.has(id));
//       setProcessedWebsiteLeads((prev) =>
//         prev.filter((l) => !convertedIds.includes(l.id)),
//       );
//       setSelectedRows([]);
//       setConvertResult(results);
//     } catch (e) {
//       setConvertResult({
//         bookingids: [],
//         errors: [{ id: "all", error: e.message }],
//       });
//     } finally {
//       setConverting(false);
//     }
//   };

//   // ── Bulk process selected unprocessed website leads (NEW) ──────────────────
//   // selectedRows here contains leadId strings like "WL-5" for raw incoming rows
//   const handleBulkProcessWebsiteLeads = async () => {
//     // Filter only the raw incoming rows that are selected
//     const toProcess = currentLeads.filter(
//       (l) => l._isIncoming && selectedRows.includes(l.leadId),
//     );
//     if (!toProcess.length) return;
//     setBulkProcessing(true);
//     setBulkProcessResult(null);
//     const results = { processed: [], errors: [] };
//     for (const lead of toProcess) {
//       try {
//         const res = await fetch(`${API}/website-leads/process`, {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify({ leadId: lead.leadId }),
//         });
//         if (!res.ok) throw new Error(`HTTP ${res.status}`);
//         const { lead: savedLead } = await res.json();
//         results.processed.push(lead.customerName || lead.leadId);
//         handleWebsiteLeadProcessed(savedLead, false);
//       } catch (e) {
//         results.errors.push({
//           name: lead.customerName || lead.leadId,
//           error: e.message,
//         });
//       }
//     }
//     setSelectedRows([]);
//     setBulkProcessing(false);
//     setBulkProcessResult(results);
//   };

//   // ── Derived counts ─────────────────────────────────────────────────────────
//   const newMetaLeadsCount = leads.filter(
//     (l) =>
//       String(l.id).startsWith("meta_") &&
//       !processedMetaIds.has(String(l.id).replace("meta_", "")),
//   ).length;
//   const facebookCount = leads.filter(
//     (l) => l.channel === "Facebook Lead",
//   ).length;
//   const instagramCount = leads.filter(
//     (l) => l.channel === "Instagram DM",
//   ).length;
//   const whatsappCount = leads.filter((l) => l.channel === "WhatsApp").length;

//   const activeLeadList =
//     storeTab === "meta" ? visibleLeads : visibleWebsiteLeads;
//   const totalPages = Math.ceil(activeLeadList.length / rowsPerPage);
//   const indexOfFirst = (currentPage - 1) * rowsPerPage;
//   const indexOfLast = indexOfFirst + rowsPerPage;
//   const currentLeads = activeLeadList.slice(indexOfFirst, indexOfLast);

//   const generatePageNumbers = () => {
//     const pages = [];
//     if (totalPages <= 3) {
//       for (let i = 1; i <= totalPages; i++) pages.push(i);
//     } else {
//       if (currentPage > 2) {
//         pages.push(1);
//         pages.push("...");
//       }
//       for (let i = currentPage - 1; i <= currentPage + 1; i++) {
//         if (i > 0 && i <= totalPages) pages.push(i);
//       }
//       if (currentPage < totalPages - 1) {
//         pages.push("...");
//         pages.push(totalPages);
//       }
//     }
//     return pages;
//   };

//   const handleRowCheckboxChange = (id) =>
//     setSelectedRows((prev) =>
//       prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id],
//     );

//   const handleSelectAll = () =>
//     setSelectedRows(
//       selectedRows.length === currentLeads.length && currentLeads.length > 0
//         ? []
//         : currentLeads.map((l) => l.id || l.leadId),
//     );

//   const isIncomingView = activeStatus === "Incoming Leads";
//   const isAllLeadsView = activeStatus === "All Leads";
//   const isWebsiteIncomingView = websiteActiveStatus === "Incoming Leads";

//   // How many of the currently selected rows are raw-incoming website leads
//   const selectedUnprocessedWebsiteCount = currentLeads.filter(
//     (l) => l._isIncoming && selectedRows.includes(l.leadId),
//   ).length;
//   // How many are processed website leads
//   const selectedProcessedWebsiteCount = selectedRows.filter(
//     (id) => !currentLeads.find((l) => l._isIncoming && l.leadId === id),
//   ).length;

//   if (error && storeTab === "meta") {
//     return (
//       <div className="flex">
//         <Menubar
//           isOpen={isSidebarOpen}
//           setIsOpen={setIsSidebarOpen}
//           isMobile={isMobile}
//         />
//         <div className="flex-1 p-6 flex justify-center items-center h-64">
//           <div className="text-lg text-red-500">
//             {error}
//             <button
//               onClick={fetchLeads}
//               className="ml-3 underline text-indigo-500 text-sm"
//             >
//               Retry
//             </button>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="flex bg-[#F8F9FA]">
//       <Menubar
//         isOpen={isSidebarOpen}
//         setIsOpen={setIsSidebarOpen}
//         isMobile={isMobile}
//       />

//       <main
//         className={`p-5 lg:p-6 transition-all duration-500 w-full ${isMobile ? "ml-0" : isSidebarOpen ? "ml-64" : "ml-16"}`}
//       >
//         <Outlet />

//         {/* ── Header ────────────────────────────────────────────────────────── */}
//         <div className="flex justify-between gap-5 items-start lg:items-center">
//           <p className="font-semibold text-xl text-gray-700 ml-10 lg:ml-0">
//             Inquire Leads
//           </p>
//           <div className="flex items-center gap-1">
//             <div className="mr-2 p-2 overflow-hidden w-8 h-8 hover:w-[120px] sm:hover:w-[250px] hover:border hover:border-[#1D2826] hover:shadow-[2px_2px_20px_rgba(0,0,0,0.08)] rounded-full flex group items-center hover:duration-300 duration-300">
//               <div className="flex items-center justify-center fill-[#1D2826]">
//                 <svg
//                   xmlns="http://www.w3.org/2000/svg"
//                   viewBox="0 0 24 24"
//                   width="18"
//                   height="18"
//                 >
//                   <path d="M18.9,16.776A10.539,10.539,0,1,0,16.776,18.9l5.1,5.1L24,21.88ZM10.5,18A7.5,7.5,0,1,1,18,10.5,7.507,7.507,0,0,1,10.5,18Z" />
//                 </svg>
//               </div>
//               <input
//                 type="text"
//                 placeholder="Search name, phone…"
//                 value={searchInput}
//                 onChange={(e) => setSearchInput(e.target.value)}
//                 className="border-none outline-none text-sm bg-transparent w-full font-normal px-2 focus:ring-0"
//               />
//             </div>
//             <div className="flex items-center">
//               <div className="relative inline-block" ref={filterRef}>
//                 <div
//                   onClick={() => setShowPopup_filter((p) => !p)}
//                   className={`flex flex-col items-center gap-4 cursor-pointer select-none group scale-[0.75] py-2.5 px-2 rounded-full border-2 transition-all duration-300 ${showPopup_filter ? "border-[#1D2826]" : "border-transparent hover:border-[#1D2826]"}`}
//                 >
//                   {[
//                     ["100%", "0%"],
//                     ["0%", "100%"],
//                     ["100%", "0%"],
//                   ].map(([a, b], i) => (
//                     <div
//                       key={i}
//                       className={`relative w-6 h-0.5 bg-[#1D2826] rounded-full ${i === 1 ? "-my-2.5" : ""}`}
//                     >
//                       <div
//                         className="absolute top-1/2 -translate-y-1/2 w-2 h-2 rounded-full border-2 border-black bg-white transition-all duration-300"
//                         style={{
//                           left: showPopup_filter ? a : b,
//                           transform: `translate(${showPopup_filter ? (i === 1 ? "0" : "-100%") : i === 1 ? "0" : "-0%"},-50%)`,
//                         }}
//                       />
//                     </div>
//                   ))}
//                 </div>
//                 {showPopup_filter && (
//                   <div className="absolute top-full mt-1 right-0 bg-white border rounded-lg shadow-custom z-10 p-4 space-y-4">
//                     <div className="flex flex-col gap-2">
//                       <p className="text-xs font-semibold text-gray-500 uppercase">
//                         Channel
//                       </p>
//                       <div className="flex gap-1 flex-wrap">
//                         {[
//                           "All",
//                           "Instagram DM",
//                           "Facebook Lead",
//                           "WhatsApp",
//                         ].map((ch) => (
//                           <button
//                             key={ch}
//                             onClick={() => setActiveChannel(ch)}
//                             className={`py-1 px-2 rounded text-xs font-medium transition-colors ${activeChannel === ch ? "bg-[#1D2826] text-white" : "bg-gray-100 hover:bg-[#DAE0CE]"}`}
//                           >
//                             {ch}
//                           </button>
//                         ))}
//                       </div>
//                     </div>
//                     <div className="flex flex-col gap-2">
//                       <p className="text-xs font-semibold text-gray-500 uppercase">
//                         Tag
//                       </p>
//                       <div className="flex gap-1">
//                         {["All", "Hot", "Warm", "Cold"].map((t) => (
//                           <button
//                             key={t}
//                             onClick={() => setActiveTag(t)}
//                             className={`py-1 px-2 rounded text-xs font-medium transition-colors ${activeTag === t ? "bg-[#1D2826] text-white" : "bg-gray-100 hover:bg-[#DAE0CE]"}`}
//                           >
//                             {t}
//                           </button>
//                         ))}
//                       </div>
//                     </div>
//                     <div className="flex flex-col gap-2">
//                       <p className="text-xs font-semibold text-gray-500 uppercase">
//                         Date Range
//                       </p>
//                       <div className="flex justify-between gap-2">
//                         {["Today", "Week", "Month", "Year"].map((label) => (
//                           <button
//                             key={label}
//                             className="flex-1 py-1 px-2 bg-gray-100 active:bg-[#DAE0CE] hover:bg-[#DAE0CE] rounded text-sm font-medium"
//                           >
//                             {label}
//                           </button>
//                         ))}
//                       </div>
//                       <div className="flex items-center gap-2">
//                         <input
//                           type="date"
//                           className="border text-sm rounded px-2 py-1 w-full focus:outline-none focus:ring-1 focus:ring-green-600 focus:border-black"
//                         />
//                         <span className="text-sm text-gray-500">-</span>
//                         <input
//                           type="date"
//                           className="border text-sm rounded px-2 py-1 w-full focus:outline-none focus:ring-1 focus:ring-green-600 focus:border-black"
//                         />
//                       </div>
//                     </div>
//                   </div>
//                 )}
//               </div>
//             </div>
//             <button
//               onClick={
//                 storeTab === "meta"
//                   ? fetchLeads
//                   : () => {
//                       fetchWebsiteLeads();
//                       fetchProcessedWebsiteLeads();
//                     }
//               }
//               title="Refresh"
//               className="p-2 rounded-lg text-xl cursor-pointer border-none"
//             >
//               <TbRefresh />
//             </button>
//             {storeTab === "meta" && (
//               <button
//                 onClick={() => setShowCreate(true)}
//                 className="ml-1 px-4 py-2 bg-[#1D2826] rounded-lg text-white text-sm font-semibold hover:scale-95 transition-all duration-200"
//               >
//                 + New Lead
//               </button>
//             )}
//           </div>
//         </div>

//         {/* ── Meta Stat Boxes ───────────────────────────────────────────────── */}
//         {storeTab === "meta" && (
//           <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 items-center gap-5 text-gray-700 font-semibold mt-5">
//             {[
//               [
//                 "FaceBook Leads",
//                 facebookCount,
//                 <IoLogoFacebook className="bg-[#3C4C4E] text-3xl text-white p-1.5 rounded-md" />,
//               ],
//               [
//                 "Instagram Leads",
//                 instagramCount,
//                 <RiInstagramFill className="bg-[#3C4C4E] text-3xl text-white p-1.5 rounded-md" />,
//               ],
//               [
//                 "WhatsApp Leads",
//                 whatsappCount,
//                 <IoLogoWhatsapp className="bg-[#3C4C4E] text-3xl text-white p-1.5 rounded-md" />,
//               ],
//               [
//                 "Unprocessed (Meta)",
//                 newMetaLeadsCount,
//                 <TbDeviceAnalytics className="bg-[#3C4C4E] text-3xl text-white p-1.5 rounded-md" />,
//               ],
//             ].map(([label, count, icon]) => (
//               <div
//                 key={label}
//                 className="flex items-center justify-between gap-5 bg-[#DAE0CE] py-2 px-4 rounded-lg"
//               >
//                 <div>
//                   <p>{label}</p>
//                   <p className="mt-2 text-lg text-black">{count}</p>
//                 </div>
//                 {icon}
//               </div>
//             ))}
//           </div>
//         )}

//         {/* ── Website Stat Boxes ────────────────────────────────────────────── */}
//         {storeTab === "website" && (
//           <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 text-gray-700 font-semibold mt-5">
//             <div className="flex items-center justify-between gap-5 bg-[#DAE0CE] py-2 px-4 rounded-lg">
//               <div>
//                 <p>Incoming</p>
//                 <p className="mt-2 text-lg text-black">
//                   {
//                     websiteLeads.filter(
//                       (l) =>
//                         !processedWebsiteIds.has(
//                           String(l.leadId).replace("WL-", ""),
//                         ),
//                     ).length
//                   }
//                 </p>
//               </div>
//               <RxOpenInNewWindow className="bg-[#3C4C4E] text-3xl text-white p-1.5 rounded-md" />
//             </div>
//             <div className="flex items-center justify-between gap-5 bg-[#DAE0CE] py-2 px-4 rounded-lg">
//               <div>
//                 <p>Processed</p>
//                 <p className="mt-2 text-lg text-black">
//                   {processedWebsiteLeads.length}
//                 </p>
//               </div>
//               <MdFileDownloadDone className="bg-[#3C4C4E] text-3xl text-white p-1.5 rounded-md" />
//             </div>
//             <div className="flex items-center justify-between gap-5 bg-[#DAE0CE] py-2 px-4 rounded-lg">
//               <div>
//                 <p>Total Leads (Website)</p>
//                 <p className="mt-2 text-lg text-black">
//                   {websiteLeads.filter(
//                     (l) =>
//                       !processedWebsiteIds.has(
//                         String(l.leadId).replace("WL-", ""),
//                       ),
//                   ).length + processedWebsiteLeads.length}
//                 </p>
//               </div>
//               <TbDeviceAnalytics className="bg-[#3C4C4E] text-3xl text-white p-1.5 rounded-md" />
//             </div>
//           </div>
//         )}

//         {/* ── Tab Switcher ──────────────────────────────────────────────────── */}
//         <div className="inline-flex border border-gray-300 rounded-lg overflow-hidden text-sm font-medium shadow-sm mt-5">
//           <button
//             onClick={() => setStoreTab("meta")}
//             className={`px-4 py-2 transition-colors duration-200 focus:outline-none ${storeTab === "meta" ? "bg-[#1D2826] text-white" : "bg-white text-gray-500 hover:bg-green-50"}`}
//           >
//             Meta Leads
//           </button>
//           <button
//             onClick={() => setStoreTab("website")}
//             className={`px-4 py-2 transition-colors duration-200 focus:outline-none ${storeTab === "website" ? "bg-[#1D2826] text-white" : "bg-white text-gray-500 hover:bg-green-50"}`}
//           >
//             Website Leads
//           </button>
//         </div>

//         {/* ── Meta Pipeline Tabs ────────────────────────────────────────────── */}
//         {storeTab === "meta" && (
//           <div className="mt-6">
//             <div className="flex w-full items-center text-[11px] font-semibold overflow-x-auto">
//               {PIPELINE_STAGES.map((stage) => {
//                 const isActive = activeStatus === stage.status;
//                 return (
//                   <button
//                     key={stage.name}
//                     onClick={() => setActiveStatus(stage.status)}
//                     className={`relative flex-shrink-0 flex-1 min-w-[70px] h-9 px-1 leading-tight transition-all ${stage.color} ${isActive ? "ring-1 ring-black z-10" : ""}`}
//                     style={{
//                       clipPath:
//                         "polygon(0 0, calc(100% - 12px) 0, 100% 50%, calc(100% - 12px) 100%, 0 100%, 12px 50%)",
//                       marginRight: "-6px",
//                     }}
//                   >
//                     <span className="flex flex-col items-center justify-center gap-0.5 w-full">
//                       <span>{stage.name}</span>
//                       <span
//                         className="rounded-full transition-all duration-200"
//                         style={{
//                           width: isActive ? 5 : 0,
//                           height: isActive ? 5 : 0,
//                           background: "currentColor",
//                           opacity: isActive ? 1 : 0,
//                           display: "block",
//                         }}
//                       />
//                     </span>
//                   </button>
//                 );
//               })}
//             </div>
//           </div>
//         )}

//         {/* ── Website Pipeline Tabs ─────────────────────────────────────────── */}
//         {storeTab === "website" && (
//           <div className="mt-6">
//             <div className="flex w-full items-center text-[11px] font-semibold overflow-x-auto">
//               {WEBSITE_PIPELINE_STAGES.map((stage) => {
//                 const isActive = websiteActiveStatus === stage.status;
//                 return (
//                   <button
//                     key={stage.name}
//                     onClick={() => setWebsiteActiveStatus(stage.status)}
//                     className={`relative flex-shrink-0 flex-1 min-w-[70px] h-9 px-1 leading-tight transition-all ${stage.color} ${isActive ? "ring-1 ring-black z-10" : ""}`}
//                     style={{
//                       clipPath:
//                         "polygon(0 0, calc(100% - 12px) 0, 100% 50%, calc(100% - 12px) 100%, 0 100%, 12px 50%)",
//                       marginRight: "-6px",
//                     }}
//                   >
//                     <span className="flex flex-col items-center justify-center gap-0.5 w-full">
//                       <span>{stage.name}</span>
//                       <span
//                         className="rounded-full transition-all duration-200"
//                         style={{
//                           width: isActive ? 5 : 0,
//                           height: isActive ? 5 : 0,
//                           background: "currentColor",
//                           opacity: isActive ? 1 : 0,
//                           display: "block",
//                         }}
//                       />
//                     </span>
//                   </button>
//                 );
//               })}
//             </div>
//           </div>
//         )}

//         {/* ── Action bars above table ───────────────────────────────────────── */}

//         {/* Convert to Booking — Meta processed OR Website processed rows selected */}
//         {selectedRows.length > 0 &&
//           ((storeTab === "meta" && !isIncomingView) ||
//             (storeTab === "website" &&
//               !isWebsiteIncomingView &&
//               selectedProcessedWebsiteCount > 0)) && (
//             <div className="mt-4 flex items-center justify-between  rounded-xl px-4 py-2.5">
//               <span className="text-sm text-amber-700 font-medium">
//                 {selectedRows.length} lead{selectedRows.length > 1 ? "s" : ""}{" "}
//                 selected
//               </span>
//               <button
//                 onClick={() => setShowConvertModal(true)}
//                 className="px-4 py-1.5 bg-[#1D2826] text-white text-xs font-semibold rounded-lg hover:scale-95 transition-all duration-200 cursor-pointer"
//               >
//                 Convert to Booking
//               </button>
//             </div>
//           )}

//         {/* Process Leads — unprocessed website rows selected (NEW) */}
//         {storeTab === "website" && selectedUnprocessedWebsiteCount > 0 && (
//           <div className="mt-4 flex items-center justify-between rounded-xl px-4 py-2.5">
//             <span className="text-sm text-orange-700 font-medium">
//               {selectedUnprocessedWebsiteCount} unprocessed lead
//               {selectedUnprocessedWebsiteCount > 1 ? "s" : ""} selected
//             </span>
//             <button
//               onClick={() => setShowBulkProcessModal(true)}
//               className="px-4 py-1.5 bg-yellow-200 text-yellow-600 text-xs font-semibold rounded-lg hover:scale-95 transition-all duration-200 cursor-pointer"
//             >
//               Process Selected Leads
//             </button>
//           </div>
//         )}

//         {/* ══════════════════  META TABLE  ══════════════════════════════════ */}
//         {storeTab === "meta" && (
//           <div className="shadow-md rounded-lg mt-5">
//             <div className="overflow-x-auto">
//               <table className="w-full text-sm text-left text-gray-500">
//                 <thead className="text-xs text-gray-400 uppercase bg-green-50 border-b">
//                   <tr>
//                     <th className="p-4">
//                       <input
//                         type="checkbox"
//                         onChange={handleSelectAll}
//                         checked={
//                           selectedRows.length === currentLeads.length &&
//                           currentLeads.length > 0
//                         }
//                       />
//                     </th>
//                     <th className="p-4">Lead Details</th>
//                     <th className="p-4">Enquiry</th>
//                     {isIncomingView ? (
//                       <>
//                         <th className="p-4">Meta Fields</th>
//                         <th className="p-4">Action</th>
//                       </>
//                     ) : (
//                       <>
//                         <th className="p-4">Status</th>
//                         <th className="p-4">Assigned To</th>
//                         <th className="p-4">Remark</th>
//                         <th className="p-4">Date</th>
//                         <th className="p-4">Actions</th>
//                       </>
//                     )}
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {loading ? (
//                     <tr>
//                       <td
//                         colSpan={isIncomingView ? 5 : 9}
//                         className="text-center py-14 text-gray-400"
//                       >
//                         Loading leads…
//                       </td>
//                     </tr>
//                   ) : currentLeads.length === 0 ? (
//                     <tr>
//                       <td
//                         colSpan={isIncomingView ? 5 : 9}
//                         className="text-center py-14 text-gray-400"
//                       >
//                         {isIncomingView
//                           ? "No unprocessed Meta leads. They'll appear here automatically via Meta webhooks."
//                           : "No leads found for this filter."}
//                       </td>
//                     </tr>
//                   ) : (
//                     currentLeads.map((lead, idx) => {
//                       const ch = CHANNELS[lead.channel] || {
//                         color: "#888",
//                         bg: "#f1f5f9",
//                         icon: "",
//                       };
//                       const isExpanded = expandedLead === lead.id;
//                       const dimmed = updatingId === lead.id;
//                       const isMetaLead = String(lead.id).startsWith("meta_");
//                       const showProcessButton = isAllLeadsView && isMetaLead;
//                       return (
//                         <React.Fragment key={lead.id}>
//                           <tr
//                             className={`border-b border-gray-200 hover:bg-gray-100 text-gray-800 transition-opacity ${idx % 2 === 0 ? "bg-white" : "bg-gray-50"}`}
//                             style={{ opacity: dimmed ? 0.55 : 1 }}
//                           >
//                             <td className="px-4 py-3">
//                               <input
//                                 type="checkbox"
//                                 onChange={() =>
//                                   handleRowCheckboxChange(lead.id)
//                                 }
//                                 checked={selectedRows.includes(lead.id)}
//                               />
//                             </td>
//                             <td className="px-4 py-3 min-w-[180px]">
//                               <div className="font-bold text-gray-800 mb-1">
//                                 {lead.name || "—"}
//                               </div>
//                               <div className="flex flex-wrap items-center gap-1 mb-1">
//                                 <span
//                                   className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] font-bold"
//                                   style={{ background: ch.bg, color: ch.color }}
//                                 >
//                                   <span className="text-xs">{ch.icon}</span>
//                                   <span>{lead.channel}</span>
//                                 </span>
//                                 {lead.tag && (
//                                   <span
//                                     className="px-1.5 py-0.5 rounded-full text-[10px] font-bold"
//                                     style={{
//                                       background:
//                                         (TAG_COLORS[lead.tag] || "#999") + "18",
//                                       color: TAG_COLORS[lead.tag] || "#999",
//                                     }}
//                                   >
//                                     {lead.tag}
//                                   </span>
//                                 )}
//                                 {isAllLeadsView && isMetaLead && (
//                                   <span className="px-1.5 py-0.5 rounded-full text-[10px] font-bold bg-amber-100 text-amber-600">
//                                     Unprocessed
//                                   </span>
//                                 )}
//                               </div>
//                               {lead.phone && (
//                                 <div className="inline-flex items-center gap-1 text-xs text-gray-500">
//                                   <FaPhone />
//                                   <span>{lead.phone}</span>
//                                 </div>
//                               )}
//                               <br />
//                               {lead.email && (
//                                 <div className="inline-flex items-center gap-1 text-xs text-gray-400">
//                                   <IoMail />
//                                   <span>{lead.email}</span>
//                                 </div>
//                               )}
//                               <br />
//                               <div className="inline-flex items-center gap-1 text-xs text-gray-400 mt-1">
//                                 <IoIosTime />
//                                 <span>{timeAgo(lead.created_at)}</span>
//                               </div>
//                             </td>
//                             <td className="px-4 py-3 max-w-[220px]">
//                               <div className="text-xs text-gray-600 leading-relaxed whitespace-pre-wrap">
//                                 {lead.enquiry
//                                   ? lead.enquiry.split("\n").map((line, i) => {
//                                       const clean = line
//                                         .replace(/^•\s*/, "")
//                                         .trim();
//                                       const parts = clean.split(":");
//                                       const question = parts[0];
//                                       const answer = parts
//                                         .slice(1)
//                                         .join(":")
//                                         .trim();
//                                       return (
//                                         <div key={i} className="mb-2">
//                                           <div>➤ {question}:</div>
//                                           {answer && (
//                                             <div className="ml-3 font-bold text-gray-800">
//                                               ↳ {answer}
//                                             </div>
//                                           )}
//                                         </div>
//                                       );
//                                     })
//                                   : "—"}
//                               </div>
//                             </td>
//                             {isIncomingView ? (
//                               <>
//                                 <td className="px-4 py-3 max-w-[220px]">
//                                   {(lead.field_data || []).length > 0 ? (
//                                     <div className="flex flex-col gap-1">
//                                       {lead.field_data.map((f, fi) => (
//                                         <div
//                                           key={fi}
//                                           className="text-[11px] text-gray-600"
//                                         >
//                                           <span className="text-gray-400 uppercase text-[10px]">
//                                             {f.name.replace(/_/g, " ")}:{" "}
//                                           </span>
//                                           <span className="font-semibold text-gray-700">
//                                             {f.values?.[0] || "—"}
//                                           </span>
//                                         </div>
//                                       ))}
//                                     </div>
//                                   ) : (
//                                     <span className="text-xs text-gray-300">
//                                       —
//                                     </span>
//                                   )}
//                                 </td>
//                                 <td className="px-4 py-3">
//                                   <ProcessMetaLeadButton
//                                     lead={lead}
//                                     onProcessed={handleMetaLeadProcessed}
//                                   />
//                                 </td>
//                               </>
//                             ) : (
//                               <>
//                                 <td className="px-4 py-3">
//                                   {showProcessButton ? (
//                                     <ProcessMetaLeadButton
//                                       lead={lead}
//                                       onProcessed={handleMetaLeadProcessed}
//                                     />
//                                   ) : (
//                                     <select
//                                       value={lead.status || ""}
//                                       onChange={(e) =>
//                                         patchLead(
//                                           lead.id,
//                                           "status",
//                                           e.target.value,
//                                         )
//                                       }
//                                       className="p-1.5 rounded-md text-[11px] font-bold cursor-pointer outline-none border"
//                                       style={{
//                                         borderColor:
//                                           STATUS_COLORS[lead.status] || "#ccc",
//                                         background:
//                                           (STATUS_COLORS[lead.status] ||
//                                             "#ccc") + "18",
//                                         color:
//                                           STATUS_COLORS[lead.status] || "#555",
//                                       }}
//                                     >
//                                       {STATUSES.map((s) => (
//                                         <option key={s} value={s}>
//                                           {s}
//                                         </option>
//                                       ))}
//                                     </select>
//                                   )}
//                                 </td>
//                                 <td className="px-4 py-3">
//                                   {showProcessButton ? (
//                                     <span className="text-xs text-gray-300">
//                                       —
//                                     </span>
//                                   ) : (
//                                     <select
//                                       value={lead.assignee || "Unassigned"}
//                                       onChange={(e) =>
//                                         patchLead(
//                                           lead.id,
//                                           "assignee",
//                                           e.target.value,
//                                         )
//                                       }
//                                       className="p-1.5 rounded-md border border-gray-200 bg-white text-xs cursor-pointer outline-none"
//                                     >
//                                       {TEAM.map((t) => (
//                                         <option key={t}>{t}</option>
//                                       ))}
//                                     </select>
//                                   )}
//                                 </td>
//                                 <td className="px-4 py-3">
//                                   {showProcessButton ? (
//                                     <span className="text-xs text-gray-300">
//                                       —
//                                     </span>
//                                   ) : lead.remark ? (
//                                     <div
//                                       onClick={() => addRemark(lead)}
//                                       title="Click to edit"
//                                       className="text-xs text-gray-600 bg-gray-50 rounded-md px-2 py-1 max-w-[160px] cursor-pointer leading-snug"
//                                     >
//                                       {lead.remark}
//                                     </div>
//                                   ) : (
//                                     <button
//                                       onClick={() => addRemark(lead)}
//                                       className="text-[11px] text-indigo-500 bg-transparent border border-dashed border-indigo-400 rounded-md px-2 py-1 cursor-pointer"
//                                     >
//                                       + Add Remark
//                                     </button>
//                                   )}
//                                 </td>
//                                 <td className="px-4 py-3">
//                                   {showProcessButton ? (
//                                     <span className="text-xs text-gray-300">
//                                       —
//                                     </span>
//                                   ) : (
//                                     <Tooltip
//                                       title={
//                                         lead.created_at
//                                           ? new Date(
//                                               lead.created_at,
//                                             ).toLocaleString()
//                                           : "—"
//                                       }
//                                       placement="left"
//                                     >
//                                       <span className="text-xs">
//                                         {lead.created_at
//                                           ? new Date(
//                                               lead.created_at,
//                                             ).toLocaleDateString()
//                                           : "—"}
//                                       </span>
//                                     </Tooltip>
//                                   )}
//                                 </td>
//                                 <td className="px-4 py-3">
//                                   {!showProcessButton && (
//                                     <div className="flex flex-col gap-1.5">
//                                       <button
//                                         onClick={() => setFollowUpLead(lead)}
//                                         className="bg-[#a19993] text-white border-none rounded-md px-2.5 py-1.5 text-[11px] font-semibold cursor-pointer"
//                                       >
//                                         Follow Up
//                                       </button>
//                                       <button
//                                         onClick={() =>
//                                           setExpandedLead(
//                                             isExpanded ? null : lead.id,
//                                           )
//                                         }
//                                         className="bg-gray-100 text-gray-600 border-none rounded-md px-2.5 py-1.5 text-[11px] cursor-pointer"
//                                       >
//                                         {isExpanded ? "▲ Less" : "▼ Details"}
//                                       </button>
//                                     </div>
//                                   )}
//                                 </td>
//                               </>
//                             )}
//                           </tr>
//                           {!isMetaLead && isExpanded && (
//                             <tr className="bg-gray-50">
//                               <td colSpan={9} className="px-6 py-4">
//                                 <div className="flex gap-7 flex-wrap">
//                                   {[
//                                     ["Lead ID", lead.id],
//                                     ["Meta ID", lead.meta_lead_id || "—"],
//                                     ["Email", lead.email || "—"],
//                                     ["Phone", lead.phone || "—"],
//                                     ["Channel", lead.channel],
//                                     ["Assigned To", lead.assignee || "—"],
//                                     ["Status", lead.status],
//                                     ["Tag", lead.tag || "—"],
//                                     ["Remark", lead.remark || "—"],
//                                     [
//                                       "Received",
//                                       lead.created_at
//                                         ? new Date(
//                                             lead.created_at,
//                                           ).toLocaleString()
//                                         : "—",
//                                     ],
//                                   ].map(([label, val]) => (
//                                     <div key={label} className="min-w-[90px]">
//                                       <div className="text-[10px] text-gray-400 uppercase font-bold mb-0.5">
//                                         {label}
//                                       </div>
//                                       <div
//                                         className="text-sm"
//                                         style={{
//                                           color:
//                                             label === "Status"
//                                               ? STATUS_COLORS[val]
//                                               : "#333",
//                                           fontWeight:
//                                             label === "Status" ? 700 : 400,
//                                         }}
//                                       >
//                                         {String(val)}
//                                       </div>
//                                     </div>
//                                   ))}
//                                 </div>
//                               </td>
//                             </tr>
//                           )}
//                         </React.Fragment>
//                       );
//                     })
//                   )}
//                 </tbody>
//               </table>
//             </div>
//             <nav className="flex items-center flex-col md:flex-row justify-between rounded-b-lg px-2 py-1 bg-[#f7f7f7]">
//               <span className="text-xs font-normal text-gray-500 mb-4 md:mb-0 block w-full md:inline md:w-auto">
//                 Showing{" "}
//                 <span className="font-semibold text-gray-700">
//                   {visibleLeads.length > 0 ? indexOfFirst + 1 : 0}–
//                   {Math.min(indexOfLast, visibleLeads.length)}
//                 </span>{" "}
//                 of{" "}
//                 <span className="font-semibold text-gray-700">
//                   {visibleLeads.length}
//                 </span>
//               </span>
//               <ul className="inline-flex -space-x-px rtl:space-x-reverse text-xs h-8">
//                 <li>
//                   <button
//                     onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
//                     disabled={currentPage === 1}
//                     className="flex items-center justify-center px-1 h-8 leading-tight text-gray-500 bg-[#f7f7f7] border-gray-300 rounded-s-lg hover:bg-gray-100"
//                   >
//                     <MdKeyboardDoubleArrowLeft />
//                   </button>
//                 </li>
//                 {generatePageNumbers().map((page, index) =>
//                   page === "..." ? (
//                     <li
//                       key={index}
//                       className="px-1 h-8 flex items-center justify-center text-gray-500"
//                     >
//                       <span>...</span>
//                     </li>
//                   ) : (
//                     <li key={index}>
//                       <button
//                         onClick={() => setCurrentPage(page)}
//                         className={`flex items-center justify-center px-3 h-8 leading-tight text-gray-500 bg-[#f7f7f7] border-gray-300 hover:bg-gray-100 ${currentPage === page ? "text-green-500 underline underline-offset-2" : ""}`}
//                       >
//                         {page}
//                       </button>
//                     </li>
//                   ),
//                 )}
//                 <li>
//                   <button
//                     onClick={() =>
//                       setCurrentPage((p) => Math.min(p + 1, totalPages))
//                     }
//                     disabled={currentPage === totalPages}
//                     className="flex items-center justify-center px-1 h-8 leading-tight text-gray-500 bg-[#f7f7f7] border-gray-300 rounded-e-lg hover:bg-gray-100"
//                   >
//                     <MdKeyboardDoubleArrowRight />
//                   </button>
//                 </li>
//               </ul>
//             </nav>
//           </div>
//         )}

//         {/* ══════════════════  WEBSITE TABLE  ═══════════════════════════════ */}
//         {storeTab === "website" && (
//           <div className="shadow-md rounded-lg mt-5">
//             <div className="overflow-x-auto">
//               <table className="w-full text-sm text-left text-gray-500">
//                 <thead className="text-xs text-gray-400 uppercase bg-green-50 border-b">
//                   <tr>
//                     {!isWebsiteIncomingView && (
//                       <th className="p-4">
//                         <input
//                           type="checkbox"
//                           onChange={handleSelectAll}
//                           checked={
//                             selectedRows.length === currentLeads.length &&
//                             currentLeads.length > 0
//                           }
//                         />
//                       </th>
//                     )}
//                     <th className="p-4">Lead ID</th>
//                     <th className="p-4">Customer</th>
//                     <th className="p-4">Property / Destination</th>
//                     <th className="p-4">Check-In → Check-Out</th>
//                     <th className="p-4">Location</th>
//                     {isWebsiteIncomingView ? (
//                       <th className="p-4">Action</th>
//                     ) : (
//                       <>
//                         <th className="p-4">Status</th>
//                         <th className="p-4">Assigned To</th>
//                         <th className="p-4">Remark</th>
//                         <th className="p-4">Actions</th>
//                       </>
//                     )}
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {(
//                     isWebsiteIncomingView
//                       ? websiteLoading
//                       : processedWebsiteLoading
//                   ) ? (
//                     <tr>
//                       <td
//                         colSpan={isWebsiteIncomingView ? 7 : 10}
//                         className="text-center py-14 text-gray-400"
//                       >
//                         Loading website leads…
//                       </td>
//                     </tr>
//                   ) : websiteError && isWebsiteIncomingView ? (
//                     <tr>
//                       <td
//                         colSpan={7}
//                         className="text-center py-14 text-red-400"
//                       >
//                         {websiteError}
//                       </td>
//                     </tr>
//                   ) : currentLeads.length === 0 ? (
//                     <tr>
//                       <td
//                         colSpan={isWebsiteIncomingView ? 7 : 10}
//                         className="text-center py-14 text-gray-400"
//                       >
//                         {isWebsiteIncomingView
//                           ? "No new website leads. All incoming leads have been processed."
//                           : "No processed website leads found for this stage."}
//                       </td>
//                     </tr>
//                   ) : isWebsiteIncomingView ? (
//                     currentLeads.map((lead, idx) => (
//                       <tr
//                         key={lead.leadId}
//                         className={`border-b border-gray-200 hover:bg-gray-100 text-gray-800 ${idx % 2 === 0 ? "bg-white" : "bg-gray-50"}`}
//                       >
//                         <td className="px-4 py-3 text-xs font-mono text-indigo-600">
//                           {lead.leadId}
//                         </td>
//                         <td className="px-4 py-3 min-w-[160px]">
//                           <div className="font-bold text-gray-800 mb-1">
//                             {lead.customerName || "—"}
//                           </div>
//                           {lead.phone && (
//                             <div className="inline-flex items-center gap-1 text-xs text-gray-500">
//                               <FaPhone />
//                               {lead.phone}
//                             </div>
//                           )}
//                           <br />
//                           {lead.email && (
//                             <div className="inline-flex items-center gap-1 text-xs text-gray-400">
//                               <IoMail />
//                               {lead.email}
//                             </div>
//                           )}
//                         </td>
//                         <td className="px-4 py-3">
//                           <div className="font-semibold text-gray-700 text-xs">
//                             {lead.property || "—"}
//                           </div>
//                           <div className="text-xs text-gray-400 mt-0.5">
//                             {lead.destination || "—"}
//                           </div>
//                         </td>
//                         <td className="px-4 py-3 text-xs text-gray-600 whitespace-nowrap">
//                           <div className="inline-flex items-center gap-1">
//                             <FaCalendarAlt className="text-gray-400" />
//                             {lead.checkin
//                               ? new Date(lead.checkin).toLocaleDateString()
//                               : "N/A"}
//                             {" → "}
//                             {lead.checkout
//                               ? new Date(lead.checkout).toLocaleDateString()
//                               : "N/A"}
//                           </div>
//                         </td>
//                         <td className="px-4 py-3 text-xs text-gray-500">
//                           <div className="inline-flex items-center gap-1">
//                             {[lead.city, lead.state, lead.country]
//                               .filter(Boolean)
//                               .join(", ") || "—"}
//                           </div>
//                         </td>
//                         <td className="px-4 py-3">
//                           <ProcessWebsiteLeadButton
//                             lead={lead}
//                             onProcessed={handleWebsiteLeadProcessed}
//                           />
//                         </td>
//                       </tr>
//                     ))
//                   ) : (
//                     currentLeads.map((lead, idx) => {
//                       const dimmed = updatingId === lead.id;
//                       const isRawIncoming = lead._isIncoming === true;
//                       return (
//                         <tr
//                           key={lead.id || lead.leadId}
//                           className={`border-b border-gray-200 hover:bg-gray-100 text-gray-800 transition-opacity ${idx % 2 === 0 ? "bg-white" : "bg-gray-50"}`}
//                           style={{ opacity: dimmed ? 0.55 : 1 }}
//                         >
//                           {/* ── Checkbox for BOTH processed and unprocessed (CHANGED) ── */}
//                           <td className="px-4 py-3">
//                             <input
//                               type="checkbox"
//                               onChange={() =>
//                                 handleRowCheckboxChange(
//                                   isRawIncoming ? lead.leadId : lead.id,
//                                 )
//                               }
//                               checked={selectedRows.includes(
//                                 isRawIncoming ? lead.leadId : lead.id,
//                               )}
//                             />
//                           </td>
//                           <td className="px-4 py-3 text-xs font-mono text-indigo-600">
//                             <div className="flex items-center gap-1.5">
//                               {isRawIncoming
//                                 ? lead.leadId
//                                 : `WL-${lead.original_lead_id}`}
//                               {isRawIncoming && (
//                                 <span className="text-[10px] bg-amber-100 text-amber-600 px-1.5 py-0.5 rounded-full font-bold whitespace-nowrap">
//                                   Unprocessed
//                                 </span>
//                               )}
//                             </div>
//                           </td>
//                           <td className="px-4 py-3 min-w-[160px]">
//                             <div className="font-bold text-gray-800 mb-1">
//                               {isRawIncoming
//                                 ? lead.customerName || "—"
//                                 : lead.customer_name || "—"}
//                             </div>
//                             {lead.phone && (
//                               <div className="inline-flex items-center gap-1 text-xs text-gray-500">
//                                 <FaPhone />
//                                 {lead.phone}
//                               </div>
//                             )}
//                             <br />
//                             {lead.email && (
//                               <div className="inline-flex items-center gap-1 text-xs text-gray-400">
//                                 <IoMail />
//                                 {lead.email}
//                               </div>
//                             )}
//                             {!isRawIncoming && lead.converted === 1 && (
//                               <div className="mt-1">
//                                 <span className="text-[10px] bg-green-100 text-green-700 px-1.5 py-0.5 rounded-full font-bold">
//                                   ✓ Converted
//                                 </span>
//                               </div>
//                             )}
//                           </td>
//                           <td className="px-4 py-3">
//                             <div className="font-semibold text-gray-700 text-xs">
//                               {lead.property || "—"}
//                             </div>
//                             <div className="text-xs text-gray-400 mt-0.5">
//                               {lead.destination || "—"}
//                             </div>
//                           </td>
//                           <td className="px-4 py-3 text-xs text-gray-600 whitespace-nowrap">
//                             <div className="inline-flex items-center gap-1">
//                               <FaCalendarAlt className="text-gray-400" />
//                               {isRawIncoming
//                                 ? lead.checkin
//                                   ? new Date(lead.checkin).toLocaleDateString()
//                                   : "—"
//                                 : lead.check_in
//                                   ? new Date(lead.check_in).toLocaleDateString()
//                                   : "—"}
//                               {" → "}
//                               {isRawIncoming
//                                 ? lead.checkout
//                                   ? new Date(lead.checkout).toLocaleDateString()
//                                   : "—"
//                                 : lead.check_out
//                                   ? new Date(
//                                       lead.check_out,
//                                     ).toLocaleDateString()
//                                   : "—"}
//                             </div>
//                           </td>
//                           <td className="px-4 py-3 text-xs text-gray-500">
//                             <div className="inline-flex items-center gap-1">
//                               {[lead.city, lead.state, lead.country]
//                                 .filter(Boolean)
//                                 .join(", ") || "—"}
//                             </div>
//                           </td>
//                           <td className="px-4 py-3">
//                             {isRawIncoming ? (
//                               <ProcessWebsiteLeadButton
//                                 lead={lead}
//                                 onProcessed={handleWebsiteLeadProcessed}
//                               />
//                             ) : (
//                               <select
//                                 value={lead.status || "New Lead"}
//                                 onChange={(e) =>
//                                   patchWebsiteLead(
//                                     lead.id,
//                                     "status",
//                                     e.target.value,
//                                   )
//                                 }
//                                 className="p-1.5 rounded-md text-[11px] font-bold cursor-pointer outline-none border"
//                                 style={{
//                                   borderColor:
//                                     WEBSITE_STATUS_COLORS[lead.status] ||
//                                     "#ccc",
//                                   background:
//                                     (WEBSITE_STATUS_COLORS[lead.status] ||
//                                       "#ccc") + "18",
//                                   color:
//                                     WEBSITE_STATUS_COLORS[lead.status] ||
//                                     "#555",
//                                 }}
//                               >
//                                 {WEBSITE_STATUSES.map((s) => (
//                                   <option key={s} value={s}>
//                                     {s}
//                                   </option>
//                                 ))}
//                               </select>
//                             )}
//                           </td>
//                           <td className="px-4 py-3">
//                             {isRawIncoming ? (
//                               <span className="text-xs text-gray-300">—</span>
//                             ) : (
//                               <select
//                                 value={lead.assignee || "Unassigned"}
//                                 onChange={(e) =>
//                                   patchWebsiteLead(
//                                     lead.id,
//                                     "assignee",
//                                     e.target.value,
//                                   )
//                                 }
//                                 className="p-1.5 rounded-md border border-gray-200 bg-white text-xs cursor-pointer outline-none"
//                               >
//                                 {TEAM.map((t) => (
//                                   <option key={t}>{t}</option>
//                                 ))}
//                               </select>
//                             )}
//                           </td>
//                           <td className="px-4 py-3">
//                             {isRawIncoming ? (
//                               <span className="text-xs text-gray-300">—</span>
//                             ) : lead.remark ? (
//                               <div
//                                 onClick={() => addWebsiteRemark(lead)}
//                                 title="Click to edit"
//                                 className="text-xs text-gray-600 bg-gray-50 rounded-md px-2 py-1 max-w-[160px] cursor-pointer leading-snug"
//                               >
//                                 {lead.remark}
//                               </div>
//                             ) : (
//                               <button
//                                 onClick={() => addWebsiteRemark(lead)}
//                                 className="text-[11px] text-indigo-500 bg-transparent border border-dashed border-indigo-400 rounded-md px-2 py-1 cursor-pointer"
//                               >
//                                 + Add Remark
//                               </button>
//                             )}
//                           </td>
//                           <td className="px-4 py-3">
//                             {isRawIncoming ? (
//                               <span className="text-xs text-gray-300">—</span>
//                             ) : (
//                               <button
//                                 onClick={() =>
//                                   setFollowUpLead({
//                                     ...lead,
//                                     name: lead.customer_name,
//                                   })
//                                 }
//                                 className="bg-[#a19993] text-white border-none rounded-md px-2.5 py-1.5 text-[11px] font-semibold cursor-pointer w-20"
//                               >
//                                 Follow Up
//                               </button>
//                             )}
//                           </td>
//                         </tr>
//                       );
//                     })
//                   )}
//                 </tbody>
//               </table>
//             </div>
//             <nav className="flex items-center flex-col md:flex-row justify-between rounded-b-lg px-2 py-1 bg-[#f7f7f7]">
//               <span className="text-xs font-normal text-gray-500 mb-4 md:mb-0 block w-full md:inline md:w-auto">
//                 Showing{" "}
//                 <span className="font-semibold text-gray-700">
//                   {visibleWebsiteLeads.length > 0 ? indexOfFirst + 1 : 0}–
//                   {Math.min(indexOfLast, visibleWebsiteLeads.length)}
//                 </span>{" "}
//                 of{" "}
//                 <span className="font-semibold text-gray-700">
//                   {visibleWebsiteLeads.length}
//                 </span>
//               </span>
//               <ul className="inline-flex -space-x-px rtl:space-x-reverse text-xs h-8">
//                 <li>
//                   <button
//                     onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
//                     disabled={currentPage === 1}
//                     className="flex items-center justify-center px-1 h-8 leading-tight text-gray-500 bg-[#f7f7f7] border-gray-300 rounded-s-lg hover:bg-gray-100"
//                   >
//                     <MdKeyboardDoubleArrowLeft />
//                   </button>
//                 </li>
//                 {generatePageNumbers().map((page, index) =>
//                   page === "..." ? (
//                     <li
//                       key={index}
//                       className="px-1 h-8 flex items-center justify-center text-gray-500"
//                     >
//                       <span>...</span>
//                     </li>
//                   ) : (
//                     <li key={index}>
//                       <button
//                         onClick={() => setCurrentPage(page)}
//                         className={`flex items-center justify-center px-3 h-8 leading-tight text-gray-500 bg-[#f7f7f7] border-gray-300 hover:bg-gray-100 ${currentPage === page ? "text-green-500 underline underline-offset-2" : ""}`}
//                       >
//                         {page}
//                       </button>
//                     </li>
//                   ),
//                 )}
//                 <li>
//                   <button
//                     onClick={() =>
//                       setCurrentPage((p) => Math.min(p + 1, totalPages))
//                     }
//                     disabled={currentPage === totalPages}
//                     className="flex items-center justify-center px-1 h-8 leading-tight text-gray-500 bg-[#f7f7f7] border-gray-300 rounded-e-lg hover:bg-gray-100"
//                   >
//                     <MdKeyboardDoubleArrowRight />
//                   </button>
//                 </li>
//               </ul>
//             </nav>
//           </div>
//         )}
//       </main>

//       {/* ── Existing modals ────────────────────────────────────────────────── */}
//       {followUpLead && (
//         <FollowUpModal
//           lead={followUpLead}
//           onClose={() => setFollowUpLead(null)}
//         />
//       )}
//       {showCreate && (
//         <CreateLeadModal
//           onClose={() => setShowCreate(false)}
//           onCreated={handleCreated}
//         />
//       )}

//       {/* ── Convert Confirm Modal ─────────────────────────────────────────── */}
//       {showConvertModal && (
//         <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
//           <div className="bg-white rounded-2xl p-7 w-[420px] shadow-2xl">
//             <div className="font-bold text-base mb-2 text-gray-800">
//               Convert to Booking
//             </div>
//             <p className="text-sm text-gray-500 mb-4">
//               Convert{" "}
//               <b className="text-gray-800">
//                 {selectedRows.length} lead{selectedRows.length > 1 ? "s" : ""}
//               </b>{" "}
//               to booking{selectedRows.length > 1 ? "s" : ""}?
//             </p>
//             <p className="text-xs text-amber-600 mb-4">
//               {storeTab === "website"
//                 ? "These website leads will be marked as converted and inserted into bookings."
//                 : "The leads will be removed from the leads table and inserted into bookings."}
//             </p>
//             <div className="bg-gray-50 rounded-lg px-3 py-2 mb-5 max-h-36 overflow-y-auto">
//               {storeTab === "meta"
//                 ? leads
//                     .filter((l) => selectedRows.includes(l.id))
//                     .map((l) => (
//                       <div
//                         key={l.id}
//                         className="flex items-center justify-between py-1 border-b border-gray-100 last:border-0"
//                       >
//                         <span className="text-xs font-semibold text-gray-700">
//                           {l.name || "—"}
//                         </span>
//                         <span className="text-[11px] text-gray-400">
//                           {channelToSource(l.channel)}
//                         </span>
//                       </div>
//                     ))
//                 : processedWebsiteLeads
//                     .filter((l) => selectedRows.includes(l.id))
//                     .map((l) => (
//                       <div
//                         key={l.id}
//                         className="flex items-center justify-between py-1 border-b border-gray-100 last:border-0"
//                       >
//                         <span className="text-xs font-semibold text-gray-700">
//                           {l.customer_name || "—"}
//                         </span>
//                         <span className="text-[11px] text-gray-400">
//                           {l.property || "Website"}
//                         </span>
//                       </div>
//                     ))}
//             </div>
//             <div className="flex gap-3">
//               <button
//                 onClick={() => setShowConvertModal(false)}
//                 disabled={converting}
//                 className="flex-1 py-2.5 rounded-lg border border-gray-200 bg-white text-gray-500 font-semibold text-sm cursor-pointer"
//               >
//                 Cancel
//               </button>
//               <button
//                 onClick={async () => {
//                   setShowConvertModal(false);
//                   storeTab === "meta"
//                     ? await handleConvertToBooking()
//                     : await handleWebsiteConvertToBooking();
//                 }}
//                 disabled={converting}
//                 className="flex-1 py-2.5 rounded-lg bg-[#1D2826] text-white font-bold text-sm cursor-pointer hover:bg-[#2d3d3a] transition-colors"
//               >
//                 {converting ? "Converting…" : "Yes, Convert"}
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* ── Convert Result Modal ──────────────────────────────────────────── */}
//       {convertResult && (
//         <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
//           <div className="bg-white rounded-2xl p-7 w-[420px] shadow-2xl">
//             {convertResult.errors.length === 0 ? (
//               <>
//                 <div className="text-center mb-4">
//                   <div className="text-4xl mb-2">✅</div>
//                   <div className="font-bold text-base text-gray-800">
//                     {convertResult.bookingids.length} Booking
//                     {convertResult.bookingids.length > 1 ? "s" : ""} Created
//                   </div>
//                   <p className="text-xs text-gray-400 mt-1">
//                     Successfully converted to bookings
//                   </p>
//                 </div>
//                 <div className="bg-green-50 rounded-lg px-3 py-2 mb-5">
//                   {convertResult.bookingids.map((bid, i) => (
//                     <div
//                       key={i}
//                       className="text-xs text-green-700 font-semibold py-0.5"
//                     >
//                       Booking ID: <span className="font-bold">{bid}</span>
//                     </div>
//                   ))}
//                 </div>
//               </>
//             ) : (
//               <>
//                 <div className="text-center mb-4">
//                   <div className="text-4xl mb-2">⚠️</div>
//                   <div className="font-bold text-base text-gray-800">
//                     Partial Conversion
//                   </div>
//                   <p className="text-xs text-gray-400 mt-1">
//                     {convertResult.bookingids.length} succeeded ·{" "}
//                     {convertResult.errors.length} failed
//                   </p>
//                 </div>
//                 {convertResult.bookingids.length > 0 && (
//                   <div className="bg-green-50 rounded-lg px-3 py-2 mb-3">
//                     <p className="text-[10px] text-green-600 font-bold uppercase mb-1">
//                       Created
//                     </p>
//                     {convertResult.bookingids.map((bid, i) => (
//                       <div key={i} className="text-xs text-green-700">
//                         Booking ID: <b>{bid}</b>
//                       </div>
//                     ))}
//                   </div>
//                 )}
//                 <div className="bg-red-50 rounded-lg px-3 py-2 mb-5">
//                   <p className="text-[10px] text-red-500 font-bold uppercase mb-1">
//                     Failed
//                   </p>
//                   {convertResult.errors.map((e, i) => (
//                     <div key={i} className="text-xs text-red-600">
//                       <b>{e.name || e.id}</b>: {e.error}
//                     </div>
//                   ))}
//                 </div>
//               </>
//             )}
//             <button
//               onClick={() => setConvertResult(null)}
//               className="w-full py-2.5 rounded-lg bg-[#1D2826] text-white font-bold text-sm cursor-pointer"
//             >
//               Done
//             </button>
//           </div>
//         </div>
//       )}

//       {/* ── Bulk Process Website Leads — Confirm Modal (NEW) ─────────────── */}
//       {showBulkProcessModal && (
//         <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
//           <div className="bg-white rounded-2xl p-7 w-[420px] shadow-2xl">
//             <div className="font-bold text-base mb-2 text-gray-800">
//               Process Leads
//             </div>
//             <p className="text-sm text-gray-500 mb-4">
//               Do you want to process{" "}
//               <b className="text-gray-800">
//                 {selectedUnprocessedWebsiteCount} lead
//                 {selectedUnprocessedWebsiteCount > 1 ? "s" : ""}
//               </b>
//               ?
//             </p>
//             <p className="text-xs text-green-600 mb-4">
//               The selected leads will be saved to the processed leads table and
//               become manageable in the pipeline.
//             </p>
//             {/* Preview list */}
//             <div className="bg-gray-50 rounded-lg px-3 py-2 mb-5 max-h-36 overflow-y-auto">
//               {currentLeads
//                 .filter((l) => l._isIncoming && selectedRows.includes(l.leadId))
//                 .map((l) => (
//                   <div
//                     key={l.leadId}
//                     className="flex items-center justify-between py-1 border-b border-gray-100 last:border-0"
//                   >
//                     <span className="text-xs font-semibold text-gray-700">
//                       {l.customerName || "—"}
//                     </span>
//                     <span className="text-[11px] text-gray-400 font-mono">
//                       {l.leadId}
//                     </span>
//                   </div>
//                 ))}
//             </div>
//             <div className="flex gap-3">
//               <button
//                 onClick={() => setShowBulkProcessModal(false)}
//                 disabled={bulkProcessing}
//                 className="flex-1 py-2.5 rounded-lg border border-gray-200 bg-white text-gray-500 font-semibold text-sm cursor-pointer"
//               >
//                 Cancel
//               </button>
//               <button
//                 onClick={async () => {
//                   setShowBulkProcessModal(false);
//                   await handleBulkProcessWebsiteLeads();
//                 }}
//                 disabled={bulkProcessing}
//                 className="flex-1 py-2.5 rounded-lg bg-green-600 text-white font-bold text-sm cursor-pointer hover:bg-green-700 transition-colors"
//               >
//                 {bulkProcessing ? "Processing…" : "Yes, Process"}
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* ── Bulk Process Result Modal (NEW) ──────────────────────────────── */}
//       {bulkProcessResult && (
//         <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
//           <div className="bg-white rounded-2xl p-7 w-[420px] shadow-2xl">
//             {bulkProcessResult.errors.length === 0 ? (
//               <>
//                 <div className="text-center mb-4">
//                   <div className="text-4xl mb-2">✅</div>
//                   <div className="font-bold text-base text-gray-800">
//                     {bulkProcessResult.processed.length} Lead
//                     {bulkProcessResult.processed.length > 1 ? "s" : ""}{" "}
//                     Processed
//                   </div>
//                   <p className="text-xs text-gray-400 mt-1">
//                     Now visible in the pipeline tabs
//                   </p>
//                 </div>
//                 <div className="bg-indigo-50 rounded-lg px-3 py-2 mb-5">
//                   {bulkProcessResult.processed.map((name, i) => (
//                     <div
//                       key={i}
//                       className="text-xs text-indigo-700 font-semibold py-0.5"
//                     >
//                       ✓ {name}
//                     </div>
//                   ))}
//                 </div>
//               </>
//             ) : (
//               <>
//                 <div className="text-center mb-4">
//                   <div className="text-4xl mb-2">⚠️</div>
//                   <div className="font-bold text-base text-gray-800">
//                     Partial Processing
//                   </div>
//                   <p className="text-xs text-gray-400 mt-1">
//                     {bulkProcessResult.processed.length} succeeded ·{" "}
//                     {bulkProcessResult.errors.length} failed
//                   </p>
//                 </div>
//                 {bulkProcessResult.processed.length > 0 && (
//                   <div className="bg-indigo-50 rounded-lg px-3 py-2 mb-3">
//                     <p className="text-[10px] text-indigo-600 font-bold uppercase mb-1">
//                       Processed
//                     </p>
//                     {bulkProcessResult.processed.map((name, i) => (
//                       <div key={i} className="text-xs text-indigo-700">
//                         ✓ {name}
//                       </div>
//                     ))}
//                   </div>
//                 )}
//                 <div className="bg-red-50 rounded-lg px-3 py-2 mb-5">
//                   <p className="text-[10px] text-red-500 font-bold uppercase mb-1">
//                     Failed
//                   </p>
//                   {bulkProcessResult.errors.map((e, i) => (
//                     <div key={i} className="text-xs text-red-600">
//                       <b>{e.name}</b>: {e.error}
//                     </div>
//                   ))}
//                 </div>
//               </>
//             )}
//             <button
//               onClick={() => setBulkProcessResult(null)}
//               className="w-full py-2.5 rounded-lg bg-[#1D2826] text-white font-bold text-sm cursor-pointer"
//             >
//               Done
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default InquireLeads;
//---------------------------------old code---------------------------
// import React, { useState, useEffect, useRef, useCallback } from "react";
// import Menubar from "../Menubar/Menubar";
// // import { useNavigate } from "react-router-dom";
// import { Outlet } from "react-router-dom";
// import "../Dashboard/Dashboard.css";
// import { Tooltip } from "antd";
// import { MdKeyboardDoubleArrowLeft } from "react-icons/md";
// import { MdKeyboardDoubleArrowRight } from "react-icons/md";
// import { IoLogoFacebook } from "react-icons/io";
// import { RiInstagramFill } from "react-icons/ri";
// import { IoLogoWhatsapp } from "react-icons/io";
// import { TbDeviceAnalytics } from "react-icons/tb";
// import { TbRefresh } from "react-icons/tb";
// import { RiWhatsappFill } from "react-icons/ri";
// import { AiFillInstagram } from "react-icons/ai";
// import { FaFacebookSquare } from "react-icons/fa";
// import { FaPhone } from "react-icons/fa6";
// import { IoMail } from "react-icons/io5";
// import { IoIosTime } from "react-icons/io";
// // import { MdLocationOn } from "react-icons/md";
// import { FaCalendarAlt } from "react-icons/fa";
// import { RxOpenInNewWindow } from "react-icons/rx";

// import { MdFileDownloadDone } from "react-icons/md";
// const API = `${process.env.REACT_APP_BACKEND_URL || "https://dash.zorbastays.com"}/web-backend`;

// const STATUSES = [
//   "New Enquiry",
//   "Call Not Picked",
//   "Contacted",
//   "Qualified",
//   "Plan & Quote Sent",
//   "In Pipeline",
//   "Negotiating",
//   "Awaiting Payment",
//   "Lost & Closed",
// ];
// const STATUS_COLORS = {
//   "New Enquiry": "#6366f1",
//   "Call Not Picked": "#f59e0b",
//   Contacted: "#3b82f6",
//   Qualified: "#8b5cf6",
//   "Plan & Quote Sent": "#06b6d4",
//   "In Pipeline": "#10b981",
//   Negotiating: "#f97316",
//   "Awaiting Payment": "#ec4899",
//   Booked: "#22c55e",
//   "Lost & Closed": "#ef4444",
// };
// const PIPELINE_STAGES = [
//   {
//     name: "Incoming",
//     color: "bg-emerald-100 text-emerald-600",
//     status: "Incoming Leads",
//   },
//   {
//     name: "Processed",
//     color: "bg-yellow-100 text-yellow-600",
//     status: "All Processed Leads",
//   },
//   {
//     name: "New Enquiry",
//     color: "bg-purple-100 text-purple-500",
//     status: "New Enquiry",
//   },
//   {
//     name: "Call Not Picked",
//     color: "bg-sky-100 text-sky-600",
//     status: "Call Not Picked",
//   },
//   {
//     name: "Contacted",
//     color: "bg-pink-100 text-pink-600",
//     status: "Contacted",
//   },
//   {
//     name: "Qualified",
//     color: "bg-teal-100 text-teal-700",
//     status: "Qualified",
//   },
//   {
//     name: "Plan/Quote Sent",
//     color: "bg-red-100 text-red-500",
//     status: "Plan & Quote Sent",
//   },
//   {
//     name: "In Pipeline",
//     color: "bg-blue-100 text-blue-600",
//     status: "In Pipeline",
//   },
//   {
//     name: "Negotiating",
//     color: "bg-lime-100 text-lime-700",
//     status: "Negotiating",
//   },
//   {
//     name: "Awaiting Payment",
//     color: "bg-green-100 text-green-700",
//     status: "Awaiting Payment",
//   },
//   {
//     name: "Lost & Closed",
//     color: "bg-slate-200 text-slate-700",
//     status: "Lost & Closed",
//   },
// ];

// const WEBSITE_STATUSES = [
//   "New Lead",
//   "Contacted",
//   "Qualified",
//   "Plan & Quote Sent",
//   "In Pipeline",
//   "Negotiating",
//   "Awaiting Payment",
//   "Lost & Closed",
// ];
// const WEBSITE_STATUS_COLORS = {
//   "New Lead": "#6366f1",
//   Contacted: "#3b82f6",
//   Qualified: "#8b5cf6",
//   "Plan & Quote Sent": "#06b6d4",
//   "In Pipeline": "#10b981",
//   Negotiating: "#f97316",
//   "Awaiting Payment": "#ec4899",
//   "Lost & Closed": "#ef4444",
// };
// const WEBSITE_PIPELINE_STAGES = [
//   { name: "All", color: "bg-orange-100 text-orange-600", status: "All Leads" },
//   {
//     name: "Incoming",
//     color: "bg-emerald-100 text-emerald-600",
//     status: "Incoming Leads",
//   },
//   {
//     name: "Processed",
//     color: "bg-yellow-100 text-yellow-600",
//     status: "All Processed Leads",
//   },
//   {
//     name: "New Lead",
//     color: "bg-purple-100 text-purple-500",
//     status: "New Lead",
//   },
//   {
//     name: "Contacted",
//     color: "bg-pink-100 text-pink-600",
//     status: "Contacted",
//   },
//   {
//     name: "Qualified",
//     color: "bg-teal-100 text-teal-700",
//     status: "Qualified",
//   },
//   {
//     name: "Plan/Quote Sent",
//     color: "bg-red-100 text-red-500",
//     status: "Plan & Quote Sent",
//   },
//   {
//     name: "In Pipeline",
//     color: "bg-blue-100 text-blue-600",
//     status: "In Pipeline",
//   },
//   {
//     name: "Negotiating",
//     color: "bg-lime-100 text-lime-700",
//     status: "Negotiating",
//   },
//   {
//     name: "Awaiting Payment",
//     color: "bg-green-100 text-green-700",
//     status: "Awaiting Payment",
//   },
//   {
//     name: "Lost & Closed",
//     color: "bg-slate-200 text-slate-700",
//     status: "Lost & Closed",
//   },
// ];

// const CHANNELS = {
//   "Instagram DM": {
//     color: "#e1306c",
//     bg: "#fce4ec",
//     icon: <AiFillInstagram />,
//   },
//   "Facebook Lead": {
//     color: "#1877f2",
//     bg: "#e3f2fd",
//     icon: <FaFacebookSquare />,
//   },
//   WhatsApp: { color: "#25d366", bg: "#e8f5e9", icon: <RiWhatsappFill /> },
// };
// const TAG_COLORS = { Hot: "#ef4444", Warm: "#f97316", Cold: "#64748b" };
// const TEAM = ["Unassigned", "Parth", "Altaf", "Riya", "Dev", "Sneha"];

// function timeAgo(dateStr) {
//   if (!dateStr) return "—";
//   const diff = (Date.now() - new Date(dateStr)) / 1000;
//   if (diff < 60) return "Just now";
//   if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
//   if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
//   return `${Math.floor(diff / 86400)}d ago`;
// }
// function channelToSource(channel) {
//   const map = {
//     "Facebook Lead": "Facebook",
//     "Instagram DM": "Instagram",
//     WhatsApp: "WhatsApp",
//   };
//   return map[channel] || channel || "Lead";
// }

// function ProcessMetaLeadButton({ lead, onProcessed }) {
//   const [processing, setProcessing] = useState(false);
//   const [done, setDone] = useState(false);
//   const handleProcess = async () => {
//     setProcessing(true);
//     try {
//       const meta_lead_id = lead.id.startsWith("meta_")
//         ? lead.id.replace("meta_", "")
//         : lead.id;
//       const res = await fetch(`${API}/leads/process-meta`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           meta_lead_id,
//           name: lead.name,
//           phone: lead.phone || "",
//           email: lead.email || "",
//           channel: lead.channel || "Facebook Lead",
//           enquiry: lead.enquiry || "",
//           form_id: lead.form_id || "",
//           page_id: lead.page_id || "",
//           field_data: lead.field_data || [],
//           raw_payload: lead,
//         }),
//       });
//       if (!res.ok) throw new Error("Failed " + res.status);
//       const { lead: savedLead, already_existed } = await res.json();
//       setDone(true);
//       onProcessed(savedLead, already_existed);
//     } catch (e) {
//       alert("Error processing lead: " + e.message);
//     } finally {
//       setProcessing(false);
//     }
//   };
//   if (done)
//     return (
//       <span className="text-xs text-green-500 font-bold">✓ Saved to DB</span>
//     );
//   return (
//     <button
//       onClick={handleProcess}
//       disabled={processing}
//       className={`px-3 py-1.5 rounded-md text-white text-xs font-bold whitespace-nowrap transition-all ${processing ? "bg-gray-400 cursor-not-allowed" : "bg-[#aeb3a4] hover:bg-[#797d72] cursor-pointer"}`}
//     >
//       {processing ? "Saving…" : "Process Lead"}
//     </button>
//   );
// }

// function ProcessWebsiteLeadButton({ lead, onProcessed }) {
//   const [processing, setProcessing] = useState(false);
//   const [done, setDone] = useState(false);
//   const handleProcess = async () => {
//     setProcessing(true);
//     try {
//       const res = await fetch(`${API}/website-leads/process`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ leadId: lead.leadId }),
//       });
//       if (!res.ok) throw new Error("Failed " + res.status);
//       const { lead: savedLead, already_existed } = await res.json();
//       setDone(true);
//       onProcessed(savedLead, already_existed);
//     } catch (e) {
//       alert("Error processing lead: " + e.message);
//     } finally {
//       setProcessing(false);
//     }
//   };
//   if (done)
//     return (
//       <span className="text-xs text-green-500 font-bold">✓ Saved to DB</span>
//     );
//   return (
//     <button
//       onClick={handleProcess}
//       disabled={processing}
//       className={`px-3 py-1.5 rounded-md text-white text-xs font-bold whitespace-nowrap transition-all ${processing ? "bg-gray-400 cursor-not-allowed" : "bg-[#aeb3a4] hover:bg-[#797d72] cursor-pointer"}`}
//     >
//       {processing ? "Saving…" : "Process Lead"}
//     </button>
//   );
// }

// function FollowUpModal({ lead, onClose }) {
//   const [type, setType] = useState("whatsapp");
//   const [msg, setMsg] = useState("");
//   const [sent, setSent] = useState(false);
//   const send = () => {
//     setSent(true);
//     setTimeout(onClose, 1600);
//   };
//   return (
//     <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
//       <div className="bg-white rounded-2xl p-7 w-[420px] shadow-2xl">
//         {sent ? (
//           <div className="text-center py-6">
//             <div className="text-5xl">✅</div>
//             <div className="text-base font-bold mt-3">Follow-up Sent!</div>
//           </div>
//         ) : (
//           <>
//             <div className="font-bold text-base mb-1">Send Follow-Up</div>
//             <div className="text-xs text-gray-400 mb-4">
//               To: <b>{lead.name || lead.customerName}</b>
//               {lead.phone ? ` · ${lead.phone}` : ""}
//             </div>
//             <div className="flex gap-2 mb-4">
//               {["whatsapp", "email"].map((t) => (
//                 <button
//                   key={t}
//                   onClick={() => setType(t)}
//                   className={`flex-1 py-2 rounded-lg font-semibold text-sm cursor-pointer border-2 transition-all ${type === t ? "border-indigo-500 bg-indigo-50 text-indigo-600" : "border-gray-200 bg-white text-gray-500"}`}
//                 >
//                   {t === "whatsapp" ? " WhatsApp" : " Email"}
//                 </button>
//               ))}
//             </div>
//             <textarea
//               value={msg}
//               onChange={(e) => setMsg(e.target.value)}
//               rows={4}
//               placeholder={`Write your ${type} message…`}
//               className="w-full p-3 rounded-lg border border-gray-200 text-sm resize-y outline-none focus:border-indigo-400 font-[inherit]"
//             />
//             <div className="flex gap-3 mt-4">
//               <button
//                 onClick={onClose}
//                 className="flex-1 py-2.5 rounded-lg border border-gray-200 bg-white text-gray-500 font-semibold cursor-pointer"
//               >
//                 Cancel
//               </button>
//               <button
//                 onClick={send}
//                 disabled={!msg}
//                 className={`flex-1 py-2.5 rounded-lg text-white font-bold cursor-pointer ${msg ? "bg-[#25d366] hover:bg-green-600" : "bg-gray-300 cursor-not-allowed"}`}
//               >
//                 Send
//               </button>
//             </div>
//           </>
//         )}
//       </div>
//     </div>
//   );
// }

// function CreateLeadModal({ onClose, onCreated }) {
//   const [form, setForm] = useState({
//     name: "",
//     phone: "",
//     email: "",
//     channel: "Instagram DM",
//     enquiry: "",
//     tag: "Warm",
//     assignee: "Unassigned",
//   });
//   const [saving, setSaving] = useState(false);
//   const [err, setErr] = useState("");
//   const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));
//   const handleSubmit = async () => {
//     if (!form.name.trim()) {
//       setErr("Name is required");
//       return;
//     }
//     setSaving(true);
//     setErr("");
//     try {
//       const res = await fetch(`${API}/leads`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(form),
//       });
//       if (!res.ok) throw new Error("Server error " + res.status);
//       const lead = await res.json();
//       onCreated(lead);
//       onClose();
//     } catch (e) {
//       setErr(e.message);
//     } finally {
//       setSaving(false);
//     }
//   };
//   const inputCls =
//     "w-full p-2.5 rounded-lg border border-gray-200 text-sm outline-none focus:border-indigo-400 mb-2.5 font-[inherit] box-border";
//   return (
//     <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
//       <div className="bg-white rounded-2xl p-7 w-[460px] shadow-2xl max-h-[90vh] overflow-y-auto">
//         <div className="font-bold text-base mb-4">➕ Add New Lead</div>
//         <input
//           className={inputCls}
//           placeholder="Full Name *"
//           value={form.name}
//           onChange={(e) => set("name", e.target.value)}
//         />
//         <input
//           className={inputCls}
//           placeholder="Phone Number"
//           value={form.phone}
//           onChange={(e) => set("phone", e.target.value)}
//         />
//         <input
//           className={inputCls}
//           placeholder="Email"
//           type="email"
//           value={form.email}
//           onChange={(e) => set("email", e.target.value)}
//         />
//         <select
//           className={inputCls}
//           value={form.channel}
//           onChange={(e) => set("channel", e.target.value)}
//         >
//           {Object.keys(CHANNELS).map((c) => (
//             <option key={c}>{c}</option>
//           ))}
//         </select>
//         <textarea
//           className={`${inputCls} resize-y`}
//           placeholder="Enquiry / Message"
//           value={form.enquiry}
//           rows={3}
//           onChange={(e) => set("enquiry", e.target.value)}
//         />
//         <div className="flex gap-2.5 mb-2.5">
//           <select
//             className="flex-1 p-2.5 rounded-lg border border-gray-200 text-sm outline-none focus:border-indigo-400 font-[inherit]"
//             value={form.tag}
//             onChange={(e) => set("tag", e.target.value)}
//           >
//             {["Hot", "Warm", "Cold"].map((t) => (
//               <option key={t}>{t}</option>
//             ))}
//           </select>
//           <select
//             className="flex-1 p-2.5 rounded-lg border border-gray-200 text-sm outline-none focus:border-indigo-400 font-[inherit]"
//             value={form.assignee}
//             onChange={(e) => set("assignee", e.target.value)}
//           >
//             {TEAM.map((t) => (
//               <option key={t}>{t}</option>
//             ))}
//           </select>
//         </div>
//         {err && <div className="text-red-500 text-xs mb-2">⚠ {err}</div>}
//         <div className="flex gap-2.5 mt-1.5">
//           <button
//             onClick={onClose}
//             className="flex-1 py-2.5 rounded-lg border border-gray-200 bg-white text-gray-500 font-semibold cursor-pointer"
//           >
//             Cancel
//           </button>
//           <button
//             onClick={handleSubmit}
//             disabled={saving}
//             className={`flex-1 py-2.5 rounded-lg text-white font-bold cursor-pointer ${saving ? "bg-gray-400 cursor-not-allowed" : "bg-indigo-500 hover:bg-indigo-600"}`}
//           >
//             {saving ? "Saving…" : "Create Lead"}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }

// const InquireLeads = () => {
//   // const navigate = useNavigate();
//   const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);
//   const [isSidebarOpen, setIsSidebarOpen] = useState(() => {
//     const s = localStorage.getItem("menubarOpen");
//     return s !== null ? JSON.parse(s) : window.innerWidth >= 1024;
//   });

//   const [storeTab, setStoreTab] = useState("meta");

//   const [leads, setLeads] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [processedMetaIds, setProcessedMetaIds] = useState(new Set());
//   const [activeStatus, setActiveStatus] = useState("Incoming Leads");

//   const [websiteLeads, setWebsiteLeads] = useState([]);
//   const [websiteLoading, setWebsiteLoading] = useState(false);
//   const [websiteError, setWebsiteError] = useState(null);
//   const [processedWebsiteIds, setProcessedWebsiteIds] = useState(new Set());
//   const [processedWebsiteLeads, setProcessedWebsiteLeads] = useState([]);
//   const [processedWebsiteLoading, setProcessedWebsiteLoading] = useState(false);
//   const [websiteActiveStatus, setWebsiteActiveStatus] = useState("All Leads");

//   const [activeChannel, setActiveChannel] = useState("All");
//   const [activeTag, setActiveTag] = useState("All");
//   const [searchInput, setSearchInput] = useState("");
//   const [search, setSearch] = useState("");
//   const [expandedLead, setExpandedLead] = useState(null);
//   const [followUpLead, setFollowUpLead] = useState(null);
//   const [showCreate, setShowCreate] = useState(false);
//   const [updatingId, setUpdatingId] = useState(null);
//   const [selectedRows, setSelectedRows] = useState([]);

//   const [showConvertModal, setShowConvertModal] = useState(false);
//   const [converting, setConverting] = useState(false);
//   const [convertResult, setConvertResult] = useState(null);

//   const rowsPerPage = 20;
//   const [currentPage, setCurrentPage] = useState(1);
//   const [showPopup_filter, setShowPopup_filter] = useState(false);
//   const filterRef = useRef(null);

//   useEffect(() => {
//     const t = setTimeout(() => setSearch(searchInput), 400);
//     return () => clearTimeout(t);
//   }, [searchInput]);

//   useEffect(() => {
//     setCurrentPage(1);
//   }, [
//     search,
//     activeStatus,
//     activeChannel,
//     activeTag,
//     websiteActiveStatus,
//     storeTab,
//   ]);

//   useEffect(() => {
//     function handleClickOutside(e) {
//       if (filterRef.current && !filterRef.current.contains(e.target))
//         setShowPopup_filter(false);
//     }
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   useEffect(() => {
//     const handleResize = () => {
//       const mobile = window.innerWidth < 1024;
//       setIsMobile(mobile);
//       if (mobile) setIsSidebarOpen(false);
//     };
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   const fetchLeads = useCallback(async () => {
//     setLoading(true);
//     setError(null);
//     try {
//       const p = new URLSearchParams();
//       if (
//         activeStatus !== "All" &&
//         activeStatus !== "Incoming Leads" &&
//         activeStatus !== "All Leads"
//       )
//         p.set("status", activeStatus);
//       if (activeChannel !== "All") p.set("channel", activeChannel);
//       if (activeTag !== "All") p.set("tag", activeTag);
//       if (search) p.set("search", search);
//       p.set("limit", "200");
//       const res = await fetch(`${API}/leads?${p}`);
//       if (!res.ok) throw new Error(`API error ${res.status}`);
//       const data = await res.json();
//       const allLeads = data.leads || [];
//       const dbMetaIds = new Set(
//         allLeads
//           .filter((l) => !String(l.id).startsWith("meta_") && l.meta_lead_id)
//           .map((l) => l.meta_lead_id),
//       );
//       setProcessedMetaIds(dbMetaIds);
//       setLeads(allLeads);
//     } catch (e) {
//       setError(e.message);
//     } finally {
//       setLoading(false);
//     }
//   }, [activeStatus, activeChannel, activeTag, search]);

//   useEffect(() => {
//     fetchLeads();
//   }, [fetchLeads]);

//   const fetchWebsiteLeads = useCallback(async () => {
//     setWebsiteLoading(true);
//     setWebsiteError(null);
//     try {
//       const res = await fetch(`${API}/website-leads`);
//       if (!res.ok) throw new Error(`API error ${res.status}`);
//       const data = await res.json();
//       setWebsiteLeads(data.data || []);
//     } catch (e) {
//       setWebsiteError(e.message);
//     } finally {
//       setWebsiteLoading(false);
//     }
//   }, []);

//   const fetchProcessedWebsiteLeads = useCallback(async () => {
//     setProcessedWebsiteLoading(true);
//     try {
//       const url =
//         websiteActiveStatus !== "Incoming Leads" &&
//         websiteActiveStatus !== "All Processed Leads" &&
//         websiteActiveStatus !== "All Leads"
//           ? `${API}/processed-website-leads?status=${encodeURIComponent(websiteActiveStatus)}`
//           : `${API}/processed-website-leads`;
//       const res = await fetch(url);
//       if (!res.ok) throw new Error(`API error ${res.status}`);
//       const data = await res.json();
//       const rows = data.data || [];
//       setProcessedWebsiteLeads(rows);
//       setProcessedWebsiteIds(
//         new Set(rows.map((r) => String(r.original_lead_id))),
//       );
//     } catch (e) {
//       console.error("fetchProcessedWebsiteLeads:", e.message);
//     } finally {
//       setProcessedWebsiteLoading(false);
//     }
//   }, [websiteActiveStatus]);

//   useEffect(() => {
//     if (storeTab === "website") {
//       fetchWebsiteLeads();
//       fetchProcessedWebsiteLeads();
//     }
//   }, [storeTab, fetchWebsiteLeads, fetchProcessedWebsiteLeads]);

//   // ── CHANGED: visibleLeads now handles "All Leads" ──────────────────────────
//   const visibleLeads = (() => {
//     if (activeStatus === "All Leads") return leads; // all meta_ incoming + all processed
//     if (activeStatus === "Incoming Leads")
//       return leads.filter(
//         (l) =>
//           String(l.id).startsWith("meta_") &&
//           !processedMetaIds.has(String(l.id).replace("meta_", "")),
//       );
//     if (activeStatus === "All Processed Leads")
//       return leads.filter((l) => !String(l.id).startsWith("meta_"));
//     return leads.filter(
//       (l) => !String(l.id).startsWith("meta_") && l.status === activeStatus,
//     );
//   })();

//   // ── CHANGED: visibleWebsiteLeads now handles "All Leads" ───────────────────
//   const visibleWebsiteLeads = (() => {
//     if (websiteActiveStatus === "All Leads") {
//       const incoming = websiteLeads
//         .filter(
//           (l) => !processedWebsiteIds.has(String(l.leadId).replace("WL-", "")),
//         )
//         .map((l) => ({ ...l, _isIncoming: true }));
//       return [...incoming, ...processedWebsiteLeads];
//     }
//     if (websiteActiveStatus === "Incoming Leads")
//       return websiteLeads.filter(
//         (l) => !processedWebsiteIds.has(String(l.leadId).replace("WL-", "")),
//       );
//     if (websiteActiveStatus === "All Processed Leads")
//       return processedWebsiteLeads;
//     return processedWebsiteLeads.filter(
//       (l) => l.status === websiteActiveStatus,
//     );
//   })();

//   const patchLead = async (id, field, value) => {
//     setUpdatingId(id);
//     setLeads((prev) =>
//       prev.map((l) => (l.id === id ? { ...l, [field]: value } : l)),
//     );
//     try {
//       const res = await fetch(`${API}/leads/${id}`, {
//         method: "PATCH",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ [field]: value }),
//       });
//       if (!res.ok) throw new Error("patch failed");
//     } catch {
//       fetchLeads();
//     } finally {
//       setUpdatingId(null);
//     }
//   };

//   const patchWebsiteLead = async (id, field, value) => {
//     setUpdatingId(id);
//     setProcessedWebsiteLeads((prev) =>
//       prev.map((l) => (l.id === id ? { ...l, [field]: value } : l)),
//     );
//     try {
//       const res = await fetch(`${API}/processed-website-leads/${id}`, {
//         method: "PATCH",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ [field]: value }),
//       });
//       if (!res.ok) throw new Error("patch failed");
//     } catch {
//       fetchProcessedWebsiteLeads();
//     } finally {
//       setUpdatingId(null);
//     }
//   };

//   const addRemark = (lead) => {
//     const r = prompt("Remark:", lead.remark || "");
//     if (r !== null) patchLead(lead.id, "remark", r);
//   };
//   const addWebsiteRemark = (lead) => {
//     const r = prompt("Remark:", lead.remark || "");
//     if (r !== null) patchWebsiteLead(lead.id, "remark", r);
//   };

//   const handleCreated = (lead) => setLeads((prev) => [lead, ...prev]);

//   const handleMetaLeadProcessed = (savedLead, alreadyExisted) => {
//     setProcessedMetaIds((prev) => {
//       const n = new Set(prev);
//       n.add(savedLead.meta_lead_id);
//       return n;
//     });
//     setLeads((prev) =>
//       prev.some((l) => l.id === savedLead.id) ? prev : [savedLead, ...prev],
//     );
//   };

//   const handleWebsiteLeadProcessed = (savedLead, alreadyExisted) => {
//     setProcessedWebsiteIds((prev) => {
//       const n = new Set(prev);
//       n.add(String(savedLead.original_lead_id));
//       return n;
//     });
//     setProcessedWebsiteLeads((prev) =>
//       prev.some((l) => l.id === savedLead.id) ? prev : [savedLead, ...prev],
//     );
//   };

//   const handleConvertToBooking = async () => {
//     const leadsToConvert = leads.filter((l) => selectedRows.includes(l.id));
//     if (!leadsToConvert.length) return;
//     setConverting(true);
//     setConvertResult(null);
//     const results = { bookingids: [], errors: [] };
//     for (const lead of leadsToConvert) {
//       try {
//         const nameParts = (lead.name || "").trim().split(/\s+/);
//         const payload = {
//           firstname: nameParts[0] || "Unknown",
//           lastname: nameParts.slice(1).join(" ") || "",
//           email: lead.email || "",
//           phone: lead.phone || "",
//           tripexecutive:
//             lead.assignee && lead.assignee !== "Unassigned"
//               ? lead.assignee
//               : "",
//           bookingstatus: "Pending",
//           paymentstatus: "Pending",
//           source: channelToSource(lead.channel),
//         };
//         const res = await fetch(`${API}/createBooking`, {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify(payload),
//         });
//         if (!res.ok) {
//           const e = await res.json().catch(() => ({}));
//           throw new Error(e.message || `HTTP ${res.status}`);
//         }
//         const data = await res.json();
//         results.bookingids.push(data.bookingid || "—");
//         await fetch(`${API}/leads/${lead.id}`, { method: "DELETE" });
//       } catch (e) {
//         results.errors.push({ name: lead.name, error: e.message });
//       }
//     }
//     const failedNames = new Set(results.errors.map((e) => e.name));
//     const convertedIds = leadsToConvert
//       .filter((l) => !failedNames.has(l.name))
//       .map((l) => l.id);
//     setLeads((prev) => prev.filter((l) => !convertedIds.includes(l.id)));
//     setSelectedRows([]);
//     setConverting(false);
//     setConvertResult(results);
//   };

//   const handleWebsiteConvertToBooking = async () => {
//     const idsToConvert = selectedRows;
//     if (!idsToConvert.length) return;
//     setConverting(true);
//     setConvertResult(null);
//     try {
//       const res = await fetch(`${API}/website-leads/convert-booking`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ ids: idsToConvert }),
//       });
//       if (!res.ok) throw new Error(`HTTP ${res.status}`);
//       const data = await res.json();
//       const results = {
//         bookingids: data.bookingids || [],
//         errors: data.errors || [],
//       };
//       const failedIds = new Set((data.errors || []).map((e) => e.id));
//       const convertedIds = idsToConvert.filter((id) => !failedIds.has(id));
//       setProcessedWebsiteLeads((prev) =>
//         prev.filter((l) => !convertedIds.includes(l.id)),
//       );
//       setSelectedRows([]);
//       setConvertResult(results);
//     } catch (e) {
//       setConvertResult({
//         bookingids: [],
//         errors: [{ id: "all", error: e.message }],
//       });
//     } finally {
//       setConverting(false);
//     }
//   };

//   const newMetaLeadsCount = leads.filter(
//     (l) =>
//       String(l.id).startsWith("meta_") &&
//       !processedMetaIds.has(String(l.id).replace("meta_", "")),
//   ).length;
//   const facebookCount = leads.filter(
//     (l) => l.channel === "Facebook Lead",
//   ).length;
//   const instagramCount = leads.filter(
//     (l) => l.channel === "Instagram DM",
//   ).length;
//   const whatsappCount = leads.filter((l) => l.channel === "WhatsApp").length;

//   const activeLeadList =
//     storeTab === "meta" ? visibleLeads : visibleWebsiteLeads;
//   const totalPages = Math.ceil(activeLeadList.length / rowsPerPage);
//   const indexOfFirst = (currentPage - 1) * rowsPerPage;
//   const indexOfLast = indexOfFirst + rowsPerPage;
//   const currentLeads = activeLeadList.slice(indexOfFirst, indexOfLast);

//   const generatePageNumbers = () => {
//     const pages = [];
//     if (totalPages <= 3) {
//       for (let i = 1; i <= totalPages; i++) pages.push(i);
//     } else {
//       if (currentPage > 2) {
//         pages.push(1);
//         pages.push("...");
//       }
//       for (let i = currentPage - 1; i <= currentPage + 1; i++) {
//         if (i > 0 && i <= totalPages) pages.push(i);
//       }
//       if (currentPage < totalPages - 1) {
//         pages.push("...");
//         pages.push(totalPages);
//       }
//     }
//     return pages;
//   };

//   const handleRowCheckboxChange = (id) =>
//     setSelectedRows((prev) =>
//       prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id],
//     );
//   const handleSelectAll = () =>
//     setSelectedRows(
//       selectedRows.length === currentLeads.length && currentLeads.length > 0
//         ? []
//         : currentLeads.map((l) => l.id || l.leadId),
//     );

//   const isIncomingView = activeStatus === "Incoming Leads";
//   const isAllLeadsView = activeStatus === "All Leads";
//   const isWebsiteIncomingView = websiteActiveStatus === "Incoming Leads";

//   if (error && storeTab === "meta") {
//     return (
//       <div className="flex">
//         <Menubar
//           isOpen={isSidebarOpen}
//           setIsOpen={setIsSidebarOpen}
//           isMobile={isMobile}
//         />
//         <div className="flex-1 p-6 flex justify-center items-center h-64">
//           <div className="text-lg text-red-500">
//             {error}
//             <button
//               onClick={fetchLeads}
//               className="ml-3 underline text-indigo-500 text-sm"
//             >
//               Retry
//             </button>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="flex bg-[#F8F9FA]">
//       <Menubar
//         isOpen={isSidebarOpen}
//         setIsOpen={setIsSidebarOpen}
//         isMobile={isMobile}
//       />

//       <main
//         className={`p-5 lg:p-6 transition-all duration-500 w-full ${isMobile ? "ml-0" : isSidebarOpen ? "ml-64" : "ml-16"}`}
//       >
//         <Outlet />

//         {/* ── Header ─────────────────────────────────────────────────────── */}
//         <div className="flex justify-between gap-5 items-start lg:items-center">
//           <p className="font-semibold text-xl text-gray-700 ml-10 lg:ml-0">
//             Inquire Leads
//           </p>
//           <div className="flex items-center gap-1">
//             <div className="mr-2 p-2 overflow-hidden w-8 h-8 hover:w-[120px] sm:hover:w-[250px] hover:border hover:border-[#1D2826] hover:shadow-[2px_2px_20px_rgba(0,0,0,0.08)] rounded-full flex group items-center hover:duration-300 duration-300">
//               <div className="flex items-center justify-center fill-[#1D2826]">
//                 <svg
//                   xmlns="http://www.w3.org/2000/svg"
//                   viewBox="0 0 24 24"
//                   width="18"
//                   height="18"
//                 >
//                   <path d="M18.9,16.776A10.539,10.539,0,1,0,16.776,18.9l5.1,5.1L24,21.88ZM10.5,18A7.5,7.5,0,1,1,18,10.5,7.507,7.507,0,0,1,10.5,18Z" />
//                 </svg>
//               </div>
//               <input
//                 type="text"
//                 placeholder="Search name, phone…"
//                 value={searchInput}
//                 onChange={(e) => setSearchInput(e.target.value)}
//                 className="border-none outline-none text-sm bg-transparent w-full font-normal px-2 focus:ring-0"
//               />
//             </div>
//             <div className="flex items-center">
//               <div className="relative inline-block" ref={filterRef}>
//                 <div
//                   onClick={() => setShowPopup_filter((p) => !p)}
//                   className={`flex flex-col items-center gap-4 cursor-pointer select-none group scale-[0.75] py-2.5 px-2 rounded-full border-2 transition-all duration-300 ${showPopup_filter ? "border-[#1D2826]" : "border-transparent hover:border-[#1D2826]"}`}
//                 >
//                   {[
//                     ["100%", "0%"],
//                     ["0%", "100%"],
//                     ["100%", "0%"],
//                   ].map(([a, b], i) => (
//                     <div
//                       key={i}
//                       className={`relative w-6 h-0.5 bg-[#1D2826] rounded-full ${i === 1 ? "-my-2.5" : ""}`}
//                     >
//                       <div
//                         className="absolute top-1/2 -translate-y-1/2 w-2 h-2 rounded-full border-2 border-black bg-white transition-all duration-300"
//                         style={{
//                           left: showPopup_filter ? a : b,
//                           transform: `translate(${showPopup_filter ? (i === 1 ? "0" : "-100%") : i === 1 ? "0" : "-0%"},-50%)`,
//                         }}
//                       />
//                     </div>
//                   ))}
//                 </div>
//                 {showPopup_filter && (
//                   <div className="absolute top-full mt-1 right-0 bg-white border rounded-lg shadow-custom z-10 p-4 space-y-4">
//                     <div className="flex flex-col gap-2">
//                       <p className="text-xs font-semibold text-gray-500 uppercase">
//                         Channel
//                       </p>
//                       <div className="flex gap-1 flex-wrap">
//                         {[
//                           "All",
//                           "Instagram DM",
//                           "Facebook Lead",
//                           "WhatsApp",
//                         ].map((ch) => (
//                           <button
//                             key={ch}
//                             onClick={() => setActiveChannel(ch)}
//                             className={`py-1 px-2 rounded text-xs font-medium transition-colors ${activeChannel === ch ? "bg-[#1D2826] text-white" : "bg-gray-100 hover:bg-[#DAE0CE]"}`}
//                           >
//                             {ch}
//                           </button>
//                         ))}
//                       </div>
//                     </div>
//                     <div className="flex flex-col gap-2">
//                       <p className="text-xs font-semibold text-gray-500 uppercase">
//                         Tag
//                       </p>
//                       <div className="flex gap-1">
//                         {["All", "Hot", "Warm", "Cold"].map((t) => (
//                           <button
//                             key={t}
//                             onClick={() => setActiveTag(t)}
//                             className={`py-1 px-2 rounded text-xs font-medium transition-colors ${activeTag === t ? "bg-[#1D2826] text-white" : "bg-gray-100 hover:bg-[#DAE0CE]"}`}
//                           >
//                             {t}
//                           </button>
//                         ))}
//                       </div>
//                     </div>
//                     <div className="flex flex-col gap-2">
//                       <p className="text-xs font-semibold text-gray-500 uppercase">
//                         Date Range
//                       </p>
//                       <div className="flex justify-between gap-2">
//                         {["Today", "Week", "Month", "Year"].map((label) => (
//                           <button
//                             key={label}
//                             className="flex-1 py-1 px-2 bg-gray-100 active:bg-[#DAE0CE] hover:bg-[#DAE0CE] rounded text-sm font-medium"
//                           >
//                             {label}
//                           </button>
//                         ))}
//                       </div>
//                       <div className="flex items-center gap-2">
//                         <input
//                           type="date"
//                           className="border text-sm rounded px-2 py-1 w-full focus:outline-none focus:ring-1 focus:ring-green-600 focus:border-black"
//                         />
//                         <span className="text-sm text-gray-500">-</span>
//                         <input
//                           type="date"
//                           className="border text-sm rounded px-2 py-1 w-full focus:outline-none focus:ring-1 focus:ring-green-600 focus:border-black"
//                         />
//                       </div>
//                     </div>
//                   </div>
//                 )}
//               </div>
//             </div>
//             <button
//               onClick={
//                 storeTab === "meta"
//                   ? fetchLeads
//                   : () => {
//                       fetchWebsiteLeads();
//                       fetchProcessedWebsiteLeads();
//                     }
//               }
//               title="Refresh"
//               className="p-2 rounded-lg text-xl cursor-pointer border-none"
//             >
//               <TbRefresh />
//             </button>
//             {storeTab === "meta" && (
//               <button
//                 onClick={() => setShowCreate(true)}
//                 className="ml-1 px-4 py-2 bg-[#1D2826] rounded-lg text-white text-sm font-semibold hover:scale-95 transition-all duration-200"
//               >
//                 + New Lead
//               </button>
//             )}
//           </div>
//         </div>

//         {/* ── Meta Stat Boxes ─────────────────────────────────────────────── */}
//         {storeTab === "meta" && (
//           <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 items-center gap-5 text-gray-700 font-semibold mt-5">
//             {[
//               [
//                 "FaceBook Leads",
//                 facebookCount,
//                 <IoLogoFacebook className="bg-[#3C4C4E] text-3xl text-white p-1.5 rounded-md" />,
//               ],
//               [
//                 "Instagram Leads",
//                 instagramCount,
//                 <RiInstagramFill className="bg-[#3C4C4E] text-3xl text-white p-1.5 rounded-md" />,
//               ],
//               [
//                 "WhatsApp Leads",
//                 whatsappCount,
//                 <IoLogoWhatsapp className="bg-[#3C4C4E] text-3xl text-white p-1.5 rounded-md" />,
//               ],
//               [
//                 "Unprocessed (Meta)",
//                 newMetaLeadsCount,
//                 <TbDeviceAnalytics className="bg-[#3C4C4E] text-3xl text-white p-1.5 rounded-md" />,
//               ],
//             ].map(([label, count, icon]) => (
//               <div
//                 key={label}
//                 className="flex items-center justify-between gap-5 bg-[#DAE0CE] py-2 px-4 rounded-lg"
//               >
//                 <div>
//                   <p>{label}</p>
//                   <p className="mt-2 text-lg text-black">{count}</p>
//                 </div>
//                 {icon}
//               </div>
//             ))}
//           </div>
//         )}

//         {/* ── Website Stat Boxes ──────────────────────────────────────────── */}
//         {storeTab === "website" && (
//           <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 text-gray-700 font-semibold mt-5">
//             <div className="flex items-center justify-between gap-5 bg-[#DAE0CE] py-2 px-4 rounded-lg">
//               <div>
//                 <p>Incoming</p>
//                 <p className="mt-2 text-lg text-black">
//                   {
//                     websiteLeads.filter(
//                       (l) =>
//                         !processedWebsiteIds.has(
//                           String(l.leadId).replace("WL-", ""),
//                         ),
//                     ).length
//                   }
//                 </p>
//               </div>
//               <RxOpenInNewWindow className="bg-[#3C4C4E] text-3xl text-white p-1.5 rounded-md" />
//             </div>
//             <div className="flex items-center justify-between gap-5 bg-[#DAE0CE] py-2 px-4 rounded-lg">
//               <div>
//                 <p>Processed</p>
//                 <p className="mt-2 text-lg text-black">
//                   {processedWebsiteLeads.length}
//                 </p>
//               </div>
//               <MdFileDownloadDone className="bg-[#3C4C4E] text-3xl text-white p-1.5 rounded-md" />
//             </div>
//             <div className="flex items-center justify-between gap-5 bg-[#DAE0CE] py-2 px-4 rounded-lg">
//               <div>
//                 <p>Total Leads (Website)</p>
//                 <p className="mt-2 text-lg text-black">
//                   {websiteLeads.filter(
//                     (l) =>
//                       !processedWebsiteIds.has(
//                         String(l.leadId).replace("WL-", ""),
//                       ),
//                   ).length + processedWebsiteLeads.length}
//                 </p>
//               </div>
//               <TbDeviceAnalytics className="bg-[#3C4C4E] text-3xl text-white p-1.5 rounded-md" />
//             </div>
//           </div>
//         )}

//         {/* ── Tab Switcher ────────────────────────────────────────────────── */}
//         <div className="inline-flex border border-gray-300 rounded-lg overflow-hidden text-sm font-medium shadow-sm mt-5">
//           <button
//             onClick={() => setStoreTab("meta")}
//             className={`px-4 py-2 transition-colors duration-200 focus:outline-none ${storeTab === "meta" ? "bg-[#1D2826] text-white" : "bg-white text-gray-500 hover:bg-green-50"}`}
//           >
//             Meta Leads
//           </button>
//           <button
//             onClick={() => setStoreTab("website")}
//             className={`px-4 py-2 transition-colors duration-200 focus:outline-none ${storeTab === "website" ? "bg-[#1D2826] text-white" : "bg-white text-gray-500 hover:bg-green-50"}`}
//           >
//             Website Leads
//           </button>
//         </div>

//         {/* ── Meta Pipeline Tabs ──────────────────────────────────────────── */}
//         {storeTab === "meta" && (
//           <div className="mt-6">
//             <div className="flex w-full items-center text-[11px] font-semibold overflow-x-auto">
//               {PIPELINE_STAGES.map((stage) => {
//                 const isActive = activeStatus === stage.status;
//                 return (
//                   <button
//                     key={stage.name}
//                     onClick={() => setActiveStatus(stage.status)}
//                     className={`relative flex-shrink-0 flex-1 min-w-[70px] h-9 px-1 leading-tight transition-all ${stage.color} ${isActive ? "ring-1 ring-black z-10" : ""}`}
//                     style={{
//                       clipPath:
//                         "polygon(0 0, calc(100% - 12px) 0, 100% 50%, calc(100% - 12px) 100%, 0 100%, 12px 50%)",
//                       marginRight: "-6px",
//                     }}
//                   >
//                     <span className="flex flex-col items-center justify-center gap-0.5 w-full">
//                       <span>{stage.name}</span>
//                       <span
//                         className="rounded-full transition-all duration-200"
//                         style={{
//                           width: isActive ? 5 : 0,
//                           height: isActive ? 5 : 0,
//                           background: "currentColor",
//                           opacity: isActive ? 1 : 0,
//                           display: "block",
//                         }}
//                       />
//                     </span>
//                   </button>
//                 );
//               })}
//             </div>
//           </div>
//         )}

//         {/* ── Website Pipeline Tabs ───────────────────────────────────────── */}
//         {storeTab === "website" && (
//           <div className="mt-6">
//             <div className="flex w-full items-center text-[11px] font-semibold overflow-x-auto">
//               {WEBSITE_PIPELINE_STAGES.map((stage) => {
//                 const isActive = websiteActiveStatus === stage.status;
//                 return (
//                   <button
//                     key={stage.name}
//                     onClick={() => setWebsiteActiveStatus(stage.status)}
//                     className={`relative flex-shrink-0 flex-1 min-w-[70px] h-9 px-1 leading-tight transition-all ${stage.color} ${isActive ? "ring-1 ring-black z-10" : ""}`}
//                     style={{
//                       clipPath:
//                         "polygon(0 0, calc(100% - 12px) 0, 100% 50%, calc(100% - 12px) 100%, 0 100%, 12px 50%)",
//                       marginRight: "-6px",
//                     }}
//                   >
//                     <span className="flex flex-col items-center justify-center gap-0.5 w-full">
//                       <span>{stage.name}</span>
//                       <span
//                         className="rounded-full transition-all duration-200"
//                         style={{
//                           width: isActive ? 5 : 0,
//                           height: isActive ? 5 : 0,
//                           background: "currentColor",
//                           opacity: isActive ? 1 : 0,
//                           display: "block",
//                         }}
//                       />
//                     </span>
//                   </button>
//                 );
//               })}
//             </div>
//           </div>
//         )}

//         {/* ── Convert to Booking bar ──────────────────────────────────────── */}
//         {selectedRows.length > 0 &&
//           ((storeTab === "meta" && !isIncomingView) ||
//             (storeTab === "website" && !isWebsiteIncomingView)) && (
//             <div className="mt-4 flex items-center justify-between rounded-xl px-4 py-2.5">
//               <span className="text-sm text-amber-700 font-medium">
//                 {selectedRows.length} lead{selectedRows.length > 1 ? "s" : ""}{" "}
//                 selected
//               </span>
//               <button
//                 onClick={() => setShowConvertModal(true)}
//                 className="px-4 py-1.5 bg-[#1D2826] text-white text-xs font-semibold rounded-lg hover:scale-95 transition-all duration-200 cursor-pointer"
//               >
//                 Convert to Booking →
//               </button>
//             </div>
//           )}

//         {/* ══════════════════  META TABLE  ══════════════════════════════════ */}
//         {storeTab === "meta" && (
//           <div className="shadow-md rounded-lg mt-5">
//             <div className="overflow-x-auto">
//               <table className="w-full text-sm text-left text-gray-500">
//                 <thead className="text-xs text-gray-400 uppercase bg-green-50 border-b">
//                   <tr>
//                     <th className="p-4">
//                       <input
//                         type="checkbox"
//                         onChange={handleSelectAll}
//                         checked={
//                           selectedRows.length === currentLeads.length &&
//                           currentLeads.length > 0
//                         }
//                       />
//                     </th>
//                     <th className="p-4">Lead Details</th>
//                     <th className="p-4">Enquiry</th>
//                     {isIncomingView ? (
//                       <>
//                         <th className="p-4">Meta Fields</th>
//                         <th className="p-4">Action</th>
//                       </>
//                     ) : (
//                       <>
//                         <th className="p-4">Status</th>
//                         <th className="p-4">Assigned To</th>
//                         <th className="p-4">Remark</th>
//                         <th className="p-4">Date</th>
//                         <th className="p-4">Actions</th>
//                       </>
//                     )}
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {loading ? (
//                     <tr>
//                       <td
//                         colSpan={isIncomingView ? 5 : 9}
//                         className="text-center py-14 text-gray-400"
//                       >
//                         Loading leads…
//                       </td>
//                     </tr>
//                   ) : currentLeads.length === 0 ? (
//                     <tr>
//                       <td
//                         colSpan={isIncomingView ? 5 : 9}
//                         className="text-center py-14 text-gray-400"
//                       >
//                         {isIncomingView
//                           ? "No unprocessed Meta leads. They'll appear here automatically via Meta webhooks."
//                           : "No leads found for this filter."}
//                       </td>
//                     </tr>
//                   ) : (
//                     currentLeads.map((lead, idx) => {
//                       const ch = CHANNELS[lead.channel] || {
//                         color: "#888",
//                         bg: "#f1f5f9",
//                         icon: "",
//                       };
//                       const isExpanded = expandedLead === lead.id;
//                       const dimmed = updatingId === lead.id;
//                       const isMetaLead = String(lead.id).startsWith("meta_");
//                       // In "All Leads" view, unprocessed meta_ rows show Process button instead of edit controls
//                       const showProcessButton = isAllLeadsView && isMetaLead;
//                       return (
//                         <React.Fragment key={lead.id}>
//                           <tr
//                             className={`border-b border-gray-200 hover:bg-gray-100 text-gray-800 transition-opacity ${idx % 2 === 0 ? "bg-white" : "bg-gray-50"}`}
//                             style={{ opacity: dimmed ? 0.55 : 1 }}
//                           >
//                             <td className="px-4 py-3">
//                               <input
//                                 type="checkbox"
//                                 onChange={() =>
//                                   handleRowCheckboxChange(lead.id)
//                                 }
//                                 checked={selectedRows.includes(lead.id)}
//                               />
//                             </td>
//                             <td className="px-4 py-3 min-w-[180px]">
//                               <div className="font-bold text-gray-800 mb-1">
//                                 {lead.name || "—"}
//                               </div>
//                               <div className="flex flex-wrap items-center gap-1 mb-1">
//                                 <span
//                                   className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] font-bold"
//                                   style={{ background: ch.bg, color: ch.color }}
//                                 >
//                                   <span className="text-xs">{ch.icon}</span>
//                                   <span>{lead.channel}</span>
//                                 </span>
//                                 {lead.tag && (
//                                   <span
//                                     className="px-1.5 py-0.5 rounded-full text-[10px] font-bold"
//                                     style={{
//                                       background:
//                                         (TAG_COLORS[lead.tag] || "#999") + "18",
//                                       color: TAG_COLORS[lead.tag] || "#999",
//                                     }}
//                                   >
//                                     {lead.tag}
//                                   </span>
//                                 )}
//                                 {isAllLeadsView && isMetaLead && (
//                                   <span className="px-1.5 py-0.5 rounded-full text-[10px] font-bold bg-amber-100 text-amber-600">
//                                     Unprocessed
//                                   </span>
//                                 )}
//                               </div>
//                               {lead.phone && (
//                                 <div className="inline-flex items-center gap-1 text-xs text-gray-500">
//                                   <FaPhone />
//                                   <span>{lead.phone}</span>
//                                 </div>
//                               )}
//                               <br />
//                               {lead.email && (
//                                 <div className="inline-flex items-center gap-1 text-xs text-gray-400">
//                                   <IoMail />
//                                   <span>{lead.email}</span>
//                                 </div>
//                               )}
//                               <br />
//                               <div className="inline-flex items-center gap-1 text-xs text-gray-400 mt-1">
//                                 <IoIosTime />
//                                 <span>{timeAgo(lead.created_at)}</span>
//                               </div>
//                             </td>
//                             <td className="px-4 py-3 max-w-[220px]">
//                               <div className="text-xs text-gray-600 leading-relaxed whitespace-pre-wrap">
//                                 {lead.enquiry
//                                   ? lead.enquiry.split("\n").map((line, i) => {
//                                       const clean = line
//                                         .replace(/^•\s*/, "")
//                                         .trim();
//                                       const parts = clean.split(":");
//                                       const question = parts[0];
//                                       const answer = parts
//                                         .slice(1)
//                                         .join(":")
//                                         .trim();
//                                       return (
//                                         <div key={i} className="mb-2">
//                                           <div>➤ {question}:</div>
//                                           {answer && (
//                                             <div className="ml-3 font-bold text-gray-800">
//                                               ↳ {answer}
//                                             </div>
//                                           )}
//                                         </div>
//                                       );
//                                     })
//                                   : "—"}
//                               </div>
//                             </td>
//                             {isIncomingView ? (
//                               <>
//                                 <td className="px-4 py-3 max-w-[220px]">
//                                   {(lead.field_data || []).length > 0 ? (
//                                     <div className="flex flex-col gap-1">
//                                       {lead.field_data.map((f, fi) => (
//                                         <div
//                                           key={fi}
//                                           className="text-[11px] text-gray-600"
//                                         >
//                                           <span className="text-gray-400 uppercase text-[10px]">
//                                             {f.name.replace(/_/g, " ")}:{" "}
//                                           </span>
//                                           <span className="font-semibold text-gray-700">
//                                             {f.values?.[0] || "—"}
//                                           </span>
//                                         </div>
//                                       ))}
//                                     </div>
//                                   ) : (
//                                     <span className="text-xs text-gray-300">
//                                       —
//                                     </span>
//                                   )}
//                                 </td>
//                                 <td className="px-4 py-3">
//                                   <ProcessMetaLeadButton
//                                     lead={lead}
//                                     onProcessed={handleMetaLeadProcessed}
//                                   />
//                                 </td>
//                               </>
//                             ) : (
//                               <>
//                                 <td className="px-4 py-3">
//                                   {showProcessButton ? (
//                                     <ProcessMetaLeadButton
//                                       lead={lead}
//                                       onProcessed={handleMetaLeadProcessed}
//                                     />
//                                   ) : (
//                                     <select
//                                       value={lead.status || ""}
//                                       onChange={(e) =>
//                                         patchLead(
//                                           lead.id,
//                                           "status",
//                                           e.target.value,
//                                         )
//                                       }
//                                       className="p-1.5 rounded-md text-[11px] font-bold cursor-pointer outline-none border"
//                                       style={{
//                                         borderColor:
//                                           STATUS_COLORS[lead.status] || "#ccc",
//                                         background:
//                                           (STATUS_COLORS[lead.status] ||
//                                             "#ccc") + "18",
//                                         color:
//                                           STATUS_COLORS[lead.status] || "#555",
//                                       }}
//                                     >
//                                       {STATUSES.map((s) => (
//                                         <option key={s} value={s}>
//                                           {s}
//                                         </option>
//                                       ))}
//                                     </select>
//                                   )}
//                                 </td>
//                                 <td className="px-4 py-3">
//                                   {showProcessButton ? (
//                                     <span className="text-xs text-gray-300">
//                                       —
//                                     </span>
//                                   ) : (
//                                     <select
//                                       value={lead.assignee || "Unassigned"}
//                                       onChange={(e) =>
//                                         patchLead(
//                                           lead.id,
//                                           "assignee",
//                                           e.target.value,
//                                         )
//                                       }
//                                       className="p-1.5 rounded-md border border-gray-200 bg-white text-xs cursor-pointer outline-none"
//                                     >
//                                       {TEAM.map((t) => (
//                                         <option key={t}>{t}</option>
//                                       ))}
//                                     </select>
//                                   )}
//                                 </td>
//                                 <td className="px-4 py-3">
//                                   {showProcessButton ? (
//                                     <span className="text-xs text-gray-300">
//                                       —
//                                     </span>
//                                   ) : lead.remark ? (
//                                     <div
//                                       onClick={() => addRemark(lead)}
//                                       title="Click to edit"
//                                       className="text-xs text-gray-600 bg-gray-50 rounded-md px-2 py-1 max-w-[160px] cursor-pointer leading-snug"
//                                     >
//                                       {lead.remark}
//                                     </div>
//                                   ) : (
//                                     <button
//                                       onClick={() => addRemark(lead)}
//                                       className="text-[11px] text-indigo-500 bg-transparent border border-dashed border-indigo-400 rounded-md px-2 py-1 cursor-pointer"
//                                     >
//                                       + Add Remark
//                                     </button>
//                                   )}
//                                 </td>
//                                 <td className="px-4 py-3">
//                                   {showProcessButton ? (
//                                     <span className="text-xs text-gray-300">
//                                       —
//                                     </span>
//                                   ) : (
//                                     <Tooltip
//                                       title={
//                                         lead.created_at
//                                           ? new Date(
//                                               lead.created_at,
//                                             ).toLocaleString()
//                                           : "—"
//                                       }
//                                       placement="left"
//                                     >
//                                       <span className="text-xs">
//                                         {lead.created_at
//                                           ? new Date(
//                                               lead.created_at,
//                                             ).toLocaleDateString()
//                                           : "—"}
//                                       </span>
//                                     </Tooltip>
//                                   )}
//                                 </td>
//                                 <td className="px-4 py-3">
//                                   {!showProcessButton && (
//                                     <div className="flex flex-col gap-1.5">
//                                       <button
//                                         onClick={() => setFollowUpLead(lead)}
//                                         className="bg-[#a19993] text-white border-none rounded-md px-2.5 py-1.5 text-[11px] font-semibold cursor-pointer"
//                                       >
//                                         Follow Up
//                                       </button>
//                                       <button
//                                         onClick={() =>
//                                           setExpandedLead(
//                                             isExpanded ? null : lead.id,
//                                           )
//                                         }
//                                         className="bg-gray-100 text-gray-600 border-none rounded-md px-2.5 py-1.5 text-[11px] cursor-pointer"
//                                       >
//                                         {isExpanded ? "▲ Less" : "▼ Details"}
//                                       </button>
//                                     </div>
//                                   )}
//                                 </td>
//                               </>
//                             )}
//                           </tr>
//                           {!isMetaLead && isExpanded && (
//                             <tr className="bg-gray-50">
//                               <td colSpan={9} className="px-6 py-4">
//                                 <div className="flex gap-7 flex-wrap">
//                                   {[
//                                     ["Lead ID", lead.id],
//                                     ["Meta ID", lead.meta_lead_id || "—"],
//                                     ["Email", lead.email || "—"],
//                                     ["Phone", lead.phone || "—"],
//                                     ["Channel", lead.channel],
//                                     ["Assigned To", lead.assignee || "—"],
//                                     ["Status", lead.status],
//                                     ["Tag", lead.tag || "—"],
//                                     ["Remark", lead.remark || "—"],
//                                     [
//                                       "Received",
//                                       lead.created_at
//                                         ? new Date(
//                                             lead.created_at,
//                                           ).toLocaleString()
//                                         : "—",
//                                     ],
//                                   ].map(([label, val]) => (
//                                     <div key={label} className="min-w-[90px]">
//                                       <div className="text-[10px] text-gray-400 uppercase font-bold mb-0.5">
//                                         {label}
//                                       </div>
//                                       <div
//                                         className="text-sm"
//                                         style={{
//                                           color:
//                                             label === "Status"
//                                               ? STATUS_COLORS[val]
//                                               : "#333",
//                                           fontWeight:
//                                             label === "Status" ? 700 : 400,
//                                         }}
//                                       >
//                                         {String(val)}
//                                       </div>
//                                     </div>
//                                   ))}
//                                 </div>
//                               </td>
//                             </tr>
//                           )}
//                         </React.Fragment>
//                       );
//                     })
//                   )}
//                 </tbody>
//               </table>
//             </div>
//             <nav
//               className="flex items-center flex-col md:flex-row justify-between rounded-b-lg px-2 py-1 bg-[#f7f7f7]"
//               aria-label="Table navigation"
//             >
//               <span className="text-xs font-normal text-gray-500 mb-4 md:mb-0 block w-full md:inline md:w-auto">
//                 Showing{" "}
//                 <span className="font-semibold text-gray-700">
//                   {visibleLeads.length > 0 ? indexOfFirst + 1 : 0}–
//                   {Math.min(indexOfLast, visibleLeads.length)}
//                 </span>{" "}
//                 of{" "}
//                 <span className="font-semibold text-gray-700">
//                   {visibleLeads.length}
//                 </span>
//               </span>
//               <ul className="inline-flex -space-x-px rtl:space-x-reverse text-xs h-8">
//                 <li>
//                   <button
//                     onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
//                     disabled={currentPage === 1}
//                     className="flex items-center justify-center px-1 h-8 leading-tight text-gray-500 bg-[#f7f7f7] border-gray-300 rounded-s-lg hover:bg-gray-100"
//                   >
//                     <MdKeyboardDoubleArrowLeft />
//                   </button>
//                 </li>
//                 {generatePageNumbers().map((page, index) =>
//                   page === "..." ? (
//                     <li
//                       key={index}
//                       className="px-1 h-8 flex items-center justify-center text-gray-500"
//                     >
//                       <span>...</span>
//                     </li>
//                   ) : (
//                     <li key={index}>
//                       <button
//                         onClick={() => setCurrentPage(page)}
//                         className={`flex items-center justify-center px-3 h-8 leading-tight text-gray-500 bg-[#f7f7f7] border-gray-300 hover:bg-gray-100 ${currentPage === page ? "text-green-500 underline underline-offset-2" : ""}`}
//                       >
//                         {page}
//                       </button>
//                     </li>
//                   ),
//                 )}
//                 <li>
//                   <button
//                     onClick={() =>
//                       setCurrentPage((p) => Math.min(p + 1, totalPages))
//                     }
//                     disabled={currentPage === totalPages}
//                     className="flex items-center justify-center px-1 h-8 leading-tight text-gray-500 bg-[#f7f7f7] border-gray-300 rounded-e-lg hover:bg-gray-100"
//                   >
//                     <MdKeyboardDoubleArrowRight />
//                   </button>
//                 </li>
//               </ul>
//             </nav>
//           </div>
//         )}

//         {/* ══════════════════  WEBSITE TABLE  ═══════════════════════════════ */}
//         {storeTab === "website" && (
//           <div className="shadow-md rounded-lg mt-5">
//             <div className="overflow-x-auto">
//               <table className="w-full text-sm text-left text-gray-500">
//                 <thead className="text-xs text-gray-400 uppercase bg-green-50 border-b">
//                   <tr>
//                     {!isWebsiteIncomingView && (
//                       <th className="p-4">
//                         <input
//                           type="checkbox"
//                           onChange={handleSelectAll}
//                           checked={
//                             selectedRows.length === currentLeads.length &&
//                             currentLeads.length > 0
//                           }
//                         />
//                       </th>
//                     )}
//                     <th className="p-4">Lead ID</th>
//                     <th className="p-4">Customer</th>
//                     <th className="p-4">Property / Destination</th>
//                     <th className="p-4">Check-In → Check-Out</th>
//                     <th className="p-4">Location</th>
//                     {isWebsiteIncomingView ? (
//                       <th className="p-4">Action</th>
//                     ) : (
//                       <>
//                         <th className="p-4">Status</th>
//                         <th className="p-4">Assigned To</th>
//                         <th className="p-4">Remark</th>
//                         <th className="p-4">Actions</th>
//                       </>
//                     )}
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {(
//                     isWebsiteIncomingView
//                       ? websiteLoading
//                       : processedWebsiteLoading
//                   ) ? (
//                     <tr>
//                       <td
//                         colSpan={isWebsiteIncomingView ? 7 : 10}
//                         className="text-center py-14 text-gray-400"
//                       >
//                         Loading website leads…
//                       </td>
//                     </tr>
//                   ) : websiteError && isWebsiteIncomingView ? (
//                     <tr>
//                       <td
//                         colSpan={7}
//                         className="text-center py-14 text-red-400"
//                       >
//                         {websiteError}
//                       </td>
//                     </tr>
//                   ) : currentLeads.length === 0 ? (
//                     <tr>
//                       <td
//                         colSpan={isWebsiteIncomingView ? 7 : 10}
//                         className="text-center py-14 text-gray-400"
//                       >
//                         {isWebsiteIncomingView
//                           ? "No new website leads. All incoming leads have been processed."
//                           : "No processed website leads found for this stage."}
//                       </td>
//                     </tr>
//                   ) : isWebsiteIncomingView ? (
//                     // ── Incoming website leads ─────────────────────────────
//                     currentLeads.map((lead, idx) => (
//                       <tr
//                         key={lead.leadId}
//                         className={`border-b border-gray-200 hover:bg-gray-100 text-gray-800 ${idx % 2 === 0 ? "bg-white" : "bg-gray-50"}`}
//                       >
//                         <td className="px-4 py-3 text-xs font-mono text-indigo-600">
//                           {lead.leadId}
//                         </td>
//                         <td className="px-4 py-3 min-w-[160px]">
//                           <div className="font-bold text-gray-800 mb-1">
//                             {lead.customerName || "—"}
//                           </div>
//                           {lead.phone && (
//                             <div className="inline-flex items-center gap-1 text-xs text-gray-500">
//                               <FaPhone />
//                               {lead.phone}
//                             </div>
//                           )}
//                           <br />
//                           {lead.email && (
//                             <div className="inline-flex items-center gap-1 text-xs text-gray-400">
//                               <IoMail />
//                               {lead.email}
//                             </div>
//                           )}
//                         </td>
//                         <td className="px-4 py-3">
//                           <div className="font-semibold text-gray-700 text-xs">
//                             {lead.property || "—"}
//                           </div>
//                           <div className="text-xs text-gray-400 mt-0.5">
//                             {lead.destination || "—"}
//                           </div>
//                         </td>
//                         <td className="px-4 py-3 text-xs text-gray-600 whitespace-nowrap">
//                           <div className="inline-flex items-center gap-1">
//                             <FaCalendarAlt className="text-gray-400" />
//                             {lead.checkin
//                               ? new Date(lead.checkin).toLocaleDateString()
//                               : "—"}
//                             {" → "}
//                             {lead.checkout
//                               ? new Date(lead.checkout).toLocaleDateString()
//                               : "—"}
//                           </div>
//                         </td>
//                         <td className="px-4 py-3 text-xs text-gray-500">
//                           <div className="inline-flex items-center gap-1">
//                             {[lead.city, lead.state, lead.country]
//                               .filter(Boolean)
//                               .join(", ") || "—"}
//                           </div>
//                         </td>
//                         <td className="px-4 py-3">
//                           <ProcessWebsiteLeadButton
//                             lead={lead}
//                             onProcessed={handleWebsiteLeadProcessed}
//                           />
//                         </td>
//                       </tr>
//                     ))
//                   ) : (
//                     // ── Processed / All website leads ──────────────────────
//                     currentLeads.map((lead, idx) => {
//                       const dimmed = updatingId === lead.id;
//                       const isRawIncoming = lead._isIncoming === true;
//                       return (
//                         <tr
//                           key={lead.id || lead.leadId}
//                           className={`border-b border-gray-200 hover:bg-gray-100 text-gray-800 transition-opacity ${idx % 2 === 0 ? "bg-white" : "bg-gray-50"}`}
//                           style={{ opacity: dimmed ? 0.55 : 1 }}
//                         >
//                           <td className="px-4 py-3">
//                             {isRawIncoming ? (
//                               <span className="text-[10px] bg-amber-100 text-amber-600 px-1.5 py-0.5 rounded-full font-bold whitespace-nowrap">
//                                 Unprocessed
//                               </span>
//                             ) : (
//                               <input
//                                 type="checkbox"
//                                 onChange={() =>
//                                   handleRowCheckboxChange(lead.id)
//                                 }
//                                 checked={selectedRows.includes(lead.id)}
//                               />
//                             )}
//                           </td>
//                           <td className="px-4 py-3 text-xs font-mono text-indigo-600">
//                             {isRawIncoming
//                               ? lead.leadId
//                               : `WL-${lead.original_lead_id}`}
//                           </td>
//                           <td className="px-4 py-3 min-w-[160px]">
//                             <div className="font-bold text-gray-800 mb-1">
//                               {isRawIncoming
//                                 ? lead.customerName || "—"
//                                 : lead.customer_name || "—"}
//                             </div>
//                             {lead.phone && (
//                               <div className="inline-flex items-center gap-1 text-xs text-gray-500">
//                                 <FaPhone />
//                                 {lead.phone}
//                               </div>
//                             )}
//                             <br />
//                             {lead.email && (
//                               <div className="inline-flex items-center gap-1 text-xs text-gray-400">
//                                 <IoMail />
//                                 {lead.email}
//                               </div>
//                             )}
//                             {!isRawIncoming && lead.converted === 1 && (
//                               <div className="mt-1">
//                                 <span className="text-[10px] bg-green-100 text-green-700 px-1.5 py-0.5 rounded-full font-bold">
//                                   ✓ Converted
//                                 </span>
//                               </div>
//                             )}
//                           </td>
//                           <td className="px-4 py-3">
//                             <div className="font-semibold text-gray-700 text-xs">
//                               {lead.property || "—"}
//                             </div>
//                             <div className="text-xs text-gray-400 mt-0.5">
//                               {lead.destination || "—"}
//                             </div>
//                           </td>
//                           <td className="px-4 py-3 text-xs text-gray-600 whitespace-nowrap">
//                             <div className="inline-flex items-center gap-1">
//                               <FaCalendarAlt className="text-gray-400" />
//                               {isRawIncoming
//                                 ? lead.checkin
//                                   ? new Date(lead.checkin).toLocaleDateString()
//                                   : "—"
//                                 : lead.check_in
//                                   ? new Date(lead.check_in).toLocaleDateString()
//                                   : "—"}
//                               {" → "}
//                               {isRawIncoming
//                                 ? lead.checkout
//                                   ? new Date(lead.checkout).toLocaleDateString()
//                                   : "—"
//                                 : lead.check_out
//                                   ? new Date(
//                                       lead.check_out,
//                                     ).toLocaleDateString()
//                                   : "—"}
//                             </div>
//                           </td>
//                           <td className="px-4 py-3 text-xs text-gray-500">
//                             <div className="inline-flex items-center gap-1">
//                               {[lead.city, lead.state, lead.country]
//                                 .filter(Boolean)
//                                 .join(", ") || "—"}
//                             </div>
//                           </td>
//                           <td className="px-4 py-3">
//                             {isRawIncoming ? (
//                               <ProcessWebsiteLeadButton
//                                 lead={lead}
//                                 onProcessed={handleWebsiteLeadProcessed}
//                               />
//                             ) : (
//                               <select
//                                 value={lead.status || "New Lead"}
//                                 onChange={(e) =>
//                                   patchWebsiteLead(
//                                     lead.id,
//                                     "status",
//                                     e.target.value,
//                                   )
//                                 }
//                                 className="p-1.5 rounded-md text-[11px] font-bold cursor-pointer outline-none border"
//                                 style={{
//                                   borderColor:
//                                     WEBSITE_STATUS_COLORS[lead.status] ||
//                                     "#ccc",
//                                   background:
//                                     (WEBSITE_STATUS_COLORS[lead.status] ||
//                                       "#ccc") + "18",
//                                   color:
//                                     WEBSITE_STATUS_COLORS[lead.status] ||
//                                     "#555",
//                                 }}
//                               >
//                                 {WEBSITE_STATUSES.map((s) => (
//                                   <option key={s} value={s}>
//                                     {s}
//                                   </option>
//                                 ))}
//                               </select>
//                             )}
//                           </td>
//                           <td className="px-4 py-3">
//                             {isRawIncoming ? (
//                               <span className="text-xs text-gray-300">—</span>
//                             ) : (
//                               <select
//                                 value={lead.assignee || "Unassigned"}
//                                 onChange={(e) =>
//                                   patchWebsiteLead(
//                                     lead.id,
//                                     "assignee",
//                                     e.target.value,
//                                   )
//                                 }
//                                 className="p-1.5 rounded-md border border-gray-200 bg-white text-xs cursor-pointer outline-none"
//                               >
//                                 {TEAM.map((t) => (
//                                   <option key={t}>{t}</option>
//                                 ))}
//                               </select>
//                             )}
//                           </td>
//                           <td className="px-4 py-3">
//                             {isRawIncoming ? (
//                               <span className="text-xs text-gray-300">—</span>
//                             ) : lead.remark ? (
//                               <div
//                                 onClick={() => addWebsiteRemark(lead)}
//                                 title="Click to edit"
//                                 className="text-xs text-gray-600 bg-gray-50 rounded-md px-2 py-1 max-w-[160px] cursor-pointer leading-snug"
//                               >
//                                 {lead.remark}
//                               </div>
//                             ) : (
//                               <button
//                                 onClick={() => addWebsiteRemark(lead)}
//                                 className="text-[11px] text-indigo-500 bg-transparent border border-dashed border-indigo-400 rounded-md px-2 py-1 cursor-pointer"
//                               >
//                                 + Add Remark
//                               </button>
//                             )}
//                           </td>
//                           <td className="px-4 py-3">
//                             {isRawIncoming ? (
//                               <span className="text-xs text-gray-300">—</span>
//                             ) : (
//                               <button
//                                 onClick={() =>
//                                   setFollowUpLead({
//                                     ...lead,
//                                     name: lead.customer_name,
//                                   })
//                                 }
//                                 className="bg-[#a19993] text-white border-none rounded-md px-2.5 py-1.5 text-[11px] font-semibold cursor-pointer w-20"
//                               >
//                                 Follow Up
//                               </button>
//                             )}
//                           </td>
//                         </tr>
//                       );
//                     })
//                   )}
//                 </tbody>
//               </table>
//             </div>
//             <nav className="flex items-center flex-col md:flex-row justify-between rounded-b-lg px-2 py-1 bg-[#f7f7f7]">
//               <span className="text-xs font-normal text-gray-500 mb-4 md:mb-0 block w-full md:inline md:w-auto">
//                 Showing{" "}
//                 <span className="font-semibold text-gray-700">
//                   {visibleWebsiteLeads.length > 0 ? indexOfFirst + 1 : 0}–
//                   {Math.min(indexOfLast, visibleWebsiteLeads.length)}
//                 </span>{" "}
//                 of{" "}
//                 <span className="font-semibold text-gray-700">
//                   {visibleWebsiteLeads.length}
//                 </span>
//               </span>
//               <ul className="inline-flex -space-x-px rtl:space-x-reverse text-xs h-8">
//                 <li>
//                   <button
//                     onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
//                     disabled={currentPage === 1}
//                     className="flex items-center justify-center px-1 h-8 leading-tight text-gray-500 bg-[#f7f7f7] border-gray-300 rounded-s-lg hover:bg-gray-100"
//                   >
//                     <MdKeyboardDoubleArrowLeft />
//                   </button>
//                 </li>
//                 {generatePageNumbers().map((page, index) =>
//                   page === "..." ? (
//                     <li
//                       key={index}
//                       className="px-1 h-8 flex items-center justify-center text-gray-500"
//                     >
//                       <span>...</span>
//                     </li>
//                   ) : (
//                     <li key={index}>
//                       <button
//                         onClick={() => setCurrentPage(page)}
//                         className={`flex items-center justify-center px-3 h-8 leading-tight text-gray-500 bg-[#f7f7f7] border-gray-300 hover:bg-gray-100 ${currentPage === page ? "text-green-500 underline underline-offset-2" : ""}`}
//                       >
//                         {page}
//                       </button>
//                     </li>
//                   ),
//                 )}
//                 <li>
//                   <button
//                     onClick={() =>
//                       setCurrentPage((p) => Math.min(p + 1, totalPages))
//                     }
//                     disabled={currentPage === totalPages}
//                     className="flex items-center justify-center px-1 h-8 leading-tight text-gray-500 bg-[#f7f7f7] border-gray-300 rounded-e-lg hover:bg-gray-100"
//                   >
//                     <MdKeyboardDoubleArrowRight />
//                   </button>
//                 </li>
//               </ul>
//             </nav>
//           </div>
//         )}
//       </main>

//       {followUpLead && (
//         <FollowUpModal
//           lead={followUpLead}
//           onClose={() => setFollowUpLead(null)}
//         />
//       )}
//       {showCreate && (
//         <CreateLeadModal
//           onClose={() => setShowCreate(false)}
//           onCreated={handleCreated}
//         />
//       )}

//       {/* ── Convert Confirm Modal ───────────────────────────────────────────── */}
//       {showConvertModal && (
//         <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
//           <div className="bg-white rounded-2xl p-7 w-[420px] shadow-2xl">
//             <div className="font-bold text-base mb-2 text-gray-800">
//               Convert to Booking
//             </div>
//             <p className="text-sm text-gray-500 mb-4">
//               Convert{" "}
//               <b className="text-gray-800">
//                 {selectedRows.length} lead{selectedRows.length > 1 ? "s" : ""}
//               </b>{" "}
//               to booking{selectedRows.length > 1 ? "s" : ""}?
//             </p>
//             <p className="text-xs text-amber-600 mb-4">
//               {storeTab === "website"
//                 ? "These website leads will be marked as converted and inserted into bookings."
//                 : "The leads will be removed from the leads table and inserted into bookings."}
//             </p>
//             <div className="bg-gray-50 rounded-lg px-3 py-2 mb-5 max-h-36 overflow-y-auto">
//               {storeTab === "meta"
//                 ? leads
//                     .filter((l) => selectedRows.includes(l.id))
//                     .map((l) => (
//                       <div
//                         key={l.id}
//                         className="flex items-center justify-between py-1 border-b border-gray-100 last:border-0"
//                       >
//                         <span className="text-xs font-semibold text-gray-700">
//                           {l.name || "—"}
//                         </span>
//                         <span className="text-[11px] text-gray-400">
//                           {channelToSource(l.channel)}
//                         </span>
//                       </div>
//                     ))
//                 : processedWebsiteLeads
//                     .filter((l) => selectedRows.includes(l.id))
//                     .map((l) => (
//                       <div
//                         key={l.id}
//                         className="flex items-center justify-between py-1 border-b border-gray-100 last:border-0"
//                       >
//                         <span className="text-xs font-semibold text-gray-700">
//                           {l.customer_name || "—"}
//                         </span>
//                         <span className="text-[11px] text-gray-400">
//                           {l.property || "Website"}
//                         </span>
//                       </div>
//                     ))}
//             </div>
//             <div className="flex gap-3">
//               <button
//                 onClick={() => setShowConvertModal(false)}
//                 disabled={converting}
//                 className="flex-1 py-2.5 rounded-lg border border-gray-200 bg-white text-gray-500 font-semibold text-sm cursor-pointer"
//               >
//                 Cancel
//               </button>
//               <button
//                 onClick={async () => {
//                   setShowConvertModal(false);
//                   storeTab === "meta"
//                     ? await handleConvertToBooking()
//                     : await handleWebsiteConvertToBooking();
//                 }}
//                 disabled={converting}
//                 className="flex-1 py-2.5 rounded-lg bg-[#1D2826] text-white font-bold text-sm cursor-pointer hover:bg-[#2d3d3a] transition-colors"
//               >
//                 {converting ? "Converting…" : "Yes, Convert"}
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* ── Convert Result Modal ────────────────────────────────────────────── */}
//       {convertResult && (
//         <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
//           <div className="bg-white rounded-2xl p-7 w-[420px] shadow-2xl">
//             {convertResult.errors.length === 0 ? (
//               <>
//                 <div className="text-center mb-4">
//                   <div className="text-4xl mb-2"></div>
//                   <div className="font-bold text-base text-gray-800">
//                     {convertResult.bookingids.length} Booking
//                     {convertResult.bookingids.length > 1 ? "s" : ""} Created
//                   </div>
//                   <p className="text-xs text-gray-400 mt-1">
//                     Successfully converted to bookings
//                   </p>
//                 </div>
//                 <div className="bg-green-50 rounded-lg px-3 py-2 mb-5">
//                   {convertResult.bookingids.map((bid, i) => (
//                     <div
//                       key={i}
//                       className="text-xs text-green-700 font-semibold py-0.5"
//                     >
//                       Booking ID: <span className="font-bold">{bid}</span>
//                     </div>
//                   ))}
//                 </div>
//               </>
//             ) : (
//               <>
//                 <div className="text-center mb-4">
//                   <div className="text-4xl mb-2"></div>
//                   <div className="font-bold text-base text-gray-800">
//                     Partial Conversion
//                   </div>
//                   <p className="text-xs text-gray-400 mt-1">
//                     {convertResult.bookingids.length} succeeded ·{" "}
//                     {convertResult.errors.length} failed
//                   </p>
//                 </div>
//                 {convertResult.bookingids.length > 0 && (
//                   <div className="bg-green-50 rounded-lg px-3 py-2 mb-3">
//                     <p className="text-[10px] text-green-600 font-bold uppercase mb-1">
//                       Created
//                     </p>
//                     {convertResult.bookingids.map((bid, i) => (
//                       <div key={i} className="text-xs text-green-700">
//                         Booking ID: <b>{bid}</b>
//                       </div>
//                     ))}
//                   </div>
//                 )}
//                 <div className="bg-red-50 rounded-lg px-3 py-2 mb-5">
//                   <p className="text-[10px] text-red-500 font-bold uppercase mb-1">
//                     Failed
//                   </p>
//                   {convertResult.errors.map((e, i) => (
//                     <div key={i} className="text-xs text-red-600">
//                       <b>{e.name || e.id}</b>: {e.error}
//                     </div>
//                   ))}
//                 </div>
//               </>
//             )}
//             <button
//               onClick={() => setConvertResult(null)}
//               className="w-full py-2.5 rounded-lg bg-[#1D2826] text-white font-bold text-sm cursor-pointer"
//             >
//               Done
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default InquireLeads;
